import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toast } from "sonner";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { LogOut, Users, Edit, Trash2, CheckCircle, XCircle, IndianRupee, Eye, Award, UserPlus, Clock, Trophy, Upload, FileText, BookOpen, Calendar, CalendarDays, Image, Phone, Mail, FileCheck, HelpCircle, GraduationCap, Plus } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const courses = [
  { id: "course1", name: "Only Makeup", fees: 28000, duration: "30 days" },
  { id: "course2", name: "Makeup & Hair", fees: 30000, duration: "45 days" },
  { id: "course3", name: "Makeup, Hair, Nails or Draping", fees: 35000, duration: "60 days" },
  { id: "course4", name: "Makeup, Hair, Nails & Draping", fees: 39500, duration: "60 days" }
];

const SCORE_PARAMS = ["personality", "communication", "punctuality", "eager_to_learn", "work_results"];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("students");
  const [students, setStudents] = useState([]);
  const [scoresheet, setScoresheet] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [teacherAttendance, setTeacherAttendance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editDialog, setEditDialog] = useState(false);
  const [viewDialog, setViewDialog] = useState(false);
  const [createTeacherDialog, setCreateTeacherDialog] = useState(false);
  const [editTeacherDialog, setEditTeacherDialog] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [editForm, setEditForm] = useState({
    name: "",
    mobile: "",
    emergency_contact: "",
    address: "",
    course_id: "",
    course3_choice: "",
    batch_number: "",
    batch_start_date: "",
    registration_paid: false,
    full_fees_paid: false,
    is_active: true
  });
  const [newTeacher, setNewTeacher] = useState({
    name: "",
    teacher_id: "",
    password: "",
    mobile: "",
    roles: []
  });
  const [editTeacherForm, setEditTeacherForm] = useState({
    name: "",
    mobile: "",
    password: "",
    roles: []
  });
  const [uploadDialog, setUploadDialog] = useState(false);
  const [uploadType, setUploadType] = useState("book"); // "book", "notes", "schedule"
  const [allBooks, setAllBooks] = useState([]);
  const [editBookDialog, setEditBookDialog] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);
  const [editBookForm, setEditBookForm] = useState({
    title: "",
    course_id: "",
    file_type: "book"
  });
  const [uploadForm, setUploadForm] = useState({
    title: "",
    course_id: "",
    batch_name: "",
    batch_date: "",
    file: null
  });
  const [mentorDialog, setMentorDialog] = useState(false);
  const [mentorForm, setMentorForm] = useState({
    mentor_name: "",
    mentor_whatsapp: ""
  });
  const [makeupTeachers, setMakeupTeachers] = useState([]);
  const [paymentManageDialog, setPaymentManageDialog] = useState(false);
  const [studentPayments, setStudentPayments] = useState([]);
  const [newPayment, setNewPayment] = useState({
    amount: "",
    payment_method: "cash",
    date: new Date().toISOString().split('T')[0]
  });
  const [editPaymentDialog, setEditPaymentDialog] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [scheduleDialog, setScheduleDialog] = useState(false);
  const [selectedBatchForSchedule, setSelectedBatchForSchedule] = useState("");
  const [selectedCourseForSchedule, setSelectedCourseForSchedule] = useState("");
  const [batchSchedules, setBatchSchedules] = useState([]);
  const [newScheduleEntry, setNewScheduleEntry] = useState({
    date: "",
    topic: "",
    course_id: ""
  });
  const [addStudentDialog, setAddStudentDialog] = useState(false);
  const [newStudentForm, setNewStudentForm] = useState({
    name: "",
    mobile: "",
    emergency_contact: "",
    address: "",
    course_id: "",
    course3_choice: "",
    batch_number: "",
    is_active: true
  });
  const [selectedBatchView, setSelectedBatchView] = useState(null);
  const [priceListHeadings, setPriceListHeadings] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [editingHeading, setEditingHeading] = useState(null);
  const [brideStories, setBrideStories] = useState([]);
  const [editingStory, setEditingStory] = useState(null);
  const [heroImages, setHeroImages] = useState([]);
  const [editingHeroImage, setEditingHeroImage] = useState(null);
  const [inspiringVideo, setInspiringVideo] = useState(null);
  const [lastBrides, setLastBrides] = useState([]);
  const [editingLastBride, setEditingLastBride] = useState(null);
  
  // Portfolio Management States
  const [portfolioItems, setPortfolioItems] = useState({});
  const [selectedPortfolioPage, setSelectedPortfolioPage] = useState("class-videos");
  const [portfolioUploadForm, setPortfolioUploadForm] = useState({
    media_type: "image",
    url: "",
    thumbnail: "",
    category: ""
  });
  const [batchStudents, setBatchStudents] = useState([]);
  const [teacherAttendanceDialog, setTeacherAttendanceDialog] = useState(false);
  const [selectedTeacherAttendance, setSelectedTeacherAttendance] = useState([]);
  const [selectedTeacherForAttendance, setSelectedTeacherForAttendance] = useState(null);
  
  // Homepage Management States
  const [hpHeroContent, setHpHeroContent] = useState({ video_base64: "", image_base64: "" });
  const [hpGalleryVideos, setHpGalleryVideos] = useState([]);
  const [hpReviewVideos, setHpReviewVideos] = useState([]);
  const [hpCoursePromoVideo, setHpCoursePromoVideo] = useState("");
  const [hpClassVideos, setHpClassVideos] = useState([]);
  const [hpBatchImages, setHpBatchImages] = useState([]);
  const [editingReviewName, setEditingReviewName] = useState(null);
  const [editingClassTitle, setEditingClassTitle] = useState(null);
  const [editingBatchTitle, setEditingBatchTitle] = useState(null);
  
  // Course-specific videos state
  const [courseVideos, setCourseVideos] = useState({
    course1: "", // Only Makeup
    course2: "", // Makeup & Hair
    course3: "", // Makeup, Hair, Nails or Draping
    course4: ""  // Makeup, Hair, Nails & Draping
  });
  
  // Footer & Section States
  const [footerContent, setFooterContent] = useState({
    title: "MUAS Academy",
    subtitle: "Ranchi's Premier Makeup & Beauty Training Institute",
    phone: "9773682082",
    whatsapp: "919773682082",
    instagram: "https://www.instagram.com/aradhanashreyamakeup",
    address: "C-127, Harmu Housing Colony, Harmu Ranchi 834002",
    copyright: "© 2025 MUAS Academy. All rights reserved."
  });
  const [aradhanaSection, setAradhanaSection] = useState({
    title: "Meet Your Mentors",
    subtitle: "Learn from the best in the industry",
    description: "",
    pictures: []
  });
  const [homepageSections, setHomepageSections] = useState({
    class_videos_image: "",
    bride_portfolio_image: "",
    model_portfolio_image: ""
  });
  
  // New Bridal Sections States
  const [inspiringBrideLooks, setInspiringBrideLooks] = useState([]);
  const [editingLook, setEditingLook] = useState(null);
  const [makeupProcessVideo, setMakeupProcessVideo] = useState(null);
  const [makeupProcessAccordion, setMakeupProcessAccordion] = useState([]);
  const [artistImages, setArtistImages] = useState([]);
  const [artistBio, setArtistBio] = useState({ intro: "", outro: "" });
  
  // Content Management States
  const [contentDialog, setContentDialog] = useState(false);
  const [contentType, setContentType] = useState(""); // "banners", "contact", "policy", "faqs", "courses"
  const [policyType, setPolicyType] = useState("terms"); // "terms", "privacy", "refund"
  const [contentForm, setContentForm] = useState({
    bannerImages: [],
    phone: "",
    email: "",
    address: "",
    whatsapp: "",
    policyContent: "",
    faqs: [],
    courseDetails: {
      course_id: "",
      name: "",
      duration: "",
      fees: "",
      description: ""
    }
  });
  
  // Extra Work Management States
  const [extraWorkDialog, setExtraWorkDialog] = useState(false);
  const [allotWorkDialog, setAllotWorkDialog] = useState(false);
  const [editAllotedWorkDialog, setEditAllotedWorkDialog] = useState(false);
  const [pendingExtraWork, setPendingExtraWork] = useState([]);
  const [allExtraWork, setAllExtraWork] = useState([]);
  const [selectedWork, setSelectedWork] = useState(null);
  const [approvalAmount, setApprovalAmount] = useState("");
  const [allotWorkForm, setAllotWorkForm] = useState({
    teacher_id: "",
    date: "",
    client_name: "",
    location: "",
    service: "",
    vanity_type: "Studio Vanity",
    qty: 1,
    at_studio: false,
    at_venue: false,
    price: "",
    artist_earning: ""
  });
  const [customServices, setCustomServices] = useState([
    "Bridal Makeup",
    "Party Makeup",
    "Engagement Makeup",
    "Pre-Wedding Shoot",
    "Hair Styling",
    "Saree Draping",
    "Mehndi"
  ]);
  const [newServiceName, setNewServiceName] = useState("");
  const [paymentDialog, setPaymentDialog] = useState(false);
  const [paymentForm, setPaymentForm] = useState({
    payment_date: new Date().toISOString().split('T')[0],
    pay_type: "CASH"
  });
  
  // Daily Task Management States
  const [allTasks, setAllTasks] = useState([]);
  const [taskManagementDialog, setTaskManagementDialog] = useState(false);
  const [editTaskDialog, setEditTaskDialog] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  
  // Daily Marks Management States
  const [selectedBatchForMarks, setSelectedBatchForMarks] = useState("");
  const [selectedStudentForMarks, setSelectedStudentForMarks] = useState(null);
  const [studentScores, setStudentScores] = useState([]);
  const [scoresDialog, setScoresDialog] = useState(false);
  const [editScoreDialog, setEditScoreDialog] = useState(false);
  const [addScoreDialog, setAddScoreDialog] = useState(false);
  const [selectedScore, setSelectedScore] = useState(null);
  const [scoreForm, setScoreForm] = useState({
    date: new Date().toISOString().split('T')[0],
    personality: 5,
    communication: 5,
    punctuality: 5,
    eager_to_learn: 5,
    work_results: 5,
    is_absent: false
  });
  const [taskSubmissionsDialog, setTaskSubmissionsDialog] = useState(false);
  const [taskSubmissions, setTaskSubmissions] = useState([]);
  const [editTaskForm, setEditTaskForm] = useState({
    task_id: "",
    course_type: "",
    due_date: "",
    task_description: ""
  });
  
  // Practice Kit Management States
  const [allKits, setAllKits] = useState([]);
  const [editKitDialog, setEditKitDialog] = useState(false);
  const [selectedKit, setSelectedKit] = useState(null);
  const [kitImageDialog, setKitImageDialog] = useState(false);
  const [editKitForm, setEditKitForm] = useState({
    kit_name: "",
    issue_date: "",
    is_returned: false,
    return_date: ""
  });

  useEffect(() => {
    const isAdmin = localStorage.getItem("admin");
    if (!isAdmin) {
      navigate("/");
      return;
    }
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      await Promise.all([
        fetchStudents(),
        fetchScoresheet(),
        fetchTeachers(),
        fetchTeacherAttendance(),
        loadAllBooks(),
        fetchAradhanaSection(),
        fetchHomepageSections()
      ]);
    } catch (error) {
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };
  
  const fetchAradhanaSection = async () => {
    try {
      const res = await axios.get(`${API}/aradhana-section`);
      // Merge with defaults to ensure all fields exist
      setAradhanaSection({
        title: res.data.title || "Meet Your Mentors",
        subtitle: res.data.subtitle || "Learn from the best in the industry",
        description: res.data.description || "",
        pictures: res.data.pictures || []
      });
    } catch (error) {
      console.error("Failed to fetch Aradhana section");
    }
  };
  
  const fetchHomepageSections = async () => {
    try {
      const res = await axios.get(`${API}/homepage-sections`);
      setHomepageSections({
        class_videos_image: res.data.class_videos_image || "",
        bride_portfolio_image: res.data.bride_portfolio_image || "",
        model_portfolio_image: res.data.model_portfolio_image || ""
      });
    } catch (error) {
      console.error("Failed to fetch homepage sections");
    }
  };

  const fetchStudents = async () => {
    try {
      const response = await axios.get(`${API}/admin/students`);
      setStudents(response.data.students);
    } catch (error) {
      console.error("Failed to fetch students");
    }
  };

  const fetchScoresheet = async () => {
    try {
      const response = await axios.get(`${API}/admin/scoresheet`);
      setScoresheet(response.data.students);
    } catch (error) {
      console.error("Failed to fetch scoresheet");
    }
  };

  const fetchTeachers = async () => {
    try {
      const response = await axios.get(`${API}/admin/teachers`);
      // Ensure all teachers have roles array
      const teachersWithRoles = response.data.teachers.map(teacher => ({
        ...teacher,
        roles: teacher.roles || []
      }));
      setTeachers(teachersWithRoles);
    } catch (error) {
      console.error("Failed to fetch teachers");
    }
  };

  const fetchTeacherAttendance = async () => {
    try {
      const response = await axios.get(`${API}/admin/teacher-attendance`);
      setTeacherAttendance(response.data.attendance);
    } catch (error) {
      console.error("Failed to fetch teacher attendance");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("admin");
    navigate("/");
  };

  const openEditDialog = (student) => {
    setSelectedStudent(student);
    setEditForm({
      name: student.name,
      mobile: student.mobile,
      emergency_contact: student.emergency_contact || "",
      address: student.address || "",
      course_id: student.course_id,
      course3_choice: student.course3_choice || "",
      batch_number: student.batch_number || "",
      batch_start_date: student.batch_start_date || "",
      registration_paid: student.registration_paid,
      full_fees_paid: student.full_fees_paid,
      is_active: student.is_active !== false  // Default to true if not set
    });
    setEditDialog(true);
  };

  const openEditTeacher = (teacher) => {
    setSelectedTeacher(teacher);
    setEditTeacherForm({
      name: teacher.name,
      mobile: teacher.mobile,
      password: "",
      roles: teacher.roles || []
    });
    setEditTeacherDialog(true);
  };

  const openViewDialog = (student) => {
    setSelectedStudent(student);
    setViewDialog(true);
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`${API}/admin/student/${selectedStudent.id}`, editForm);
      toast.success("Student updated successfully");
      setEditDialog(false);
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update student");
    }
  };

  const handleDelete = async (studentId) => {
    if (!window.confirm("Are you sure you want to delete this student?")) {
      return;
    }
    
    try {
      await axios.delete(`${API}/admin/student/${studentId}`);
      toast.success("Student deleted successfully");
      fetchData();
    } catch (error) {
      toast.error("Failed to delete student");
    }
  };

  const handleCreateTeacher = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/admin/teacher`, newTeacher);
      toast.success("Teacher created successfully");
      setCreateTeacherDialog(false);
      setNewTeacher({ name: "", teacher_id: "", password: "", mobile: "" });
      fetchTeachers();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to create teacher");
    }
  };

  const handleUpdateTeacher = async () => {
    try {
      const updateData = {
        name: editTeacherForm.name,
        mobile: editTeacherForm.mobile
      };
      if (editTeacherForm.password) {
        updateData.password = editTeacherForm.password;
      }
      
      await axios.put(`${API}/admin/teacher/${selectedTeacher.id}`, updateData);
      toast.success("Teacher updated successfully");
      setEditTeacherDialog(false);
      fetchTeachers();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update teacher");
    }
  };

  const handleDeleteTeacher = async (teacherId) => {
    if (!window.confirm("Are you sure you want to delete this teacher?")) {
      return;
    }
    
    try {
      await axios.delete(`${API}/admin/teacher/${teacherId}`);
      toast.success("Teacher deleted successfully");
      fetchTeachers();
    } catch (error) {
      toast.error("Failed to delete teacher");
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleUploadContent = async () => {
    try {
      if (uploadType === "schedule") {
        // Upload batch schedule
        if (!uploadForm.course_id || !uploadForm.batch_name || !uploadForm.batch_date) {
          toast.error("Please fill all schedule fields");
          return;
        }
        await axios.post(`${API}/admin/batch-schedule`, {
          course_id: uploadForm.course_id,
          batch_name: uploadForm.batch_name,
          batch_date: uploadForm.batch_date
        });
        toast.success("Batch schedule created successfully");
      } else {
        // Upload book/notes
        if (!uploadForm.title || !uploadForm.course_id || !uploadForm.file) {
          toast.error("Please fill all fields and select a file");
          return;
        }
        
        // Check file size (limit to 5MB for original file)
        const maxFileSize = 5 * 1024 * 1024; // 5MB
        if (uploadForm.file.size > maxFileSize) {
          toast.error(`File too large! Maximum size is 5MB. Your file: ${(uploadForm.file.size / (1024 * 1024)).toFixed(2)}MB`);
          return;
        }
        
        const base64 = await convertToBase64(uploadForm.file);
        await axios.post(`${API}/admin/upload-book`, {
          title: uploadForm.title,
          course_id: uploadForm.course_id,
          file_base64: base64,
          file_type: uploadType
        });
        toast.success(`${uploadType === "book" ? "Book" : "Notes"} uploaded successfully`);
      }
      
      setUploadDialog(false);
      setUploadForm({
        title: "",
        course_id: "",
        batch_name: "",
        batch_date: "",
        file: null
      });
    } catch (error) {
      toast.error(error.response?.data?.detail || "Upload failed");
    }
  };

  const handleSaveContent = async () => {
    try {
      if (contentType === "banners") {
        // Handle banner images upload
        await axios.post(`${API}/admin/content/homepage-banners`, {
          banner_images: contentForm.bannerImages
        });
        toast.success("Homepage banners updated successfully");
      } else if (contentType === "contact") {
        await axios.post(`${API}/admin/content/contact`, {
          phone: contentForm.phone,
          email: contentForm.email,
          address: contentForm.address,
          whatsapp: contentForm.whatsapp
        });
        toast.success("Contact details updated successfully");
      } else if (contentType === "policy") {
        await axios.post(`${API}/admin/content/policy`, {
          policy_type: policyType,
          content: contentForm.policyContent
        });
        toast.success(`${policyType.charAt(0).toUpperCase() + policyType.slice(1)} policy updated successfully`);
      } else if (contentType === "faqs") {
        await axios.post(`${API}/admin/content/faqs`, contentForm.faqs);
        toast.success("FAQs updated successfully");
      } else if (contentType === "courses") {
        await axios.put(`${API}/admin/content/course`, contentForm.courseDetails);
        toast.success("Course details updated successfully");
      }
      
      setContentDialog(false);
      setContentForm({
        bannerImages: [],
        phone: "",
        email: "",
        address: "",
        whatsapp: "",
        policyContent: "",
        faqs: [],
        courseDetails: {
          course_id: "",
          name: "",
          duration: "",
          fees: "",
          description: ""
        }
      });
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to save content");
    }
  };

  const loadContentData = async (type) => {
    try {
      if (type === "contact") {
        const res = await axios.get(`${API}/content/contact`);
        setContentForm({
          ...contentForm,
          phone: res.data.phone,
          email: res.data.email,
          address: res.data.address,
          whatsapp: res.data.whatsapp
        });
      } else if (type === "policy") {
        const res = await axios.get(`${API}/content/policy/${policyType}`);
        setContentForm({
          ...contentForm,
          policyContent: res.data.content
        });
      } else if (type === "faqs") {
        const res = await axios.get(`${API}/content/faqs`);
        setContentForm({
          ...contentForm,
          faqs: res.data.faqs.length > 0 ? res.data.faqs : [{ question: "", answer: "" }]
        });
      } else if (type === "banners") {
        const res = await axios.get(`${API}/content/homepage-banners`);
        setContentForm({
          ...contentForm,
          bannerImages: res.data.banner_images
        });
      }
    } catch (error) {
      console.error("Failed to load content:", error);
    }
  };

  // Extra Work Management Functions
  const loadPendingExtraWork = async () => {
    try {
      const response = await axios.get(`${API}/admin/extra-work/pending`);
      setPendingExtraWork(response.data.pending_work || []);
    } catch (error) {
      console.error("Failed to load pending extra work:", error);
    }
  };

  const loadAllExtraWork = async () => {
    try {
      const response = await axios.get(`${API}/admin/extra-work/all`);
      setAllExtraWork(response.data.all_work || []);
    } catch (error) {
      console.error("Failed to load all extra work:", error);
    }
  };

  const handleApproveExtraWork = async () => {
    if (!selectedWork || !approvalAmount || isNaN(parseFloat(approvalAmount))) {
      toast.error("Please enter a valid amount");
      return;
    }

    try {
      await axios.put(`${API}/admin/extra-work/${selectedWork.id}/approve`, null, {
        params: { amount: parseFloat(approvalAmount) }
      });

      toast.success("Extra work approved successfully!");
      setSelectedWork(null);
      setApprovalAmount("");
      loadPendingExtraWork();
      loadAllExtraWork();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to approve extra work");
    }
  };

  const handleAllotWork = async () => {
    if (!allotWorkForm.teacher_id || !allotWorkForm.date || !allotWorkForm.client_name || 
        !allotWorkForm.location || !allotWorkForm.service || !allotWorkForm.vanity_type) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      const response = await axios.post(`${API}/admin/extra-work/allot`, allotWorkForm);
      toast.success(`Work allotted! Job ID: #${response.data.job_id}`);
      setAllotWorkDialog(false);
      setAllotWorkForm({
        teacher_id: "",
        date: "",
        client_name: "",
        location: "",
        service: "",
        vanity_type: "Studio Vanity",
        qty: 1,
        at_studio: false,
        at_venue: false,
        price: "",
        artist_earning: ""
      });
      loadAllExtraWork();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to allot work");
    }
  };

  const handleEditAllotedWork = async () => {
    try {
      const updateData = {
        date: allotWorkForm.date,
        client_name: allotWorkForm.client_name,
        location: allotWorkForm.location,
        service: allotWorkForm.service,
        vanity_type: allotWorkForm.vanity_type,
        qty: allotWorkForm.qty,
        at_studio: allotWorkForm.at_studio,
        at_venue: allotWorkForm.at_venue,
        price: parseFloat(allotWorkForm.price) || 0,
        artist_earning: parseFloat(allotWorkForm.artist_earning) || 0
      };
      await axios.put(`${API}/admin/extra-work/${selectedWork.id}/edit`, updateData);
      toast.success("Work updated successfully!");
      setEditAllotedWorkDialog(false);
      loadAllExtraWork();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update work");
    }
  };

  const handleDeleteExtraWork = async (workId) => {
    if (!confirm("Are you sure you want to delete this extra work entry?")) {
      return;
    }

    try {
      await axios.delete(`${API}/admin/extra-work/${workId}`);
      toast.success("Extra work deleted successfully!");
      loadPendingExtraWork();
      loadAllExtraWork();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to delete extra work");
    }
  };

  // Portfolio Management Functions
  const loadPortfolioItems = async (pageType) => {
    try {
      const response = await axios.get(`${API}/portfolio/${pageType}`);
      setPortfolioItems(prev => ({
        ...prev,
        [pageType]: response.data.items || []
      }));
    } catch (error) {
      console.error("Failed to load portfolio items:", error);
    }
  };

  // Daily Task Management Functions
  const loadAllTasks = async () => {
    try {
      const response = await axios.get(`${API}/admin/tasks/all`);
      setAllTasks(response.data.tasks || []);
      setTaskManagementDialog(true);
    } catch (error) {
      console.error("Failed to load all tasks:", error);
      toast.error("Failed to load tasks");
    }
  };

  const handleEditTask = (task) => {
    setSelectedTask(task);
    setEditTaskForm({
      task_id: task.id,
      course_type: task.course_type,
      due_date: task.due_date,
      task_description: task.task_description
    });
    setEditTaskDialog(true);
  };

  const handleUpdateTask = async () => {
    if (!editTaskForm.course_type || !editTaskForm.due_date || !editTaskForm.task_description) {
      toast.error("Please fill all fields");
      return;
    }

    try {
      await axios.put(`${API}/admin/task/${editTaskForm.task_id}/update`, {
        task_id: editTaskForm.task_id,
        course_type: editTaskForm.course_type,
        due_date: editTaskForm.due_date,
        task_description: editTaskForm.task_description
      });

      toast.success("Task updated successfully!");
      setEditTaskDialog(false);
      loadAllTasks(); // Refresh the task list
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update task");
    }
  };

  const handleDeleteTask = async (taskId) => {
    if (!confirm("Are you sure you want to delete this task? This will also delete all related submissions.")) {
      return;
    }

    try {
      await axios.delete(`${API}/admin/task/${taskId}`);
      toast.success("Task deleted successfully!");
      loadAllTasks(); // Refresh the task list
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to delete task");
    }
  };

  const loadTaskSubmissions = async (taskId) => {
    try {
      const response = await axios.get(`${API}/admin/task/${taskId}/submissions`);
      setTaskSubmissions(response.data);
      setTaskSubmissionsDialog(true);
    } catch (error) {
      console.error("Failed to load task submissions:", error);
      toast.error("Failed to load task submissions");
    }
  };

  // Books & Notes Management Functions
  const loadAllBooks = async () => {
    try {
      const response = await axios.get(`${API}/admin/books`);
      setAllBooks(response.data.books || []);
    } catch (error) {
      toast.error("Failed to load books and notes");
    }
  };

  const handleUpdateBook = async () => {
    try {
      await axios.put(`${API}/admin/book/${selectedBook.id}`, {
        title: editBookForm.title,
        course_id: editBookForm.course_id,
        file_type: editBookForm.file_type
      });
      toast.success("Book/Notes updated successfully!");
      setEditBookDialog(false);
      loadAllBooks();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update");
    }
  };

  const handleDeleteBook = async (bookId) => {
    if (!confirm("Are you sure you want to delete this book/notes?")) {
      return;
    }

    try {
      await axios.delete(`${API}/admin/book/${bookId}`);
      toast.success("Book/Notes deleted successfully!");
      loadAllBooks();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to delete");
    }
  };

  // Practice Kit Management Functions
  const loadAllKits = async () => {
    try {
      const response = await axios.get(`${API}/admin/kits`);
      setAllKits(response.data.kits || []);
    } catch (error) {
      console.error("Failed to load practice kits:", error);
      toast.error("Failed to load practice kits");
    }
  };

  const handleEditKit = (kit) => {
    setSelectedKit(kit);
    setEditKitForm({
      kit_name: kit.kit_name,
      issue_date: kit.issue_date,
      is_returned: kit.is_returned,
      return_date: kit.return_date || ""
    });
    setEditKitDialog(true);
  };

  const handleUpdateKit = async () => {
    if (!editKitForm.kit_name || !editKitForm.issue_date) {
      toast.error("Please fill in kit name and issue date");
      return;
    }

    try {
      await axios.put(`${API}/admin/kit/${selectedKit.id}`, {
        kit_name: editKitForm.kit_name,
        issue_date: editKitForm.issue_date,
        is_returned: editKitForm.is_returned,
        return_date: editKitForm.return_date || null
      });
      toast.success("Practice kit updated successfully!");
      setEditKitDialog(false);
      loadAllKits();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update kit");
    }
  };

  const handleDeleteKit = async (kitId) => {
    if (!confirm("Are you sure you want to delete this practice kit record?")) {
      return;
    }

    try {
      await axios.delete(`${API}/admin/kit/${kitId}`);
      toast.success("Practice kit deleted successfully!");
      loadAllKits();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to delete kit");
    }
  };

  const viewKitImage = (kit) => {
    setSelectedKit(kit);
    setKitImageDialog(true);
  };

  // Daily Marks Management Functions
  const loadStudentScores = async (studentId) => {
    try {
      const response = await axios.get(`${API}/student/${studentId}/scores`);
      setStudentScores(response.data.scores || []);
    } catch (error) {
      toast.error("Failed to load scores");
    }
  };

  const handleAddScore = async () => {
    if (!scoreForm.date) {
      toast.error("Please select a date");
      return;
    }

    try {
      await axios.post(`${API}/admin/student/${selectedStudentForMarks.id}/score`, {
        date: scoreForm.date,
        scores: {
          personality: parseFloat(scoreForm.personality),
          communication: parseFloat(scoreForm.communication),
          punctuality: parseFloat(scoreForm.punctuality),
          eager_to_learn: parseFloat(scoreForm.eager_to_learn),
          work_results: parseFloat(scoreForm.work_results)
        },
        is_absent: scoreForm.is_absent
      });

      toast.success("Score added successfully!");
      setAddScoreDialog(false);
      loadStudentScores(selectedStudentForMarks.id);
      fetchStudents(); // Refresh to get updated total
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to add score");
    }
  };

  const handleUpdateScore = async () => {
    try {
      await axios.put(`${API}/admin/score/${selectedScore.id}`, {
        scores: {
          personality: parseFloat(scoreForm.personality),
          communication: parseFloat(scoreForm.communication),
          punctuality: parseFloat(scoreForm.punctuality),
          eager_to_learn: parseFloat(scoreForm.eager_to_learn),
          work_results: parseFloat(scoreForm.work_results)
        },
        is_absent: scoreForm.is_absent
      });

      toast.success("Score updated successfully!");
      setEditScoreDialog(false);
      loadStudentScores(selectedStudentForMarks.id);
      fetchStudents(); // Refresh to get updated total
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update score");
    }
  };

  const handleDeleteScore = async (scoreId) => {
    if (!confirm("Are you sure you want to delete this score?")) {
      return;
    }

    try {
      await axios.delete(`${API}/admin/score/${scoreId}`);
      toast.success("Score deleted successfully!");
      loadStudentScores(selectedStudentForMarks.id);
      fetchStudents(); // Refresh to get updated total
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to delete score");
    }
  };

  const handleUpdateMentor = async () => {
    try {
      if (!mentorForm.mentor_name || !mentorForm.mentor_whatsapp) {
        toast.error("Please fill all mentor fields");
        return;
      }
      await axios.put(`${API}/admin/student/${selectedStudent.id}/mentor`, {
        student_id: selectedStudent.id,
        mentor_name: mentorForm.mentor_name,
        mentor_whatsapp: mentorForm.mentor_whatsapp
      });
      toast.success("Mentor updated successfully");
      setMentorDialog(false);
      fetchStudents();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update mentor");
    }
  };

  const openMentorDialog = async (student) => {
    setSelectedStudent(student);
    setMentorForm({
      mentor_name: student.mentor_name || "",
      mentor_whatsapp: student.mentor_whatsapp || ""
    });
    
    // Fetch all teachers and filter those with "makeup" role
    try {
      const response = await axios.get(`${API}/admin/teachers`);
      const allTeachers = response.data.teachers || [];
      const makeupMentors = allTeachers.filter(teacher => 
        teacher.roles && teacher.roles.includes("makeup")
      );
      setMakeupTeachers(makeupMentors);
    } catch (error) {
      console.error("Failed to fetch teachers:", error);
      toast.error("Failed to load mentor list");
    }
    
    setMentorDialog(true);
  };

  const fetchStudentPayments = async (studentId) => {
    try {
      const response = await axios.get(`${API}/student/${studentId}/payments`);
      setStudentPayments(response.data.payments);
    } catch (error) {
      toast.error("Failed to fetch payments");
    }
  };

  const openPaymentManage = async (student) => {
    setSelectedStudent(student);
    await fetchStudentPayments(student.id);
    setPaymentManageDialog(true);
  };

  const handleAddPayment = async () => {
    try {
      if (!newPayment.amount || parseFloat(newPayment.amount) <= 0) {
        toast.error("Please enter valid amount");
        return;
      }
      await axios.post(`${API}/admin/student/${selectedStudent.id}/add-payment`, {
        amount: parseFloat(newPayment.amount),
        payment_method: newPayment.payment_method,
        date: newPayment.date
      });
      toast.success("Payment added successfully");
      setNewPayment({
        amount: "",
        payment_method: "cash",
        date: new Date().toISOString().split('T')[0]
      });
      await fetchStudentPayments(selectedStudent.id);
      fetchStudents();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to add payment");
    }
  };

  const handleUpdatePayment = async () => {
    try {
      await axios.put(`${API}/admin/payment/${selectedPayment.id}`, {
        amount: parseFloat(selectedPayment.amount),
        payment_method: selectedPayment.payment_method,
        date: selectedPayment.date
      });
      toast.success("Payment updated successfully");
      setEditPaymentDialog(false);
      await fetchStudentPayments(selectedStudent.id);
      fetchStudents();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to update payment");
    }
  };

  const handleDeletePayment = async (paymentId) => {
    if (!window.confirm("Are you sure you want to delete this payment?")) {
      return;
    }
    try {
      await axios.delete(`${API}/admin/payment/${paymentId}`);
      toast.success("Payment deleted successfully");
      await fetchStudentPayments(selectedStudent.id);
      fetchStudents();
    } catch (error) {
      toast.error("Failed to delete payment");
    }
  };

  const openScheduleDialog = async (batch) => {
    setSelectedBatchForSchedule(batch);
    setSelectedCourseForSchedule(""); // Reset course selection
    setScheduleDialog(true);
  };

  const fetchBatchSchedule = async (batch, courseType) => {
    try {
      const response = await axios.get(`${API}/admin/schedule/${batch}`);
      // Filter by course type (makeup, hair, nails, draping)
      const filtered = response.data.schedules.filter(s => {
        if (courseType === "makeup") return s.course_id.includes("course");
        if (courseType === "hair") return ["course2", "course3", "course4"].includes(s.course_id);
        if (courseType === "nails") return ["course3", "course4"].includes(s.course_id);
        if (courseType === "draping") return ["course3", "course4"].includes(s.course_id);
        return true;
      });
      setBatchSchedules(filtered);
    } catch (error) {
      toast.error("Failed to fetch schedule");
    }
  };

  const handleAddScheduleEntry = async () => {
    try {
      if (!newScheduleEntry.date || !newScheduleEntry.topic || !newScheduleEntry.course_id) {
        toast.error("Please fill all fields including course type");
        return;
      }
      
      await axios.post(`${API}/admin/schedule/entry`, {
        batch_number: selectedBatchForSchedule,
        course_id: newScheduleEntry.course_id,
        date: newScheduleEntry.date,
        topic: newScheduleEntry.topic
      });
      
      toast.success("Schedule entry added successfully");
      setNewScheduleEntry({ date: "", topic: "", course_id: newScheduleEntry.course_id });
      if (selectedCourseForSchedule) {
        await fetchBatchSchedule(selectedBatchForSchedule, selectedCourseForSchedule);
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to add schedule entry");
    }
  };

  const handleDeleteScheduleEntry = async (scheduleId) => {
    if (!window.confirm("Are you sure you want to delete this schedule entry?")) {
      return;
    }
    try {
      await axios.delete(`${API}/admin/schedule/${scheduleId}`);
      toast.success("Schedule entry deleted successfully");
      await fetchBatchSchedule(selectedBatchForSchedule);
    } catch (error) {
      toast.error("Failed to delete schedule entry");
    }
  };

  const handleAddStudentManually = async () => {
    try {
      if (!newStudentForm.name || !newStudentForm.mobile || !newStudentForm.course_id) {
        toast.error("Please fill required fields");
        return;
      }
      
      await axios.post(`${API}/admin/student/create`, newStudentForm);
      toast.success("Student added successfully");
      setAddStudentDialog(false);
      setNewStudentForm({
        name: "", mobile: "", emergency_contact: "", address: "",
        course_id: "", course3_choice: "", batch_number: "", is_active: true
      });
      fetchStudents();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to add student");
    }
  };

  const openTeacherAttendanceDialog = async (teacher) => {
    setSelectedTeacherForAttendance(teacher);
    try {
      const response = await axios.get(`${API}/admin/teacher/${teacher.id}/attendance`);
      setSelectedTeacherAttendance(response.data.attendance || []);
      setTeacherAttendanceDialog(true);
    } catch (error) {
      toast.error("Failed to fetch teacher attendance");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-purple-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-indigo-50">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-4xl font-bold text-gray-900">Admin Dashboard</h1>
            <p className="text-gray-600 mt-1">MUAS Academy Management</p>
          </div>
          <Button variant="outline" onClick={handleLogout} data-testid="admin-logout-button">
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-4 gap-6 mb-8">
          <Card className="bg-gradient-to-br from-blue-500 to-blue-600 text-white" data-testid="total-students-card">
            <CardHeader>
              <CardTitle className="text-white flex items-center gap-2">
                <Users className="w-5 h-5" />
                Total Students
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-4xl font-bold">{students.length}</p>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-br from-green-500 to-green-600 text-white" data-testid="registration-paid-card">
            <CardHeader>
              <CardTitle className="text-white">Registration Paid</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-4xl font-bold">
                {students.filter(s => s.registration_paid).length}
              </p>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-br from-purple-500 to-purple-600 text-white" data-testid="full-fees-paid-card">
            <CardHeader>
              <CardTitle className="text-white">Full Fees Paid</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-4xl font-bold">
                {students.filter(s => s.full_fees_paid).length}
              </p>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-br from-orange-500 to-orange-600 text-white" data-testid="teachers-card">
            <CardHeader>
              <CardTitle className="text-white">Teachers</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-4xl font-bold">{teachers.length}</p>
            </CardContent>
          </Card>
        </div>

        {/* Tabs */}
        <Card className="bg-white/90 backdrop-blur-sm">
          <CardContent className="pt-6">
            <Tabs value={activeTab} onValueChange={setActiveTab}>
              <TabsList className="grid w-full grid-cols-9 mb-6">
                <TabsTrigger value="students" data-testid="students-tab">Students</TabsTrigger>
                <TabsTrigger value="teachers" data-testid="teachers-tab">Teachers</TabsTrigger>
                <TabsTrigger value="daily-marks" data-testid="daily-marks-tab">Daily Marks</TabsTrigger>
                <TabsTrigger value="content" data-testid="content-tab">Content Management</TabsTrigger>
                <TabsTrigger value="extra-work" data-testid="extra-work-tab">Extra Work</TabsTrigger>
                <TabsTrigger value="kits" data-testid="kits-tab">Practice Kits</TabsTrigger>
                <TabsTrigger value="homepage" data-testid="homepage-tab">Homepage</TabsTrigger>
                <TabsTrigger value="bridal" data-testid="bridal-tab">Bridal Services</TabsTrigger>
                <TabsTrigger value="portfolio" data-testid="portfolio-tab">Portfolio</TabsTrigger>
              </TabsList>

              {/* Students Tab */}
              <TabsContent value="students">
                <div className="mb-4 flex justify-between items-center">
                  {selectedBatchView && (
                    <Button variant="outline" onClick={() => setSelectedBatchView(null)}>
                      ← Back to Batches
                    </Button>
                  )}
                  <Button onClick={() => setAddStudentDialog(true)} className="bg-green-600 hover:bg-green-700 ml-auto">
                    <UserPlus className="w-4 h-4 mr-2" />
                    Add Student Manually
                  </Button>
                </div>

                {!selectedBatchView ? (
                  /* Batch Selection View */
                  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
                    {[...new Set(students.map(s => s.batch_number).filter(Boolean))].sort().map(batch => {
                      const batchCount = students.filter(s => s.batch_number === batch).length;
                      return (
                        <Card 
                          key={batch}
                          className="border-2 hover:border-blue-500 cursor-pointer transition-all hover:shadow-lg"
                          onClick={() => setSelectedBatchView(batch)}
                        >
                          <CardContent className="p-6 text-center">
                            <Users className="w-8 h-8 mx-auto mb-2 text-blue-600" />
                            <p className="text-2xl font-bold text-blue-600">Batch {batch}</p>
                            <p className="text-sm text-gray-600 mt-1">{batchCount} students</p>
                          </CardContent>
                        </Card>
                      );
                    })}
                    {students.filter(s => !s.batch_number).length > 0 && (
                      <Card 
                        className="border-2 border-orange-300 hover:border-orange-500 cursor-pointer transition-all hover:shadow-lg"
                        onClick={() => setSelectedBatchView("unassigned")}
                      >
                        <CardContent className="p-6 text-center">
                          <Users className="w-8 h-8 mx-auto mb-2 text-orange-600" />
                          <p className="text-2xl font-bold text-orange-600">Unassigned</p>
                          <p className="text-sm text-gray-600 mt-1">
                            {students.filter(s => !s.batch_number).length} students
                          </p>
                        </CardContent>
                      </Card>
                    )}
                  </div>
                ) : (
                  /* Students List View */
                  <div className="overflow-x-auto">
                    <h3 className="text-xl font-bold mb-4">
                      {selectedBatchView === "unassigned" ? "Unassigned Students" : `Batch ${selectedBatchView} Students`}
                    </h3>
                    <table className="w-full">
                      <thead>
                        <tr className="border-b bg-gray-50">
                          <th className="text-left p-3 font-semibold">Name</th>
                          <th className="text-left p-3 font-semibold">Mobile</th>
                          <th className="text-left p-3 font-semibold">Course</th>
                          <th className="text-left p-3 font-semibold">Mentor</th>
                          <th className="text-center p-3 font-semibold">Rank</th>
                          <th className="text-center p-3 font-semibold">Total Score</th>
                          <th className="text-left p-3 font-semibold">Paid</th>
                          <th className="text-left p-3 font-semibold">Balance</th>
                          <th className="text-left p-3 font-semibold">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {students
                          .filter(s => selectedBatchView === "unassigned" ? !s.batch_number : s.batch_number === selectedBatchView)
                          .map((student, idx) => (
                          <tr key={student.id} className={`border-b hover:bg-gray-50 ${student.is_active === false ? 'bg-orange-50' : ''}`}>
                            <td className="p-3">
                              <div className="flex items-center gap-2">
                                {student.name}
                                {student.is_active === false && (
                                  <span className="px-2 py-1 bg-orange-500 text-white text-xs rounded-full">
                                    Inactive
                                  </span>
                                )}
                              </div>
                            </td>
                            <td className="p-3">{student.mobile}</td>
                            <td className="p-3">
                              <div className="flex flex-col">
                                <span className="text-sm">{student.course_name}</span>
                                {student.course_id === "course3" && student.course3_choice && (
                                  <span className="text-xs text-purple-600 font-medium">
                                    {student.course3_choice === "nails" ? "Makeup, Hair & Nails" : "Makeup, Hair & Draping"}
                                  </span>
                                )}
                              </div>
                            </td>
                            <td className="p-3">{student.mentor_name}</td>
                            <td className="p-3 text-center">
                              {student.rank ? (
                                <span className="inline-flex items-center justify-center w-8 h-8 bg-amber-500 text-white rounded-full text-sm font-bold">
                                  #{student.rank}
                                </span>
                              ) : (
                                <span className="text-gray-400">-</span>
                              )}
                            </td>
                            <td className="p-3 text-center">
                              <span className="font-bold text-purple-600 text-lg">
                                {student.total_score || 0}
                              </span>
                            </td>
                            <td className="p-3">
                              <span className="font-semibold text-green-600">
                                ₹{(student.paid_fees || 0).toLocaleString()}
                              </span>
                            </td>
                            <td className="p-3">
                              <span className="font-semibold text-orange-600">
                                ₹{(student.balance_fees || 0).toLocaleString()}
                              </span>
                            </td>
                            <td className="p-3">
                              <div className="flex gap-2">
                                <Button
                                  size="sm"
                                  variant="outline"
                                  onClick={() => openEditDialog(student)}
                                >
                                  <Edit className="w-4 h-4 mr-1" />
                                  Manage
                                </Button>
                                <Button
                                  size="sm"
                                  variant="destructive"
                                  onClick={() => handleDelete(student.id)}
                                >
                                  <Trash2 className="w-4 h-4" />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </TabsContent>

              {/* Scoresheet Tab */}
              {/* Teachers Tab */}
              <TabsContent value="teachers">
                <div className="mb-4">
                  <Button
                    onClick={() => setCreateTeacherDialog(true)}
                    className="gap-2"
                    data-testid="create-teacher-button"
                  >
                    <UserPlus className="w-4 h-4" />
                    Add New Teacher
                  </Button>
                </div>
                
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {teachers.map((teacher, idx) => (
                    <Card key={teacher.id} className="border-2" data-testid={`teacher-card-${idx}`}>
                      <CardHeader>
                        <CardTitle>{teacher.name}</CardTitle>
                      </CardHeader>
                      <CardContent>
                        <div className="space-y-2 text-sm mb-3">
                          <p><strong>ID:</strong> {teacher.teacher_id}</p>
                          <p><strong>Mobile:</strong> {teacher.mobile}</p>
                          {teacher.roles && teacher.roles.length > 0 && (
                            <p><strong>Roles:</strong> {teacher.roles.map(r => r.charAt(0).toUpperCase() + r.slice(1)).join(', ')}</p>
                          )}
                        </div>
                        <div className="flex gap-2">
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => openTeacherAttendanceDialog(teacher)}
                            className="flex-1"
                          >
                            <Clock className="w-4 h-4 mr-1" />
                            Attendance
                          </Button>
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => openEditTeacher(teacher)}
                            data-testid={`edit-teacher-${idx}`}
                          >
                            <Edit className="w-4 h-4" />
                          </Button>
                          <Button
                            size="sm"
                            variant="destructive"
                            onClick={() => handleDeleteTeacher(teacher.id)}
                            data-testid={`delete-teacher-${idx}`}
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
                
                {teachers.length === 0 && (
                  <div className="text-center py-12 text-gray-500">
                    No teachers added yet
                  </div>
                )}
              </TabsContent>

              {/* Teacher Attendance Tab */}
              <TabsContent value="attendance">
                <div className="space-y-3">
                  {teacherAttendance.map((record, idx) => (
                    <Card key={idx} className="border" data-testid={`attendance-record-${idx}`}>
                      <CardContent className="p-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="font-semibold">{record.teacher_name}</p>
                            <p className="text-sm text-gray-600">{record.date}</p>
                          </div>
                          <div className="flex gap-4 text-sm">
                            <div className="text-center">
                              <p className="text-xs text-gray-500">Time In</p>
                              <p className="font-semibold text-green-600">
                                {record.time_in ? new Date(record.time_in).toLocaleTimeString() : "-"}
                              </p>
                            </div>
                            <div className="text-center">
                              <p className="text-xs text-gray-500">Time Out</p>
                              <p className="font-semibold text-red-600">
                                {record.time_out ? new Date(record.time_out).toLocaleTimeString() : "-"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                  
                  {teacherAttendance.length === 0 && (
                    <div className="text-center py-12 text-gray-500">
                      No attendance records yet
                    </div>
                  )}
                </div>
              </TabsContent>

              {/* Content Management Tab */}
              <TabsContent value="content">
                <div className="space-y-6">
                  {/* Books & Notes Upload */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => { setUploadType("book"); setUploadDialog(true); }}>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <BookOpen className="w-5 h-5 text-green-500" />
                          Upload Book
                        </CardTitle>
                      </CardHeader>
                      <CardContent>
                        <p className="text-sm text-gray-600">Upload course books for students</p>
                      </CardContent>
                    </Card>

                    <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => { setUploadType("notes"); setUploadDialog(true); }}>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <FileText className="w-5 h-5 text-purple-500" />
                          Upload Notes
                        </CardTitle>
                      </CardHeader>
                      <CardContent>
                        <p className="text-sm text-gray-600">Upload course notes for students</p>
                      </CardContent>
                    </Card>
                  </div>

                  {/* Uploaded Books & Notes List */}
                  <Card>
                    <CardHeader>
                      <CardTitle>Uploaded Books & Notes</CardTitle>
                      <CardDescription>Manage all uploaded learning materials</CardDescription>
                    </CardHeader>
                    <CardContent>
                      <div className="border rounded-lg overflow-hidden">
                        <table className="w-full text-sm">
                          <thead className="bg-gray-100">
                            <tr>
                              <th className="text-left p-3">Title</th>
                              <th className="text-left p-3">Type</th>
                              <th className="text-left p-3">Course</th>
                              <th className="text-left p-3">Uploaded Date</th>
                              <th className="text-center p-3">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {allBooks.map((book, idx) => (
                              <tr key={idx} className="border-b hover:bg-gray-50">
                                <td className="p-3 font-medium">{book.title}</td>
                                <td className="p-3">
                                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                    book.file_type === 'book' ? 'bg-green-100 text-green-700' : 'bg-purple-100 text-purple-700'
                                  }`}>
                                    {book.file_type === 'book' ? 'Book' : 'Notes'}
                                  </span>
                                </td>
                                <td className="p-3">
                                  {book.course_id === 'course1' && 'Course 1: Makeup'}
                                  {book.course_id === 'course2' && 'Course 2: Makeup & Hair'}
                                  {book.course_id === 'course3' && 'Course 3: Makeup, Hair & Nails/Draping'}
                                  {book.course_id === 'course4' && 'Course 4: Master Course'}
                                </td>
                                <td className="p-3">{new Date(book.created_at).toLocaleDateString()}</td>
                                <td className="text-center p-3">
                                  <div className="flex gap-2 justify-center">
                                    <Button
                                      size="sm"
                                      variant="outline"
                                      onClick={() => {
                                        setSelectedBook(book);
                                        setEditBookForm({
                                          title: book.title,
                                          course_id: book.course_id,
                                          file_type: book.file_type
                                        });
                                        setEditBookDialog(true);
                                      }}
                                    >
                                      <Edit className="w-4 h-4" />
                                    </Button>
                                    <Button
                                      size="sm"
                                      variant="destructive"
                                      onClick={() => handleDeleteBook(book.id)}
                                    >
                                      <Trash2 className="w-4 h-4" />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {allBooks.length === 0 && (
                          <div className="text-center py-8 text-gray-500">
                            No books or notes uploaded yet
                          </div>
                        )}
                      </div>
                    </CardContent>
                  </Card>

                  {/* Homepage & Website Content */}
                  <Card>
                    <CardHeader>
                      <CardTitle>Homepage & Website Management</CardTitle>
                      <CardDescription>Manage banners, contact details, policies, and FAQs</CardDescription>
                    </CardHeader>
                    <CardContent>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => { setContentType("banners"); setContentDialog(true); }}>
                          <CardHeader>
                            <CardTitle className="flex items-center gap-2 text-base">
                              <Image className="w-5 h-5 text-pink-500" />
                              Homepage Banners
                            </CardTitle>
                          </CardHeader>
                          <CardContent>
                            <p className="text-sm text-gray-600">Update hero section images</p>
                          </CardContent>
                        </Card>

                        <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => { setContentType("contact"); setContentDialog(true); }}>
                          <CardHeader>
                            <CardTitle className="flex items-center gap-2 text-base">
                              <Phone className="w-5 h-5 text-blue-500" />
                              Contact Details
                            </CardTitle>
                          </CardHeader>
                          <CardContent>
                            <p className="text-sm text-gray-600">Update phone, email, address</p>
                          </CardContent>
                        </Card>

                        <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => { setContentType("policy"); setContentDialog(true); }}>
                          <CardHeader>
                            <CardTitle className="flex items-center gap-2 text-base">
                              <FileCheck className="w-5 h-5 text-indigo-500" />
                              Policies
                            </CardTitle>
                          </CardHeader>
                          <CardContent>
                            <p className="text-sm text-gray-600">Edit T&C, Privacy, Refund</p>
                          </CardContent>
                        </Card>

                        <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => { setContentType("faqs"); setContentDialog(true); }}>
                          <CardHeader>
                            <CardTitle className="flex items-center gap-2 text-base">
                              <HelpCircle className="w-5 h-5 text-orange-500" />
                              FAQs
                            </CardTitle>
                          </CardHeader>
                          <CardContent>
                            <p className="text-sm text-gray-600">Manage frequently asked questions</p>
                          </CardContent>
                        </Card>

                        <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => { setContentType("courses"); setContentDialog(true); }}>
                          <CardHeader>
                            <CardTitle className="flex items-center gap-2 text-base">
                              <GraduationCap className="w-5 h-5 text-teal-500" />
                              Course Details
                            </CardTitle>
                          </CardHeader>
                          <CardContent>
                            <p className="text-sm text-gray-600">Edit course info & prices</p>
                          </CardContent>
                        </Card>
                      </div>
                    </CardContent>
                  </Card>

                  {/* Daily Task Management */}
                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center gap-2">
                        <CalendarDays className="w-5 h-5 text-purple-500" />
                        Daily Task Management
                      </CardTitle>
                      <CardDescription>View and manage all daily tasks created by teachers</CardDescription>
                    </CardHeader>
                    <CardContent>
                      <Button
                        onClick={loadAllTasks}
                        className="bg-purple-500 hover:bg-purple-600"
                      >
                        <Eye className="w-4 h-4 mr-2" />
                        View All Tasks
                      </Button>
                      <p className="text-sm text-gray-600 mt-2">
                        View, edit, and delete daily tasks created by teachers across all courses
                      </p>
                    </CardContent>
                  </Card>

                  {/* Batch Schedule Management */}
                  <Card>
                    <CardHeader>
                      <CardTitle className="flex items-center gap-2">
                        <Calendar className="w-5 h-5 text-blue-500" />
                        Batch Schedule Management
                      </CardTitle>
                      <CardDescription>Manage date-wise schedules for each batch</CardDescription>
                    </CardHeader>
                    <CardContent>
                      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
                        {[...new Set(students.map(s => s.batch_number).filter(Boolean))].sort().map(batch => (
                          <Button
                            key={batch}
                            variant="outline"
                            className="h-20 flex flex-col items-center justify-center hover:bg-blue-50"
                            onClick={() => openScheduleDialog(batch)}
                          >
                            <Calendar className="w-5 h-5 mb-1" />
                            <span className="font-semibold">Batch {batch}</span>
                          </Button>
                        ))}
                      </div>
                      {students.filter(s => s.batch_number).length === 0 && (
                        <p className="text-center py-8 text-gray-500">No batches with students yet</p>
                      )}
                    </CardContent>
                  </Card>
                </div>
              </TabsContent>

              {/* Extra Work Management Tab */}
              <TabsContent value="extra-work">
                <div className="space-y-6">
                  <div className="flex gap-4 mb-6">
                    <Button 
                      onClick={() => {
                        setAllotWorkForm({
                          teacher_id: "",
                          date: "",
                          client_name: "",
                          location: "",
                          service: "",
                          vanity_type: "Studio Vanity",
                          qty: 1,
                          at_studio: false,
                          at_venue: false,
                          price: "",
                          artist_earning: ""
                        });
                        setAllotWorkDialog(true);
                      }}
                      className="bg-purple-500 hover:bg-purple-600"
                      data-testid="allot-work-btn"
                    >
                      <Plus className="w-4 h-4 mr-2" />
                      Allot Work to Artist
                    </Button>
                    
                    <Button 
                      onClick={() => {
                        loadPendingExtraWork();
                        setExtraWorkDialog(true);
                      }}
                      className="bg-orange-500 hover:bg-orange-600"
                    >
                      <Clock className="w-4 h-4 mr-2" />
                      Pending Approvals ({pendingExtraWork.length})
                    </Button>
                    
                    <Button 
                      onClick={loadAllExtraWork}
                      variant="outline"
                    >
                      <Eye className="w-4 h-4 mr-2" />
                      View All Extra Work
                    </Button>
                  </div>

                  {/* All Extra Work Table */}
                  {allExtraWork.length > 0 && (
                    <Card>
                      <CardHeader>
                        <CardTitle>All Extra Work Entries</CardTitle>
                        <CardDescription>Complete history of artist external work assignments</CardDescription>
                      </CardHeader>
                      <CardContent>
                        <div className="overflow-x-auto">
                          <table className="w-full text-sm">
                            <thead>
                              <tr className="border-b bg-gray-50">
                                <th className="text-left p-2 font-semibold">Job ID</th>
                                <th className="text-left p-2 font-semibold">Artist</th>
                                <th className="text-left p-2 font-semibold">Client</th>
                                <th className="text-left p-2 font-semibold">Date</th>
                                <th className="text-left p-2 font-semibold">Service</th>
                                <th className="text-left p-2 font-semibold">Price</th>
                                <th className="text-left p-2 font-semibold">Earning</th>
                                <th className="text-center p-2 font-semibold">Payment</th>
                                <th className="text-left p-2 font-semibold">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allExtraWork.map((work) => (
                                <tr key={work.id} className="border-b hover:bg-gray-50">
                                  <td className="p-2">
                                    <span className="font-mono bg-purple-100 text-purple-700 px-2 py-1 rounded text-xs">
                                      #{work.job_id || '----'}
                                    </span>
                                  </td>
                                  <td className="p-2 font-medium">{work.teacher_name}</td>
                                  <td className="p-2">{work.client_name}</td>
                                  <td className="p-2">{new Date(work.date).toLocaleDateString()}</td>
                                  <td className="p-2">
                                    <div className="flex flex-col">
                                      <span>{work.service}</span>
                                      <span className="text-xs text-gray-500">
                                        {work.at_studio && "📍 Studio"}
                                        {work.at_studio && work.at_venue && " | "}
                                        {work.at_venue && "📍 Venue"}
                                      </span>
                                    </div>
                                  </td>
                                  <td className="p-2 font-semibold text-gray-700">
                                    ₹{work.price || 0}
                                  </td>
                                  <td className="p-2 font-semibold text-green-600">
                                    ₹{work.artist_earning || work.amount || 0}
                                  </td>
                                  <td className="p-2 text-center">
                                    {work.payment_status === 'paid' ? (
                                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
                                        Paid
                                      </span>
                                    ) : (
                                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">
                                        Pending
                                      </span>
                                    )}
                                  </td>
                                  <td className="p-2">
                                    <div className="flex gap-1 flex-wrap">
                                      <Button
                                        size="sm"
                                        variant="outline"
                                        onClick={() => {
                                          setSelectedWork(work);
                                          setAllotWorkForm({
                                            teacher_id: work.teacher_id,
                                            date: work.date,
                                            client_name: work.client_name,
                                            location: work.location,
                                            service: work.service,
                                            vanity_type: work.vanity_type || "Studio Vanity",
                                            qty: work.qty,
                                            at_studio: work.at_studio || false,
                                            at_venue: work.at_venue || false,
                                            price: work.price || "",
                                            artist_earning: work.artist_earning || ""
                                          });
                                          setEditAllotedWorkDialog(true);
                                        }}
                                        data-testid={`edit-work-${work.job_id}`}
                                      >
                                        <Edit className="w-3 h-3" />
                                      </Button>
                                      {work.payment_status !== 'paid' && (
                                        <Button
                                          size="sm"
                                          onClick={() => {
                                            setSelectedWork(work);
                                            setPaymentDialog(true);
                                          }}
                                          className="bg-green-500 hover:bg-green-600"
                                          data-testid={`pay-now-${work.job_id}`}
                                        >
                                          Pay Now
                                        </Button>
                                      )}
                                      <Button
                                        size="sm"
                                        variant="destructive"
                                        onClick={() => handleDeleteExtraWork(work.id)}
                                        data-testid={`delete-work-${work.job_id}`}
                                      >
                                        <Trash2 className="w-3 h-3" />
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </CardContent>
                    </Card>
                  )}
                </div>
              </TabsContent>

              {/* Daily Marks Management Tab */}
              <TabsContent value="daily-marks">
                <Card>
                  <CardHeader>
                    <CardTitle>Daily Marks Management</CardTitle>
                    <CardDescription>View and edit student daily marks</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-4">
                      {/* Batch Selection */}
                      <div className="grid gap-4">
                        <Label>Select Batch</Label>
                        <Select 
                          value={selectedBatchForMarks} 
                          onValueChange={(batch) => {
                            setSelectedBatchForMarks(batch);
                            setSelectedStudentForMarks(null);
                            setStudentScores([]);
                          }}
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Choose a batch first" />
                          </SelectTrigger>
                          <SelectContent>
                            {[...new Set(students.map(s => s.batch_number).filter(Boolean))].sort().map((batch) => (
                              <SelectItem key={batch} value={batch}>
                                Batch {batch}
                              </SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>

                      {/* Student Selection - Only show if batch is selected */}
                      {selectedBatchForMarks && (
                        <div className="grid gap-4">
                          <Label>Select Student</Label>
                          <Select 
                            value={selectedStudentForMarks?.id || ""} 
                            onValueChange={(studentId) => {
                              const student = students.find(s => s.id === studentId);
                              setSelectedStudentForMarks(student);
                              loadStudentScores(studentId);
                            }}
                          >
                            <SelectTrigger>
                              <SelectValue placeholder="Choose a student" />
                            </SelectTrigger>
                            <SelectContent>
                              {students
                                .filter(s => s.batch_number === selectedBatchForMarks)
                                .map((student) => (
                                  <SelectItem key={student.id} value={student.id}>
                                    {student.name} ({student.course_name})
                                  </SelectItem>
                                ))}
                            </SelectContent>
                          </Select>
                        </div>
                      )}

                      {/* Show student info and scores */}
                      {selectedStudentForMarks && (
                        <>
                          <div className="bg-purple-50 p-4 rounded-lg">
                            <h3 className="font-semibold text-lg">{selectedStudentForMarks.name}</h3>
                            <p className="text-sm text-gray-600">Total Score: {selectedStudentForMarks.total_score || 0}</p>
                            <p className="text-sm text-gray-600">Mentor: {selectedStudentForMarks.mentor_name}</p>
                          </div>

                          <div className="flex justify-between items-center">
                            <h4 className="font-semibold">Score History</h4>
                            <Button 
                              onClick={() => {
                                setScoreForm({
                                  date: new Date().toISOString().split('T')[0],
                                  personality: 5,
                                  communication: 5,
                                  punctuality: 5,
                                  eager_to_learn: 5,
                                  work_results: 5,
                                  is_absent: false
                                });
                                setAddScoreDialog(true);
                              }}
                              className="bg-green-500 hover:bg-green-600"
                            >
                              Add New Score
                            </Button>
                          </div>

                          {/* Scores Table */}
                          <div className="border rounded-lg overflow-hidden">
                            <table className="w-full text-sm">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="text-left p-3">Date</th>
                                  <th className="text-center p-3">Personality</th>
                                  <th className="text-center p-3">Communication</th>
                                  <th className="text-center p-3">Punctuality</th>
                                  <th className="text-center p-3">Eager to Learn</th>
                                  <th className="text-center p-3">Work Results</th>
                                  <th className="text-center p-3">Total</th>
                                  <th className="text-center p-3">Status</th>
                                  <th className="text-center p-3">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {studentScores.map((score, idx) => (
                                  <tr key={idx} className="border-b hover:bg-gray-50">
                                    <td className="p-3">{new Date(score.date).toLocaleDateString()}</td>
                                    <td className="text-center p-3">{score.scores.personality || '-'}</td>
                                    <td className="text-center p-3">{score.scores.communication || '-'}</td>
                                    <td className="text-center p-3">{score.scores.punctuality || '-'}</td>
                                    <td className="text-center p-3">{score.scores.eager_to_learn || '-'}</td>
                                    <td className="text-center p-3">{score.scores.work_results || '-'}</td>
                                    <td className="text-center p-3 font-bold">{score.total}</td>
                                    <td className="text-center p-3">
                                      {score.is_absent ? (
                                        <span className="text-red-600 font-medium">Absent</span>
                                      ) : (
                                        <span className="text-green-600 font-medium">Present</span>
                                      )}
                                    </td>
                                    <td className="text-center p-3">
                                      <div className="flex gap-2 justify-center">
                                        <Button
                                          size="sm"
                                          variant="outline"
                                          onClick={() => {
                                            setSelectedScore(score);
                                            setScoreForm({
                                              date: score.date,
                                              personality: score.scores.personality || 5,
                                              communication: score.scores.communication || 5,
                                              punctuality: score.scores.punctuality || 5,
                                              eager_to_learn: score.scores.eager_to_learn || 5,
                                              work_results: score.scores.work_results || 5,
                                              is_absent: score.is_absent || false
                                            });
                                            setEditScoreDialog(true);
                                          }}
                                        >
                                          <Edit className="w-4 h-4" />
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="destructive"
                                          onClick={() => handleDeleteScore(score.id)}
                                        >
                                          <Trash2 className="w-4 h-4" />
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            {studentScores.length === 0 && (
                              <div className="text-center py-8 text-gray-500">
                                No scores recorded yet
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </TabsContent>

              {/* Practice Kits Tab */}
              <TabsContent value="kits">
                <div className="space-y-6">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold">Practice Kit Management</h3>
                    <Button 
                      onClick={loadAllKits}
                      className="bg-purple-500 hover:bg-purple-600"
                    >
                      <Eye className="w-4 h-4 mr-2" />
                      Load All Kits
                    </Button>
                  </div>

                  {allKits.length > 0 ? (
                    <Card>
                      <CardHeader>
                        <CardTitle>All Practice Kits</CardTitle>
                        <CardDescription>View and manage all practice kits issued to students</CardDescription>
                      </CardHeader>
                      <CardContent>
                        <div className="overflow-x-auto">
                          <table className="w-full text-sm">
                            <thead>
                              <tr className="border-b">
                                <th className="text-left p-2">Kit Name</th>
                                <th className="text-left p-2">Student</th>
                                <th className="text-left p-2">Issued By</th>
                                <th className="text-left p-2">Issue Date</th>
                                <th className="text-left p-2">Status</th>
                                <th className="text-left p-2">Return Date</th>
                                <th className="text-left p-2">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allKits.map((kit) => (
                                <tr key={kit.id} className="border-b hover:bg-gray-50">
                                  <td className="p-2 font-medium">{kit.kit_name}</td>
                                  <td className="p-2">{kit.student_name}</td>
                                  <td className="p-2">{kit.issued_by_name}</td>
                                  <td className="p-2">{new Date(kit.issue_date).toLocaleDateString()}</td>
                                  <td className="p-2">
                                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                      kit.is_returned 
                                        ? 'bg-green-100 text-green-700' 
                                        : 'bg-purple-100 text-purple-700'
                                    }`}>
                                      {kit.is_returned ? '✓ Returned' : '📦 Issued'}
                                    </span>
                                  </td>
                                  <td className="p-2">
                                    {kit.return_date ? new Date(kit.return_date).toLocaleDateString() : '-'}
                                  </td>
                                  <td className="p-2">
                                    <div className="flex gap-1">
                                      {kit.kit_image_base64 && (
                                        <Button
                                          size="sm"
                                          variant="outline"
                                          onClick={() => viewKitImage(kit)}
                                          title="View Kit Image"
                                        >
                                          <Eye className="w-3 h-3" />
                                        </Button>
                                      )}
                                      <Button
                                        size="sm"
                                        variant="outline"
                                        onClick={() => handleEditKit(kit)}
                                      >
                                        <Edit className="w-3 h-3" />
                                      </Button>
                                      <Button
                                        size="sm"
                                        variant="outline"
                                        onClick={() => handleDeleteKit(kit.id)}
                                        className="text-red-600 hover:bg-red-50"
                                      >
                                        <Trash2 className="w-3 h-3" />
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </CardContent>
                    </Card>
                  ) : (
                    <Card>
                      <CardContent className="py-12">
                        <p className="text-center text-gray-500">
                          No practice kits found. Click "Load All Kits" to view kits.
                        </p>
                      </CardContent>
                    </Card>
                  )}
                </div>
              </TabsContent>

              {/* Homepage Management Tab */}
              <TabsContent value="homepage">
                <div className="space-y-6">
                  <div className="flex justify-between items-center mb-6">
                    <h3 className="text-2xl font-bold">Homepage Management</h3>
                    <Button
                      variant="outline"
                      onClick={async () => {
                        try {
                          const [heroRes, galleryRes, reviewsRes, promoRes, classRes, batchRes] = await Promise.all([
                            axios.get(`${API}/homepage/hero`),
                            axios.get(`${API}/homepage/videos`),
                            axios.get(`${API}/reviews/videos`),
                            axios.get(`${API}/course-promo-video`),
                            axios.get(`${API}/class-videos`),
                            axios.get(`${API}/batch-images`)
                          ]);
                          setHpHeroContent(heroRes.data);
                          setHpGalleryVideos(galleryRes.data.videos || []);
                          setHpReviewVideos(reviewsRes.data.videos || []);
                          setHpCoursePromoVideo(promoRes.data.video_base64 || "");
                          setHpClassVideos(classRes.data.videos || []);
                          setHpBatchImages(batchRes.data.images || []);
                          toast.success("All content refreshed!");
                        } catch (error) {
                          toast.error("Failed to refresh content");
                        }
                      }}
                    >
                      🔄 Refresh All Content
                    </Button>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-6">
                    {/* Hero Section Management */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Hero Section</CardTitle>
                        <CardDescription>Video and fallback image for homepage hero</CardDescription>
                      </CardHeader>
                      <CardContent className="space-y-4">
                        {/* Current Hero Video */}
                        <div className="border rounded-lg p-3 bg-gray-50">
                          <Label className="text-sm font-semibold mb-2 block">Current Hero Video</Label>
                          {hpHeroContent.video_base64 ? (
                            <div className="flex items-center gap-3">
                              <div className="w-32 h-20 bg-black rounded overflow-hidden">
                                <video src={hpHeroContent.video_base64} className="w-full h-full object-cover" muted />
                              </div>
                              <div className="flex-1">
                                <p className="text-sm text-green-600 font-medium">✓ Video uploaded</p>
                                <p className="text-xs text-gray-500 truncate max-w-[200px]">{hpHeroContent.video_base64.substring(0, 50)}...</p>
                              </div>
                              <Button
                                size="sm"
                                variant="destructive"
                                onClick={async () => {
                                  if (!confirm("Delete hero video?")) return;
                                  try {
                                    await axios.delete(`${API}/admin/homepage/hero/video`);
                                    setHpHeroContent(prev => ({ ...prev, video_base64: "" }));
                                    toast.success("Hero video deleted!");
                                  } catch (error) {
                                    toast.error("Failed to delete");
                                  }
                                }}
                              >
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            </div>
                          ) : (
                            <p className="text-sm text-gray-400 italic">No video uploaded</p>
                          )}
                        </div>

                        {/* Upload Hero Video */}
                        <div>
                          <div className="flex items-center justify-between mb-2">
                            <Label>Upload New Video</Label>
                            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                              <button type="button" id="hp-hero-video-mode-file" onClick={() => { document.getElementById('hero-video-file').classList.remove('hidden'); document.getElementById('hero-video-url').classList.add('hidden'); document.getElementById('hp-hero-video-mode-file').classList.add('bg-white', 'shadow'); document.getElementById('hp-hero-video-mode-url').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md bg-white shadow">📁 File</button>
                              <button type="button" id="hp-hero-video-mode-url" onClick={() => { document.getElementById('hero-video-file').classList.add('hidden'); document.getElementById('hero-video-url').classList.remove('hidden'); document.getElementById('hp-hero-video-mode-url').classList.add('bg-white', 'shadow'); document.getElementById('hp-hero-video-mode-file').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md">🔗 URL</button>
                            </div>
                          </div>
                          <Input id="hero-video-file" type="file" accept="video/mp4,video/webm,video/quicktime" onChange={async (e) => { const file = e.target.files[0]; if (!file) return; if (file.size > 50 * 1024 * 1024) { toast.error("Video too large. Max 50MB"); return; } const reader = new FileReader(); reader.onloadend = async () => { try { await axios.post(`${API}/admin/homepage/hero`, { video_base64: reader.result }); setHpHeroContent(prev => ({ ...prev, video_base64: reader.result })); toast.success("Hero video uploaded!"); e.target.value = ''; } catch (error) { toast.error("Failed to upload"); } }; reader.readAsDataURL(file); }} />
                          <Input id="hero-video-url" type="url" placeholder="Paste video URL..." className="hidden" onKeyDown={async (e) => { if (e.key === 'Enter') { const url = e.target.value.trim(); if (!url) return; try { await axios.post(`${API}/admin/homepage/hero`, { video_base64: url }); setHpHeroContent(prev => ({ ...prev, video_base64: url })); toast.success("Video URL saved!"); e.target.value = ''; } catch (error) { toast.error("Failed to save URL"); } } }} />
                        </div>

                        {/* Current Hero Image */}
                        <div className="border rounded-lg p-3 bg-gray-50">
                          <Label className="text-sm font-semibold mb-2 block">Current Fallback Image</Label>
                          {hpHeroContent.image_base64 ? (
                            <div className="flex items-center gap-3">
                              <img src={hpHeroContent.image_base64} alt="Hero" className="w-24 h-16 object-cover rounded" />
                              <div className="flex-1">
                                <p className="text-sm text-green-600 font-medium">✓ Image uploaded</p>
                              </div>
                              <Button size="sm" variant="destructive" onClick={async () => { if (!confirm("Delete fallback image?")) return; try { await axios.delete(`${API}/admin/homepage/hero/image`); setHpHeroContent(prev => ({ ...prev, image_base64: "" })); toast.success("Image deleted!"); } catch (error) { toast.error("Failed to delete"); } }}>
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            </div>
                          ) : (
                            <p className="text-sm text-gray-400 italic">No fallback image</p>
                          )}
                        </div>

                        {/* Upload Hero Image */}
                        <div>
                          <div className="flex items-center justify-between mb-2">
                            <Label>Upload Fallback Image</Label>
                            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                              <button type="button" id="hp-hero-img-mode-file" onClick={() => { document.getElementById('hero-image-file').classList.remove('hidden'); document.getElementById('hero-image-url').classList.add('hidden'); document.getElementById('hp-hero-img-mode-file').classList.add('bg-white', 'shadow'); document.getElementById('hp-hero-img-mode-url').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md bg-white shadow">📁 File</button>
                              <button type="button" id="hp-hero-img-mode-url" onClick={() => { document.getElementById('hero-image-file').classList.add('hidden'); document.getElementById('hero-image-url').classList.remove('hidden'); document.getElementById('hp-hero-img-mode-url').classList.add('bg-white', 'shadow'); document.getElementById('hp-hero-img-mode-file').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md">🔗 URL</button>
                            </div>
                          </div>
                          <Input id="hero-image-file" type="file" accept="image/*" onChange={async (e) => { const file = e.target.files[0]; if (!file) return; if (file.size > 10 * 1024 * 1024) { toast.error("Image too large. Max 10MB"); return; } const reader = new FileReader(); reader.onloadend = async () => { try { await axios.post(`${API}/admin/homepage/hero`, { image_base64: reader.result }); setHpHeroContent(prev => ({ ...prev, image_base64: reader.result })); toast.success("Image uploaded!"); e.target.value = ''; } catch (error) { toast.error("Failed to upload"); } }; reader.readAsDataURL(file); }} />
                          <Input id="hero-image-url" type="url" placeholder="Paste image URL..." className="hidden" onKeyDown={async (e) => { if (e.key === 'Enter') { const url = e.target.value.trim(); if (!url) return; try { await axios.post(`${API}/admin/homepage/hero`, { image_base64: url }); setHpHeroContent(prev => ({ ...prev, image_base64: url })); toast.success("Image URL saved!"); e.target.value = ''; } catch (error) { toast.error("Failed to save URL"); } } }} />
                        </div>
                      </CardContent>
                    </Card>

                    {/* Video Gallery Management */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Video Gallery ({hpGalleryVideos.length})</CardTitle>
                        <CardDescription>Videos shown in homepage slider</CardDescription>
                      </CardHeader>
                      <CardContent className="space-y-4">
                        {/* Current Videos */}
                        {hpGalleryVideos.length > 0 && (
                          <div className="border rounded-lg p-3 bg-gray-50 max-h-48 overflow-y-auto">
                            <Label className="text-sm font-semibold mb-2 block">Current Videos</Label>
                            <div className="space-y-2">
                              {hpGalleryVideos.map((video, idx) => (
                                <div key={video.id} className="flex items-center gap-2 bg-white p-2 rounded border">
                                  <div className="w-16 h-10 bg-black rounded overflow-hidden flex-shrink-0">
                                    <video src={video.video_base64} className="w-full h-full object-cover" muted />
                                  </div>
                                  <span className="flex-1 text-sm truncate">{video.title || `Video ${idx + 1}`}</span>
                                  <Button size="sm" variant="destructive" className="h-7 w-7 p-0" onClick={async () => { if (!confirm("Delete this video?")) return; try { await axios.delete(`${API}/admin/homepage/videos/${video.id}`); setHpGalleryVideos(prev => prev.filter(v => v.id !== video.id)); toast.success("Deleted!"); } catch (error) { toast.error("Failed to delete"); } }}>
                                    <Trash2 className="w-3 h-3" />
                                  </Button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Upload New Video */}
                        <div>
                          <div className="flex items-center justify-between mb-2">
                            <Label>Add New Video</Label>
                            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                              <button type="button" id="hp-gallery-mode-file" onClick={() => { document.getElementById('gallery-video-file').classList.remove('hidden'); document.getElementById('gallery-video-url').classList.add('hidden'); document.getElementById('hp-gallery-mode-file').classList.add('bg-white', 'shadow'); document.getElementById('hp-gallery-mode-url').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md bg-white shadow">📁 File</button>
                              <button type="button" id="hp-gallery-mode-url" onClick={() => { document.getElementById('gallery-video-file').classList.add('hidden'); document.getElementById('gallery-video-url').classList.remove('hidden'); document.getElementById('hp-gallery-mode-url').classList.add('bg-white', 'shadow'); document.getElementById('hp-gallery-mode-file').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md">🔗 URL</button>
                            </div>
                          </div>
                          <Input id="gallery-video-file" type="file" accept="video/*" onChange={async (e) => { const file = e.target.files[0]; if (!file) return; if (file.size > 50 * 1024 * 1024) { toast.error("Max 50MB"); return; } const title = prompt("Enter video title:") || file.name; const reader = new FileReader(); reader.onloadend = async () => { try { const res = await axios.post(`${API}/admin/homepage/videos`, { video_base64: reader.result, title }); setHpGalleryVideos(prev => [{ id: res.data.video_id, video_base64: reader.result, title }, ...prev]); toast.success("Video added!"); e.target.value = ''; } catch (error) { toast.error("Failed to add"); } }; reader.readAsDataURL(file); }} />
                          <Input id="gallery-video-url" type="url" placeholder="Paste video URL (press Enter)" className="hidden" onKeyDown={async (e) => { if (e.key === 'Enter') { const url = e.target.value.trim(); if (!url) return; const title = prompt("Enter video title:") || "Gallery Video"; try { const res = await axios.post(`${API}/admin/homepage/videos`, { video_base64: url, title }); setHpGalleryVideos(prev => [{ id: res.data.video_id, video_base64: url, title }, ...prev]); toast.success("Video added!"); e.target.value = ''; } catch (error) { toast.error("Failed to add"); } } }} />
                        </div>
                      </CardContent>
                    </Card>

                    {/* Customer Review Videos */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Customer Review Videos ({hpReviewVideos.length})</CardTitle>
                        <CardDescription>"Real People, Real Review" section</CardDescription>
                      </CardHeader>
                      <CardContent className="space-y-4">
                        {/* Current Review Videos */}
                        {hpReviewVideos.length > 0 && (
                          <div className="border rounded-lg p-3 bg-gray-50 max-h-48 overflow-y-auto">
                            <Label className="text-sm font-semibold mb-2 block">Current Reviews</Label>
                            <div className="space-y-2">
                              {hpReviewVideos.map((video) => (
                                <div key={video.id} className="flex items-center gap-2 bg-white p-2 rounded border">
                                  <div className="w-12 h-12 bg-black rounded overflow-hidden flex-shrink-0">
                                    {video.thumbnail_base64 ? <img src={video.thumbnail_base64} className="w-full h-full object-cover" alt="" /> : <video src={video.video_base64} className="w-full h-full object-cover" muted />}
                                  </div>
                                  {editingReviewName === video.id ? (
                                    <Input defaultValue={video.reviewer_name} className="flex-1 h-8 text-sm" id={`edit-review-${video.id}`} onKeyDown={async (e) => { if (e.key === 'Enter') { try { await axios.put(`${API}/admin/reviews/videos/${video.id}`, { reviewer_name: e.target.value }); setHpReviewVideos(prev => prev.map(v => v.id === video.id ? { ...v, reviewer_name: e.target.value } : v)); setEditingReviewName(null); toast.success("Updated!"); } catch (error) { toast.error("Failed"); } } else if (e.key === 'Escape') setEditingReviewName(null); }} autoFocus />
                                  ) : (
                                    <span className="flex-1 text-sm truncate">{video.reviewer_name}</span>
                                  )}
                                  <Button size="sm" variant="outline" className="h-7 w-7 p-0" onClick={() => setEditingReviewName(video.id)}>
                                    <Edit className="w-3 h-3" />
                                  </Button>
                                  <Button size="sm" variant="destructive" className="h-7 w-7 p-0" onClick={async () => { if (!confirm("Delete?")) return; try { await axios.delete(`${API}/admin/reviews/videos/${video.id}`); setHpReviewVideos(prev => prev.filter(v => v.id !== video.id)); toast.success("Deleted!"); } catch (error) { toast.error("Failed"); } }}>
                                    <Trash2 className="w-3 h-3" />
                                  </Button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Add Review Video */}
                        <div>
                          <div className="flex items-center justify-between mb-2">
                            <Label>Add Review Video</Label>
                            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                              <button type="button" id="hp-review-mode-file" onClick={() => { document.getElementById('review-video-file').classList.remove('hidden'); document.getElementById('review-video-url').classList.add('hidden'); document.getElementById('hp-review-mode-file').classList.add('bg-white', 'shadow'); document.getElementById('hp-review-mode-url').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md bg-white shadow">📁 File</button>
                              <button type="button" id="hp-review-mode-url" onClick={() => { document.getElementById('review-video-file').classList.add('hidden'); document.getElementById('review-video-url').classList.remove('hidden'); document.getElementById('hp-review-mode-url').classList.add('bg-white', 'shadow'); document.getElementById('hp-review-mode-file').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md">🔗 URL</button>
                            </div>
                          </div>
                          <Input id="review-video-file" type="file" accept="video/*" onChange={async (e) => { const file = e.target.files[0]; if (!file) return; if (file.size > 50 * 1024 * 1024) { toast.error("Max 50MB"); return; } const name = prompt("Reviewer name:"); if (!name) return; const reader = new FileReader(); reader.onloadend = async () => { try { const res = await axios.post(`${API}/admin/reviews/videos`, { video_base64: reader.result, reviewer_name: name }); setHpReviewVideos(prev => [{ id: res.data.video_id, video_base64: reader.result, reviewer_name: name }, ...prev]); toast.success("Added!"); e.target.value = ''; } catch (error) { toast.error("Failed"); } }; reader.readAsDataURL(file); }} />
                          <Input id="review-video-url" type="url" placeholder="Paste video URL (press Enter)" className="hidden" onKeyDown={async (e) => { if (e.key === 'Enter') { const url = e.target.value.trim(); if (!url) return; const name = prompt("Reviewer name:"); if (!name) return; try { const res = await axios.post(`${API}/admin/reviews/videos`, { video_base64: url, reviewer_name: name }); setHpReviewVideos(prev => [{ id: res.data.video_id, video_base64: url, reviewer_name: name }, ...prev]); toast.success("Added!"); e.target.value = ''; } catch (error) { toast.error("Failed"); } } }} />
                        </div>
                      </CardContent>
                    </Card>

                    {/* Course Promo Video */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Course Promo Video</CardTitle>
                        <CardDescription>Video for Courses page header</CardDescription>
                      </CardHeader>
                      <CardContent className="space-y-4">
                        {/* Current Video */}
                        <div className="border rounded-lg p-3 bg-gray-50">
                          <Label className="text-sm font-semibold mb-2 block">Current Video</Label>
                          {hpCoursePromoVideo ? (
                            <div className="flex items-center gap-3">
                              <div className="w-32 h-20 bg-black rounded overflow-hidden">
                                <video src={hpCoursePromoVideo} className="w-full h-full object-cover" muted />
                              </div>
                              <div className="flex-1">
                                <p className="text-sm text-green-600 font-medium">✓ Video uploaded</p>
                              </div>
                              <Button size="sm" variant="destructive" onClick={async () => { if (!confirm("Delete promo video?")) return; try { await axios.delete(`${API}/admin/course-promo-video`); setHpCoursePromoVideo(""); toast.success("Deleted!"); } catch (error) { toast.error("Failed"); } }}>
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            </div>
                          ) : (
                            <p className="text-sm text-gray-400 italic">No video uploaded</p>
                          )}
                        </div>

                        {/* Upload */}
                        <div>
                          <div className="flex items-center justify-between mb-2">
                            <Label>Upload Video</Label>
                            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                              <button type="button" id="hp-promo-mode-file" onClick={() => { document.getElementById('course-promo-video-file').classList.remove('hidden'); document.getElementById('course-promo-video-url').classList.add('hidden'); document.getElementById('hp-promo-mode-file').classList.add('bg-white', 'shadow'); document.getElementById('hp-promo-mode-url').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md bg-white shadow">📁 File</button>
                              <button type="button" id="hp-promo-mode-url" onClick={() => { document.getElementById('course-promo-video-file').classList.add('hidden'); document.getElementById('course-promo-video-url').classList.remove('hidden'); document.getElementById('hp-promo-mode-url').classList.add('bg-white', 'shadow'); document.getElementById('hp-promo-mode-file').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md">🔗 URL</button>
                            </div>
                          </div>
                          <Input id="course-promo-video-file" type="file" accept="video/*" onChange={async (e) => { const file = e.target.files[0]; if (!file) return; if (file.size > 50 * 1024 * 1024) { toast.error("Max 50MB"); return; } const reader = new FileReader(); reader.onloadend = async () => { try { await axios.post(`${API}/admin/course-promo-video`, { video_base64: reader.result }); setHpCoursePromoVideo(reader.result); toast.success("Uploaded!"); e.target.value = ''; } catch (error) { toast.error("Failed"); } }; reader.readAsDataURL(file); }} />
                          <Input id="course-promo-video-url" type="url" placeholder="Paste video URL (press Enter)" className="hidden" onKeyDown={async (e) => { if (e.key === 'Enter') { const url = e.target.value.trim(); if (!url) return; try { await axios.post(`${API}/admin/course-promo-video`, { video_base64: url }); setHpCoursePromoVideo(url); toast.success("Saved!"); e.target.value = ''; } catch (error) { toast.error("Failed"); } } }} />
                        </div>
                      </CardContent>
                    </Card>

                    {/* Individual Course Videos */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Individual Course Videos</CardTitle>
                        <CardDescription>Upload a video for each course card</CardDescription>
                      </CardHeader>
                      <CardContent className="space-y-4">
                        <Button variant="outline" size="sm" className="mb-2" onClick={async () => { 
                          try { 
                            const res = await axios.get(`${API}/course-videos`); 
                            setCourseVideos(res.data); 
                            toast.success("Loaded!"); 
                          } catch (error) { 
                            toast.error("Failed to load"); 
                          } 
                        }}>🔄 Load Current</Button>
                        
                        <div className="grid md:grid-cols-2 gap-4">
                          {/* Course 1: Only Makeup */}
                          <div className="border rounded-lg p-3">
                            <Label className="font-semibold text-purple-700">Course 1: Only Makeup</Label>
                            {courseVideos.course1 && (
                              <div className="w-full h-24 bg-black rounded overflow-hidden mt-2 mb-2">
                                <video src={courseVideos.course1} className="w-full h-full object-cover" muted />
                              </div>
                            )}
                            <Input type="file" accept="video/*" className="mt-2" onChange={async (e) => { 
                              const file = e.target.files[0]; 
                              if (!file) return; 
                              if (file.size > 50 * 1024 * 1024) { toast.error("Max 50MB"); return; } 
                              const reader = new FileReader(); 
                              reader.onloadend = () => { setCourseVideos(prev => ({ ...prev, course1: reader.result })); }; 
                              reader.readAsDataURL(file); 
                            }} />
                            <Input type="url" placeholder="Or paste video URL" value={courseVideos.course1 || ""} className="mt-2" onChange={(e) => setCourseVideos(prev => ({ ...prev, course1: e.target.value }))} />
                          </div>
                          
                          {/* Course 2: Makeup & Hair */}
                          <div className="border rounded-lg p-3">
                            <Label className="font-semibold text-purple-700">Course 2: Makeup & Hair</Label>
                            {courseVideos.course2 && (
                              <div className="w-full h-24 bg-black rounded overflow-hidden mt-2 mb-2">
                                <video src={courseVideos.course2} className="w-full h-full object-cover" muted />
                              </div>
                            )}
                            <Input type="file" accept="video/*" className="mt-2" onChange={async (e) => { 
                              const file = e.target.files[0]; 
                              if (!file) return; 
                              if (file.size > 50 * 1024 * 1024) { toast.error("Max 50MB"); return; } 
                              const reader = new FileReader(); 
                              reader.onloadend = () => { setCourseVideos(prev => ({ ...prev, course2: reader.result })); }; 
                              reader.readAsDataURL(file); 
                            }} />
                            <Input type="url" placeholder="Or paste video URL" value={courseVideos.course2 || ""} className="mt-2" onChange={(e) => setCourseVideos(prev => ({ ...prev, course2: e.target.value }))} />
                          </div>
                          
                          {/* Course 3: Makeup, Hair, Nails or Draping */}
                          <div className="border rounded-lg p-3">
                            <Label className="font-semibold text-purple-700">Course 3: Makeup, Hair, Nails/Draping</Label>
                            {courseVideos.course3 && (
                              <div className="w-full h-24 bg-black rounded overflow-hidden mt-2 mb-2">
                                <video src={courseVideos.course3} className="w-full h-full object-cover" muted />
                              </div>
                            )}
                            <Input type="file" accept="video/*" className="mt-2" onChange={async (e) => { 
                              const file = e.target.files[0]; 
                              if (!file) return; 
                              if (file.size > 50 * 1024 * 1024) { toast.error("Max 50MB"); return; } 
                              const reader = new FileReader(); 
                              reader.onloadend = () => { setCourseVideos(prev => ({ ...prev, course3: reader.result })); }; 
                              reader.readAsDataURL(file); 
                            }} />
                            <Input type="url" placeholder="Or paste video URL" value={courseVideos.course3 || ""} className="mt-2" onChange={(e) => setCourseVideos(prev => ({ ...prev, course3: e.target.value }))} />
                          </div>
                          
                          {/* Course 4: Master Course */}
                          <div className="border rounded-lg p-3">
                            <Label className="font-semibold text-purple-700">Course 4: Master Course</Label>
                            {courseVideos.course4 && (
                              <div className="w-full h-24 bg-black rounded overflow-hidden mt-2 mb-2">
                                <video src={courseVideos.course4} className="w-full h-full object-cover" muted />
                              </div>
                            )}
                            <Input type="file" accept="video/*" className="mt-2" onChange={async (e) => { 
                              const file = e.target.files[0]; 
                              if (!file) return; 
                              if (file.size > 50 * 1024 * 1024) { toast.error("Max 50MB"); return; } 
                              const reader = new FileReader(); 
                              reader.onloadend = () => { setCourseVideos(prev => ({ ...prev, course4: reader.result })); }; 
                              reader.readAsDataURL(file); 
                            }} />
                            <Input type="url" placeholder="Or paste video URL" value={courseVideos.course4 || ""} className="mt-2" onChange={(e) => setCourseVideos(prev => ({ ...prev, course4: e.target.value }))} />
                          </div>
                        </div>
                        
                        <Button className="w-full mt-4" onClick={async () => { 
                          try { 
                            await axios.post(`${API}/admin/course-videos`, courseVideos); 
                            toast.success("Course videos saved!"); 
                          } catch (error) { 
                            toast.error("Failed to save"); 
                          } 
                        }}>Save All Course Videos</Button>
                      </CardContent>
                    </Card>

                    {/* Class Videos */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Class Videos ({hpClassVideos.length})</CardTitle>
                        <CardDescription>"Watch Class Videos" on Courses page</CardDescription>
                      </CardHeader>
                      <CardContent className="space-y-4">
                        {/* Current Class Videos */}
                        {hpClassVideos.length > 0 && (
                          <div className="border rounded-lg p-3 bg-gray-50 max-h-48 overflow-y-auto">
                            <Label className="text-sm font-semibold mb-2 block">Current Videos</Label>
                            <div className="space-y-2">
                              {hpClassVideos.map((video) => (
                                <div key={video.id} className="flex items-center gap-2 bg-white p-2 rounded border">
                                  <div className="w-16 h-10 bg-black rounded overflow-hidden flex-shrink-0">
                                    <video src={video.video_base64} className="w-full h-full object-cover" muted />
                                  </div>
                                  {editingClassTitle === video.id ? (
                                    <Input defaultValue={video.title} className="flex-1 h-8 text-sm" id={`edit-class-${video.id}`} onKeyDown={async (e) => { if (e.key === 'Enter') { try { await axios.put(`${API}/admin/class-videos/${video.id}`, { title: e.target.value }); setHpClassVideos(prev => prev.map(v => v.id === video.id ? { ...v, title: e.target.value } : v)); setEditingClassTitle(null); toast.success("Updated!"); } catch (error) { toast.error("Failed"); } } else if (e.key === 'Escape') setEditingClassTitle(null); }} autoFocus />
                                  ) : (
                                    <span className="flex-1 text-sm truncate">{video.title}</span>
                                  )}
                                  <Button size="sm" variant="outline" className="h-7 w-7 p-0" onClick={() => setEditingClassTitle(video.id)}>
                                    <Edit className="w-3 h-3" />
                                  </Button>
                                  <Button size="sm" variant="destructive" className="h-7 w-7 p-0" onClick={async () => { if (!confirm("Delete?")) return; try { await axios.delete(`${API}/admin/class-videos/${video.id}`); setHpClassVideos(prev => prev.filter(v => v.id !== video.id)); toast.success("Deleted!"); } catch (error) { toast.error("Failed"); } }}>
                                    <Trash2 className="w-3 h-3" />
                                  </Button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Add Class Video */}
                        <div>
                          <div className="flex items-center justify-between mb-2">
                            <Label>Add Class Video</Label>
                            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                              <button type="button" id="hp-class-mode-file" onClick={() => { document.getElementById('class-video-file').classList.remove('hidden'); document.getElementById('class-video-url').classList.add('hidden'); document.getElementById('hp-class-mode-file').classList.add('bg-white', 'shadow'); document.getElementById('hp-class-mode-url').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md bg-white shadow">📁 File</button>
                              <button type="button" id="hp-class-mode-url" onClick={() => { document.getElementById('class-video-file').classList.add('hidden'); document.getElementById('class-video-url').classList.remove('hidden'); document.getElementById('hp-class-mode-url').classList.add('bg-white', 'shadow'); document.getElementById('hp-class-mode-file').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md">🔗 URL</button>
                            </div>
                          </div>
                          <Input id="class-video-file" type="file" accept="video/*" onChange={async (e) => { const file = e.target.files[0]; if (!file) return; if (file.size > 50 * 1024 * 1024) { toast.error("Max 50MB"); return; } const title = prompt("Video title:"); if (!title) return; const reader = new FileReader(); reader.onloadend = async () => { try { const res = await axios.post(`${API}/admin/class-videos`, { video_base64: reader.result, title }); setHpClassVideos(prev => [{ id: res.data.id, video_base64: reader.result, title }, ...prev]); toast.success("Added!"); e.target.value = ''; } catch (error) { toast.error("Failed"); } }; reader.readAsDataURL(file); }} />
                          <Input id="class-video-url" type="url" placeholder="Paste video URL (press Enter)" className="hidden" onKeyDown={async (e) => { if (e.key === 'Enter') { const url = e.target.value.trim(); if (!url) return; const title = prompt("Video title:"); if (!title) return; try { const res = await axios.post(`${API}/admin/class-videos`, { video_base64: url, title }); setHpClassVideos(prev => [{ id: res.data.id, video_base64: url, title }, ...prev]); toast.success("Added!"); e.target.value = ''; } catch (error) { toast.error("Failed"); } } }} />
                        </div>
                      </CardContent>
                    </Card>

                    {/* Last 5 Batches Images */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Last 5 Batches ({hpBatchImages.length})</CardTitle>
                        <CardDescription>Batch photos on Courses page</CardDescription>
                      </CardHeader>
                      <CardContent className="space-y-4">
                        {/* Current Batch Images */}
                        {hpBatchImages.length > 0 && (
                          <div className="border rounded-lg p-3 bg-gray-50 max-h-48 overflow-y-auto">
                            <Label className="text-sm font-semibold mb-2 block">Current Images</Label>
                            <div className="grid grid-cols-3 gap-2">
                              {hpBatchImages.map((img) => (
                                <div key={img.id} className="relative group">
                                  <img src={img.image_base64} alt={img.title} className="w-full h-16 object-cover rounded" />
                                  <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-1 rounded">
                                    <Button size="sm" variant="outline" className="h-6 w-6 p-0 bg-white" onClick={() => { const newTitle = prompt("Edit title:", img.title); if (newTitle) { axios.put(`${API}/admin/batch-images/${img.id}`, { title: newTitle }).then(() => { setHpBatchImages(prev => prev.map(i => i.id === img.id ? { ...i, title: newTitle } : i)); toast.success("Updated!"); }).catch(() => toast.error("Failed")); } }}>
                                      <Edit className="w-3 h-3" />
                                    </Button>
                                    <Button size="sm" variant="destructive" className="h-6 w-6 p-0" onClick={async () => { if (!confirm("Delete?")) return; try { await axios.delete(`${API}/admin/batch-images/${img.id}`); setHpBatchImages(prev => prev.filter(i => i.id !== img.id)); toast.success("Deleted!"); } catch (error) { toast.error("Failed"); } }}>
                                      <Trash2 className="w-3 h-3" />
                                    </Button>
                                  </div>
                                  <p className="text-xs text-center mt-1 truncate">{img.title}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Add Batch Image */}
                        <div>
                          <div className="flex items-center justify-between mb-2">
                            <Label>Add Batch Image</Label>
                            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                              <button type="button" id="hp-batch-mode-file" onClick={() => { document.getElementById('batch-image-file').classList.remove('hidden'); document.getElementById('batch-image-url').classList.add('hidden'); document.getElementById('hp-batch-mode-file').classList.add('bg-white', 'shadow'); document.getElementById('hp-batch-mode-url').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md bg-white shadow">📁 File</button>
                              <button type="button" id="hp-batch-mode-url" onClick={() => { document.getElementById('batch-image-file').classList.add('hidden'); document.getElementById('batch-image-url').classList.remove('hidden'); document.getElementById('hp-batch-mode-url').classList.add('bg-white', 'shadow'); document.getElementById('hp-batch-mode-file').classList.remove('bg-white', 'shadow'); }} className="px-2 py-1 rounded-md">🔗 URL</button>
                            </div>
                          </div>
                          <Input id="batch-image-file" type="file" accept="image/*" onChange={async (e) => { const file = e.target.files[0]; if (!file) return; if (file.size > 5 * 1024 * 1024) { toast.error("Max 5MB"); return; } const title = prompt("Batch title:"); if (!title) return; const reader = new FileReader(); reader.onloadend = async () => { try { const res = await axios.post(`${API}/admin/batch-images`, { image_base64: reader.result, title }); setHpBatchImages(prev => [{ id: res.data.id, image_base64: reader.result, title }, ...prev]); toast.success("Added!"); e.target.value = ''; } catch (error) { toast.error("Failed"); } }; reader.readAsDataURL(file); }} />
                          <Input id="batch-image-url" type="url" placeholder="Paste image URL (press Enter)" className="hidden" onKeyDown={async (e) => { if (e.key === 'Enter') { const url = e.target.value.trim(); if (!url) return; const title = prompt("Batch title:"); if (!title) return; try { const res = await axios.post(`${API}/admin/batch-images`, { image_base64: url, title }); setHpBatchImages(prev => [{ id: res.data.id, image_base64: url, title }, ...prev]); toast.success("Added!"); e.target.value = ''; } catch (error) { toast.error("Failed"); } } }} />
                        </div>
                      </CardContent>
                    </Card>
                  </div>

                  {/* Footer, Aradhana Section & Homepage Sections Management */}
                  <div className="grid md:grid-cols-2 gap-6 mt-6">
                    {/* Footer Content Management */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Footer Content</CardTitle>
                        <CardDescription>Edit footer text, contact info & social links</CardDescription>
                      </CardHeader>
                      <CardContent className="space-y-3">
                        <Button variant="outline" size="sm" className="mb-2" onClick={async () => { try { const res = await axios.get(`${API}/footer-content`); setFooterContent(res.data); toast.success("Loaded!"); } catch (error) { toast.error("Failed"); } }}>🔄 Load Current</Button>
                        <div>
                          <Label>Title</Label>
                          <Input value={footerContent.title} onChange={(e) => setFooterContent({ ...footerContent, title: e.target.value })} className="mt-1" />
                        </div>
                        <div>
                          <Label>Subtitle</Label>
                          <Input value={footerContent.subtitle} onChange={(e) => setFooterContent({ ...footerContent, subtitle: e.target.value })} className="mt-1" />
                        </div>
                        <div className="grid grid-cols-2 gap-2">
                          <div>
                            <Label>Phone</Label>
                            <Input value={footerContent.phone} onChange={(e) => setFooterContent({ ...footerContent, phone: e.target.value })} className="mt-1" />
                          </div>
                          <div>
                            <Label>WhatsApp (with country code)</Label>
                            <Input value={footerContent.whatsapp} onChange={(e) => setFooterContent({ ...footerContent, whatsapp: e.target.value })} className="mt-1" />
                          </div>
                        </div>
                        <div>
                          <Label>Instagram URL</Label>
                          <Input value={footerContent.instagram} onChange={(e) => setFooterContent({ ...footerContent, instagram: e.target.value })} className="mt-1" />
                        </div>
                        <div>
                          <Label>Address</Label>
                          <Input value={footerContent.address} onChange={(e) => setFooterContent({ ...footerContent, address: e.target.value })} className="mt-1" />
                        </div>
                        <div>
                          <Label>Copyright Text</Label>
                          <Input value={footerContent.copyright} onChange={(e) => setFooterContent({ ...footerContent, copyright: e.target.value })} className="mt-1" />
                        </div>
                        <Button className="w-full mt-2" onClick={async () => { try { await axios.post(`${API}/admin/footer-content`, footerContent); toast.success("Footer updated!"); } catch (error) { toast.error("Failed"); } }}>Save Footer Content</Button>
                      </CardContent>
                    </Card>

                    {/* Aradhana Shreya Section */}
                    <Card>
                      <CardHeader>
                        <CardTitle>Aradhana Shreya Section</CardTitle>
                        <CardDescription>Edit text content and pictures for mentor section</CardDescription>
                      </CardHeader>
                      <CardContent className="space-y-3">
                        <Button variant="outline" size="sm" className="mb-2" onClick={async () => { try { const res = await axios.get(`${API}/aradhana-section`); setAradhanaSection({ title: res.data.title || "", subtitle: res.data.subtitle || "", description: res.data.description || "", pictures: res.data.pictures || [] }); toast.success("Loaded!"); } catch (error) { toast.error("Failed"); } }}>🔄 Load Current</Button>
                        <div>
                          <Label>Section Title</Label>
                          <Input value={aradhanaSection.title} onChange={(e) => setAradhanaSection({ ...aradhanaSection, title: e.target.value })} className="mt-1" />
                        </div>
                        <div>
                          <Label>Subtitle</Label>
                          <Input value={aradhanaSection.subtitle} onChange={(e) => setAradhanaSection({ ...aradhanaSection, subtitle: e.target.value })} className="mt-1" />
                        </div>
                        <div>
                          <Label>Description</Label>
                          <Textarea value={aradhanaSection.description} onChange={(e) => setAradhanaSection({ ...aradhanaSection, description: e.target.value })} className="mt-1" rows={3} />
                        </div>
                        
                        {/* Picture Uploads */}
                        <div className="border-t pt-3 mt-3">
                          <Label className="font-semibold">Section Pictures (Slider Images)</Label>
                          <p className="text-xs text-gray-500 mb-2">Upload pictures for the Aradhana section slider</p>
                          
                          {/* Current Pictures */}
                          {aradhanaSection.pictures && aradhanaSection.pictures.filter(pic => pic && pic.trim() !== '').length > 0 && (
                            <div className="grid grid-cols-4 gap-2 mb-3">
                              {aradhanaSection.pictures.filter(pic => pic && pic.trim() !== '').map((pic, idx) => (
                                <div key={idx} className="relative group">
                                  <img src={pic} alt={`Aradhana ${idx + 1}`} className="w-full h-20 object-cover rounded" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />
                                  <div className="hidden w-full h-20 bg-gray-200 rounded items-center justify-center text-xs text-gray-500">Invalid URL</div>
                                  <button
                                    onClick={async () => {
                                      const newPictures = aradhanaSection.pictures.filter((p) => p !== pic);
                                      const updatedSection = { ...aradhanaSection, pictures: newPictures };
                                      setAradhanaSection(updatedSection);
                                      try {
                                        await axios.post(`${API}/admin/aradhana-section`, updatedSection);
                                        toast.success("Picture deleted!");
                                      } catch (error) {
                                        toast.error("Failed to delete");
                                      }
                                    }}
                                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 text-xs opacity-0 group-hover:opacity-100 transition-opacity"
                                  >×</button>
                                </div>
                              ))}
                            </div>
                          )}
                          
                          {/* File Upload */}
                          <div className="flex gap-2 items-center">
                            <Input 
                              type="file" 
                              accept="image/*" 
                              className="flex-1"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (!file) return;
                                const reader = new FileReader();
                                reader.onloadend = async () => {
                                  const newPictures = [...(aradhanaSection.pictures || []), reader.result];
                                  const updatedSection = { ...aradhanaSection, pictures: newPictures };
                                  setAradhanaSection(updatedSection);
                                  // Auto-save
                                  try {
                                    await axios.post(`${API}/admin/aradhana-section`, updatedSection);
                                    toast.success("Picture uploaded and saved!");
                                  } catch (error) {
                                    toast.error("Picture added but failed to save.");
                                  }
                                };
                                reader.readAsDataURL(file);
                                e.target.value = '';
                              }}
                            />
                          </div>
                          
                          {/* URL Input */}
                          <div className="flex gap-2 mt-2">
                            <Input 
                              type="url" 
                              placeholder="Or paste image URL and click Add"
                              id="aradhana-pic-url"
                              className="flex-1"
                            />
                            <Button 
                              size="sm"
                              onClick={async () => {
                                const urlInput = document.getElementById('aradhana-pic-url');
                                if (urlInput.value && urlInput.value.trim()) {
                                  const newPictures = [...(aradhanaSection.pictures || []), urlInput.value.trim()];
                                  const updatedSection = { ...aradhanaSection, pictures: newPictures };
                                  setAradhanaSection(updatedSection);
                                  urlInput.value = '';
                                  // Auto-save to backend
                                  try {
                                    await axios.post(`${API}/admin/aradhana-section`, updatedSection);
                                    toast.success("Picture added and saved!");
                                  } catch (error) {
                                    toast.error("Picture added but failed to save. Click 'Save Section Content'.");
                                  }
                                } else {
                                  toast.error("Please enter a valid image URL");
                                }
                              }}
                            >Add</Button>
                          </div>
                        </div>
                        
                        <Button className="w-full mt-2" onClick={async () => { try { await axios.post(`${API}/admin/aradhana-section`, aradhanaSection); toast.success("Section updated!"); } catch (error) { toast.error("Failed"); } }}>Save Section Content</Button>
                      </CardContent>
                    </Card>

                    {/* Portfolio Box Images */}
                    <Card className="md:col-span-2">
                      <CardHeader>
                        <CardTitle>Portfolio Box Images</CardTitle>
                        <CardDescription>Edit images for the 3 portfolio boxes: Class Videos, Bride Portfolio, Model Portfolio</CardDescription>
                      </CardHeader>
                      <CardContent>
                        <Button variant="outline" size="sm" className="mb-4" onClick={async () => { try { const res = await axios.get(`${API}/homepage-sections`); setHomepageSections(res.data); toast.success("Loaded!"); } catch (error) { toast.error("Failed"); } }}>🔄 Load Current</Button>
                        <div className="grid md:grid-cols-3 gap-4">
                          <div className="border rounded-lg p-3">
                            <Label className="font-semibold">Class Videos Box</Label>
                            {homepageSections.class_videos_image && (
                              <img src={homepageSections.class_videos_image} alt="Class Videos" className="w-full h-24 object-cover rounded mt-2 mb-2" />
                            )}
                            <div className="flex gap-2 mt-2">
                              <Input type="file" accept="image/*" onChange={async (e) => { 
                                const file = e.target.files[0]; 
                                if (!file) return; 
                                if (file.size > 2 * 1024 * 1024) {
                                  toast.error("Image too large! Max 2MB. Use URL instead.");
                                  e.target.value = '';
                                  return;
                                }
                                const reader = new FileReader(); 
                                reader.onloadend = () => { setHomepageSections(prev => ({ ...prev, class_videos_image: reader.result })); }; 
                                reader.readAsDataURL(file); 
                                e.target.value = '';
                              }} className="flex-1" />
                            </div>
                            <Input type="url" placeholder="Or paste image URL (recommended)" value={homepageSections.class_videos_image || ""} className="mt-2" onChange={(e) => setHomepageSections(prev => ({ ...prev, class_videos_image: e.target.value }))} />
                          </div>
                          <div className="border rounded-lg p-3">
                            <Label className="font-semibold">Bride Portfolio Box</Label>
                            {homepageSections.bride_portfolio_image && (
                              <img src={homepageSections.bride_portfolio_image} alt="Bride Portfolio" className="w-full h-24 object-cover rounded mt-2 mb-2" />
                            )}
                            <div className="flex gap-2 mt-2">
                              <Input type="file" accept="image/*" onChange={async (e) => { 
                                const file = e.target.files[0]; 
                                if (!file) return; 
                                if (file.size > 2 * 1024 * 1024) {
                                  toast.error("Image too large! Max 2MB. Use URL instead.");
                                  e.target.value = '';
                                  return;
                                }
                                const reader = new FileReader(); 
                                reader.onloadend = () => { setHomepageSections(prev => ({ ...prev, bride_portfolio_image: reader.result })); }; 
                                reader.readAsDataURL(file); 
                                e.target.value = '';
                              }} className="flex-1" />
                            </div>
                            <Input type="url" placeholder="Or paste image URL (recommended)" value={homepageSections.bride_portfolio_image || ""} className="mt-2" onChange={(e) => setHomepageSections(prev => ({ ...prev, bride_portfolio_image: e.target.value }))} />
                          </div>
                          <div className="border rounded-lg p-3">
                            <Label className="font-semibold">Model Portfolio Box</Label>
                            {homepageSections.model_portfolio_image && (
                              <img src={homepageSections.model_portfolio_image} alt="Model Portfolio" className="w-full h-24 object-cover rounded mt-2 mb-2" />
                            )}
                            <div className="flex gap-2 mt-2">
                              <Input type="file" accept="image/*" onChange={async (e) => { 
                                const file = e.target.files[0]; 
                                if (!file) return; 
                                if (file.size > 2 * 1024 * 1024) {
                                  toast.error("Image too large! Max 2MB. Use URL instead.");
                                  e.target.value = '';
                                  return;
                                }
                                const reader = new FileReader(); 
                                reader.onloadend = () => { setHomepageSections(prev => ({ ...prev, model_portfolio_image: reader.result })); }; 
                                reader.readAsDataURL(file); 
                                e.target.value = '';
                              }} className="flex-1" />
                            </div>
                            <Input type="url" placeholder="Or paste image URL (recommended)" value={homepageSections.model_portfolio_image || ""} className="mt-2" onChange={(e) => setHomepageSections(prev => ({ ...prev, model_portfolio_image: e.target.value }))} />
                          </div>
                        </div>
                        <p className="text-xs text-gray-500 mt-2">💡 Tip: For reliable uploads, use image URLs from Cloudinary or other image hosts instead of file uploads.</p>
                        <Button className="w-full mt-4" onClick={async () => { 
                          try { 
                            await axios.post(`${API}/admin/homepage-sections`, homepageSections); 
                            toast.success("Portfolio box images updated!"); 
                          } catch (error) { 
                            console.error("Save error:", error);
                            if (error.response?.status === 413) {
                              toast.error("Images too large! Please use smaller images or URLs.");
                            } else {
                              toast.error("Failed to save. Try using image URLs instead of file uploads.");
                            }
                          } 
                        }}>Save Portfolio Box Images</Button>
                      </CardContent>
                    </Card>
                  </div>

                  <Card className="mt-6">
                    <CardHeader>
                      <CardTitle>Quick Links</CardTitle>
                    </CardHeader>
                    <CardContent className="grid md:grid-cols-3 gap-4">
                      <Button variant="outline" onClick={() => window.open("/", "_blank")}>View Live Homepage</Button>
                      <Button variant="outline" onClick={() => window.open("/bridal-services", "_blank")}>View Bridal Services Page</Button>
                      <Button variant="outline" onClick={() => window.open("/courses", "_blank")}>View Courses Page</Button>
                    </CardContent>
                  </Card>
                </div>
              </TabsContent>

              {/* Bridal Services Tab */}
              <TabsContent value="bridal">
                <div className="space-y-6">
                  <h2 className="text-2xl font-bold mb-4">Bridal Services Page Management</h2>

                  {/* Hero Slider Images */}
                  <Card>
                    <CardHeader>
                      <CardTitle>Hero Slider Images</CardTitle>
                      <CardDescription>Upload images for the main hero slider on bridal services page</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                      {/* Add New Hero Image */}
                      <div className="border rounded-lg p-4 bg-gray-50">
                        <Label className="text-base font-semibold mb-3 block">Add New Hero Image</Label>
                        <div className="grid md:grid-cols-2 gap-4">
                          <div>
                            <Label htmlFor="hero-bride-name">Bride Name</Label>
                            <Input
                              id="hero-bride-name"
                              type="text"
                              placeholder="e.g., PRIYA SHARMA"
                              className="mt-1"
                            />
                          </div>
                          <div>
                            <Label htmlFor="hero-makeup-date">Makeup Date</Label>
                            <Input
                              id="hero-makeup-date"
                              type="text"
                              placeholder="e.g., 15 January 2025"
                              className="mt-1"
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <div className="flex items-center justify-between mb-2">
                            <Label>Hero Image</Label>
                            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                              <button
                                type="button"
                                id="hero-mode-file"
                                onClick={() => {
                                  document.getElementById('hero-image-file').classList.remove('hidden');
                                  document.getElementById('hero-image-url').classList.add('hidden');
                                  document.getElementById('hero-mode-file').classList.add('bg-white', 'shadow');
                                  document.getElementById('hero-mode-url').classList.remove('bg-white', 'shadow');
                                }}
                                className="px-2 py-1 rounded-md bg-white shadow"
                              >
                                📁 File
                              </button>
                              <button
                                type="button"
                                id="hero-mode-url"
                                onClick={() => {
                                  document.getElementById('hero-image-file').classList.add('hidden');
                                  document.getElementById('hero-image-url').classList.remove('hidden');
                                  document.getElementById('hero-mode-url').classList.add('bg-white', 'shadow');
                                  document.getElementById('hero-mode-file').classList.remove('bg-white', 'shadow');
                                }}
                                className="px-2 py-1 rounded-md"
                              >
                                🔗 URL
                              </button>
                            </div>
                          </div>
                          <Input
                            id="hero-image-file"
                            type="file"
                            accept="image/jpeg,image/png,image/webp"
                          />
                          <Input
                            id="hero-image-url"
                            type="url"
                            placeholder="Paste image URL (Google Drive, Cloudinary, etc.)"
                            className="hidden"
                          />
                          <p className="text-xs text-gray-400 mt-1">Max 5MB for file upload, or paste direct image URL</p>
                        </div>
                        <Button
                          className="mt-3"
                          onClick={async () => {
                            const fileInput = document.getElementById('hero-image-file');
                            const urlInput = document.getElementById('hero-image-url');
                            const isUrlMode = !document.getElementById('hero-image-url').classList.contains('hidden');
                            
                            const brideName = document.getElementById('hero-bride-name').value;
                            const makeupDate = document.getElementById('hero-makeup-date').value;
                            
                            if (!brideName || !makeupDate) {
                              toast.error("Please enter Bride Name and Makeup Date first");
                              return;
                            }
                            
                            let imageData = "";
                            
                            if (isUrlMode) {
                              // URL mode
                              const url = urlInput.value.trim();
                              if (!url) {
                                toast.error("Please enter an image URL");
                                return;
                              }
                              imageData = url;
                              
                              try {
                                await axios.post(`${API}/admin/bridal-hero-images`, {
                                  image: imageData,
                                  brideName: brideName,
                                  makeupDate: makeupDate
                                });
                                toast.success("Hero image added successfully!");
                                document.getElementById('hero-bride-name').value = '';
                                document.getElementById('hero-makeup-date').value = '';
                                urlInput.value = '';
                                const response = await axios.get(`${API}/bridal-hero-images`);
                                setHeroImages(response.data.images || []);
                              } catch (error) {
                                toast.error(error.response?.data?.detail || "Failed to add hero image");
                              }
                            } else {
                              // File mode
                              const file = fileInput?.files?.[0];
                              if (!file) {
                                toast.error("Please select an image");
                                return;
                              }
                              
                              if (file.size > 5 * 1024 * 1024) {
                                toast.error("Image too large. Maximum size is 5MB");
                                return;
                              }
                              
                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                try {
                                  await axios.post(`${API}/admin/bridal-hero-images`, {
                                    image: reader.result,
                                    brideName: brideName,
                                    makeupDate: makeupDate
                                  });
                                  toast.success("Hero image added successfully!");
                                  document.getElementById('hero-bride-name').value = '';
                                  document.getElementById('hero-makeup-date').value = '';
                                  fileInput.value = '';
                                  const response = await axios.get(`${API}/bridal-hero-images`);
                                  setHeroImages(response.data.images || []);
                                } catch (error) {
                                  toast.error(error.response?.data?.detail || "Failed to add hero image");
                                }
                              };
                              reader.readAsDataURL(file);
                            }
                          }}
                        >
                          <Plus className="w-4 h-4 mr-2" /> Add Hero Image
                        </Button>
                      </div>

                      {/* Existing Hero Images List */}
                      <div className="border-t pt-4">
                        <div className="flex justify-between items-center mb-3">
                          <Label className="text-base font-semibold">Current Hero Images</Label>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={async () => {
                              try {
                                const response = await axios.get(`${API}/bridal-hero-images`);
                                setHeroImages(response.data.images || []);
                                toast.success("Hero images refreshed!");
                              } catch (error) {
                                toast.error("Failed to fetch hero images");
                              }
                            }}
                          >
                            Refresh List
                          </Button>
                        </div>

                        {heroImages.length > 0 ? (
                          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                            {heroImages.map((img, index) => (
                              <div key={img.id || index} className="relative border rounded-lg overflow-hidden bg-white">
                                {/* Image Preview */}
                                <div className="h-32 bg-gray-100">
                                  {img.image ? (
                                    <img src={img.image} alt={img.brideName} className="w-full h-full object-cover" />
                                  ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-400">No Image</div>
                                  )}
                                </div>
                                {/* Info */}
                                <div className="p-2">
                                  {editingHeroImage === img.id ? (
                                    <div className="space-y-2">
                                      <Input
                                        id={`edit-hero-name-${img.id}`}
                                        defaultValue={img.brideName}
                                        placeholder="Bride Name"
                                        className="text-xs"
                                      />
                                      <Input
                                        id={`edit-hero-date-${img.id}`}
                                        defaultValue={img.makeupDate}
                                        placeholder="Makeup Date"
                                        className="text-xs"
                                      />
                                      <div className="flex gap-1">
                                        <Button
                                          size="sm"
                                          className="text-xs flex-1"
                                          onClick={async () => {
                                            const newName = document.getElementById(`edit-hero-name-${img.id}`).value;
                                            const newDate = document.getElementById(`edit-hero-date-${img.id}`).value;
                                            try {
                                              await axios.put(`${API}/admin/bridal-hero-images/${img.id}`, {
                                                brideName: newName,
                                                makeupDate: newDate
                                              });
                                              toast.success("Updated!");
                                              setEditingHeroImage(null);
                                              const response = await axios.get(`${API}/bridal-hero-images`);
                                              setHeroImages(response.data.images || []);
                                            } catch (error) {
                                              toast.error("Failed to update");
                                            }
                                          }}
                                        >
                                          Save
                                        </Button>
                                        <Button size="sm" variant="outline" className="text-xs" onClick={() => setEditingHeroImage(null)}>
                                          Cancel
                                        </Button>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <p className="font-medium text-xs truncate">{img.brideName}</p>
                                      <p className="text-[10px] text-gray-500">{img.makeupDate}</p>
                                      <div className="flex gap-1 mt-2">
                                        <Button size="sm" variant="outline" className="text-xs flex-1" onClick={() => setEditingHeroImage(img.id)}>
                                          <Edit className="w-3 h-3" />
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="destructive"
                                          className="text-xs flex-1"
                                          onClick={async () => {
                                            if (!confirm("Delete this hero image?")) return;
                                            try {
                                              await axios.delete(`${API}/admin/bridal-hero-images/${img.id}`);
                                              toast.success("Deleted!");
                                              setHeroImages(heroImages.filter(i => i.id !== img.id));
                                            } catch (error) {
                                              toast.error("Failed to delete");
                                            }
                                          }}
                                        >
                                          <Trash2 className="w-3 h-3" />
                                        </Button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500 italic p-4 text-center border rounded bg-gray-50">
                            No hero images yet. Click "Refresh List" to load existing or add new images above.
                          </p>
                        )}
                      </div>

                      <p className="text-sm text-gray-500 bg-blue-50 p-3 rounded">
                        These images appear in the full-screen hero slider at the top of the bridal services page.
                      </p>
                    </CardContent>
                  </Card>

                  {/* My Last 5 Brides Images */}
                  <Card>
                    <CardHeader>
                      <CardTitle>My Last 5 Brides</CardTitle>
                      <CardDescription>Upload images for the "My Last 5 Brides" section</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                      {/* Add New Bride */}
                      <div className="border rounded-lg p-4 bg-gray-50">
                        <Label className="text-base font-semibold mb-3 block">Add New Bride</Label>
                        <div className="grid md:grid-cols-2 gap-4">
                          <div>
                            <Label htmlFor="bride-name">Bride Name</Label>
                            <Input
                              id="bride-name"
                              type="text"
                              placeholder="e.g., PRIYA"
                              className="mt-1"
                            />
                          </div>
                          <div>
                            <Label htmlFor="bride-date">Makeup Date</Label>
                            <Input
                              id="bride-date"
                              type="text"
                              placeholder="e.g., 15 Jan 2025"
                              className="mt-1"
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <div className="flex items-center justify-between mb-2">
                            <Label>Bride Image</Label>
                            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                              <button
                                type="button"
                                id="bride-mode-file"
                                onClick={() => {
                                  document.getElementById('bride-image-file').classList.remove('hidden');
                                  document.getElementById('bride-image-url').classList.add('hidden');
                                  document.getElementById('bride-mode-file').classList.add('bg-white', 'shadow');
                                  document.getElementById('bride-mode-url').classList.remove('bg-white', 'shadow');
                                }}
                                className="px-2 py-1 rounded-md bg-white shadow"
                              >
                                📁 File
                              </button>
                              <button
                                type="button"
                                id="bride-mode-url"
                                onClick={() => {
                                  document.getElementById('bride-image-file').classList.add('hidden');
                                  document.getElementById('bride-image-url').classList.remove('hidden');
                                  document.getElementById('bride-mode-url').classList.add('bg-white', 'shadow');
                                  document.getElementById('bride-mode-file').classList.remove('bg-white', 'shadow');
                                }}
                                className="px-2 py-1 rounded-md"
                              >
                                🔗 URL
                              </button>
                            </div>
                          </div>
                          <Input
                            id="bride-image-file"
                            type="file"
                            accept="image/jpeg,image/png,image/webp"
                          />
                          <Input
                            id="bride-image-url"
                            type="url"
                            placeholder="Paste image URL (Google Drive, Cloudinary, etc.)"
                            className="hidden"
                          />
                          <p className="text-xs text-gray-400 mt-1">Max 5MB for file upload, or paste direct image URL</p>
                        </div>
                        <Button
                          className="mt-3"
                          onClick={async () => {
                            const fileInput = document.getElementById('bride-image-file');
                            const urlInput = document.getElementById('bride-image-url');
                            const isUrlMode = !document.getElementById('bride-image-url').classList.contains('hidden');
                            
                            const brideName = document.getElementById('bride-name').value;
                            const brideDate = document.getElementById('bride-date').value;
                            
                            if (!brideName || !brideDate) {
                              toast.error("Please enter Bride Name and Makeup Date first");
                              return;
                            }
                            
                            if (isUrlMode) {
                              const url = urlInput.value.trim();
                              if (!url) {
                                toast.error("Please enter an image URL");
                                return;
                              }
                              
                              try {
                                await axios.post(`${API}/admin/last-brides`, {
                                  image: url,
                                  brideName: brideName,
                                  makeupDate: brideDate
                                });
                                toast.success("Bride image added successfully!");
                                document.getElementById('bride-name').value = '';
                                document.getElementById('bride-date').value = '';
                                urlInput.value = '';
                                const response = await axios.get(`${API}/last-brides`);
                                setLastBrides(response.data.brides || []);
                              } catch (error) {
                                toast.error(error.response?.data?.detail || "Failed to add bride image");
                              }
                            } else {
                              const file = fileInput?.files?.[0];
                              if (!file) {
                                toast.error("Please select an image");
                                return;
                              }
                              
                              if (file.size > 5 * 1024 * 1024) {
                                toast.error("Image too large. Maximum size is 5MB");
                                return;
                              }
                              
                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                try {
                                  await axios.post(`${API}/admin/last-brides`, {
                                    image: reader.result,
                                    brideName: brideName,
                                    makeupDate: brideDate
                                  });
                                  toast.success("Bride image added successfully!");
                                  document.getElementById('bride-name').value = '';
                                  document.getElementById('bride-date').value = '';
                                  fileInput.value = '';
                                  const response = await axios.get(`${API}/last-brides`);
                                  setLastBrides(response.data.brides || []);
                                } catch (error) {
                                  toast.error(error.response?.data?.detail || "Failed to add bride image");
                                }
                              };
                              reader.readAsDataURL(file);
                            }
                          }}
                        >
                          <Plus className="w-4 h-4 mr-2" /> Add Bride
                        </Button>
                      </div>

                      {/* Existing Brides List */}
                      <div className="border-t pt-4">
                        <div className="flex justify-between items-center mb-3">
                          <Label className="text-base font-semibold">Current Last 5 Brides</Label>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={async () => {
                              try {
                                const response = await axios.get(`${API}/last-brides`);
                                setLastBrides(response.data.brides || []);
                                toast.success("Brides list refreshed!");
                              } catch (error) {
                                toast.error("Failed to fetch brides");
                              }
                            }}
                          >
                            Refresh List
                          </Button>
                        </div>

                        {lastBrides.length > 0 ? (
                          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                            {lastBrides.map((bride, index) => (
                              <div key={bride.id || index} className="relative border rounded-lg overflow-hidden bg-white">
                                {/* Image Preview */}
                                <div className="h-32 bg-gray-100">
                                  {bride.image ? (
                                    <img src={bride.image} alt={bride.brideName} className="w-full h-full object-cover" />
                                  ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-400">No Image</div>
                                  )}
                                </div>
                                {/* Info */}
                                <div className="p-2">
                                  {editingLastBride === bride.id ? (
                                    <div className="space-y-2">
                                      <Input
                                        id={`edit-bride-name-${bride.id}`}
                                        defaultValue={bride.brideName}
                                        placeholder="Bride Name"
                                        className="text-xs"
                                      />
                                      <Input
                                        id={`edit-bride-date-${bride.id}`}
                                        defaultValue={bride.makeupDate}
                                        placeholder="Makeup Date"
                                        className="text-xs"
                                      />
                                      <div className="flex gap-1">
                                        <Button
                                          size="sm"
                                          className="text-xs flex-1"
                                          onClick={async () => {
                                            const newName = document.getElementById(`edit-bride-name-${bride.id}`).value;
                                            const newDate = document.getElementById(`edit-bride-date-${bride.id}`).value;
                                            try {
                                              await axios.put(`${API}/admin/last-bride/${bride.id}`, {
                                                brideName: newName,
                                                makeupDate: newDate
                                              });
                                              toast.success("Updated!");
                                              setEditingLastBride(null);
                                              const response = await axios.get(`${API}/last-brides`);
                                              setLastBrides(response.data.brides || []);
                                            } catch (error) {
                                              toast.error("Failed to update");
                                            }
                                          }}
                                        >
                                          Save
                                        </Button>
                                        <Button size="sm" variant="outline" className="text-xs" onClick={() => setEditingLastBride(null)}>
                                          Cancel
                                        </Button>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <p className="font-medium text-xs truncate">{bride.brideName}</p>
                                      <p className="text-[10px] text-gray-500">{bride.makeupDate}</p>
                                      <div className="flex gap-1 mt-2">
                                        <Button size="sm" variant="outline" className="text-xs flex-1" onClick={() => setEditingLastBride(bride.id)}>
                                          <Edit className="w-3 h-3" />
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="destructive"
                                          className="text-xs flex-1"
                                          onClick={async () => {
                                            if (!confirm("Delete this bride?")) return;
                                            try {
                                              await axios.delete(`${API}/admin/last-brides/${bride.id}`);
                                              toast.success("Deleted!");
                                              setLastBrides(lastBrides.filter(b => b.id !== bride.id));
                                            } catch (error) {
                                              toast.error("Failed to delete");
                                            }
                                          }}
                                        >
                                          <Trash2 className="w-3 h-3" />
                                        </Button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500 italic p-4 text-center border rounded bg-gray-50">
                            No brides yet. Click "Refresh List" to load existing or add new brides above.
                          </p>
                        )}
                      </div>

                      <p className="text-sm text-gray-500 bg-pink-50 p-3 rounded">
                        Only the 5 most recent brides will be displayed on the bridal services page. Each bride shows with their name and makeup date.
                      </p>
                    </CardContent>
                  </Card>

                  {/* Quick Links */}
                  <Card>
                    <CardHeader>
                      <CardTitle>Quick Links</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <Button 
                        variant="outline" 
                        onClick={() => window.open('/bridal-services', '_blank')}
                      >
                        View Bridal Services Page
                      </Button>
                    </CardContent>
                  </Card>

                  {/* Inspiring Video Upload */}
                  <Card>
                    <CardHeader>
                      <CardTitle>Inspiring Model Brides Video</CardTitle>
                      <CardDescription>Upload autoplay video for the "INSPIRING MODEL BRIDES" section</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                      {/* Current Video Preview */}
                      <div className="border-b pb-4">
                        <div className="flex justify-between items-center mb-3">
                          <Label className="text-base font-semibold">Current Video</Label>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={async () => {
                              try {
                                const response = await axios.get(`${API}/inspiring-video`);
                                setInspiringVideo(response.data.video || null);
                                toast.success("Video status refreshed!");
                              } catch (error) {
                                toast.error("Failed to fetch video");
                              }
                            }}
                          >
                            Refresh
                          </Button>
                        </div>
                        
                        {inspiringVideo ? (
                          <div className="flex items-center gap-4 p-3 border rounded-lg bg-gray-50">
                            <div className="w-32 h-20 bg-black rounded overflow-hidden flex-shrink-0">
                              <video 
                                src={inspiringVideo.startsWith('/api') ? `${process.env.REACT_APP_BACKEND_URL || ''}${inspiringVideo}` : inspiringVideo}
                                className="w-full h-full object-cover"
                                muted
                              />
                            </div>
                            <div className="flex-1">
                              <p className="font-medium text-sm">Inspiring Model Brides Video</p>
                              <p className="text-xs text-gray-500">Currently uploaded and active</p>
                            </div>
                            <Button
                              size="sm"
                              variant="destructive"
                              onClick={async () => {
                                if (!confirm("Delete the inspiring video?")) return;
                                try {
                                  await axios.delete(`${API}/admin/inspiring-video`);
                                  toast.success("Video deleted!");
                                  setInspiringVideo(null);
                                } catch (error) {
                                  toast.error("Failed to delete");
                                }
                              }}
                            >
                              <Trash2 className="w-4 h-4 mr-1" /> Delete
                            </Button>
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500 italic p-4 text-center border rounded bg-gray-50">
                            No inspiring video uploaded. Click "Refresh" to check or upload a new one below.
                          </p>
                        )}
                      </div>

                      {/* Upload New Video */}
                      <div>
                        <Label className="text-base font-semibold mb-2 block">{inspiringVideo ? 'Replace Video' : 'Add New Video'}</Label>
                        <div className="flex items-center justify-between mb-2">
                          <Label>Video Source</Label>
                          <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                            <button
                              type="button"
                              id="inspiring-mode-file"
                              onClick={() => {
                                document.getElementById('inspiring-video-file').classList.remove('hidden');
                                document.getElementById('inspiring-video-url').classList.add('hidden');
                                document.getElementById('inspiring-mode-file').classList.add('bg-white', 'shadow');
                                document.getElementById('inspiring-mode-url').classList.remove('bg-white', 'shadow');
                              }}
                              className="px-2 py-1 rounded-md bg-white shadow"
                            >
                              📁 File
                            </button>
                            <button
                              type="button"
                              id="inspiring-mode-url"
                              onClick={() => {
                                document.getElementById('inspiring-video-file').classList.add('hidden');
                                document.getElementById('inspiring-video-url').classList.remove('hidden');
                                document.getElementById('inspiring-mode-url').classList.add('bg-white', 'shadow');
                                document.getElementById('inspiring-mode-file').classList.remove('bg-white', 'shadow');
                              }}
                              className="px-2 py-1 rounded-md"
                            >
                              🔗 URL
                            </button>
                          </div>
                        </div>
                        <Input
                          id="inspiring-video-file"
                          type="file"
                          accept="video/mp4,video/quicktime,.mov"
                        />
                        <Input
                          id="inspiring-video-url"
                          type="url"
                          placeholder="Paste video URL (Google Drive, Cloudinary, YouTube, etc.)"
                          className="hidden"
                        />
                        <p className="text-xs text-gray-400 mt-1">Max 50MB for file upload, or paste direct video URL</p>
                        <Button
                          className="mt-3"
                          id="upload-inspiring-btn"
                          onClick={async () => {
                            const fileInput = document.getElementById('inspiring-video-file');
                            const urlInput = document.getElementById('inspiring-video-url');
                            const isUrlMode = !document.getElementById('inspiring-video-url').classList.contains('hidden');
                            const uploadBtn = document.getElementById('upload-inspiring-btn');
                            
                            if (isUrlMode) {
                              const url = urlInput.value.trim();
                              if (!url) {
                                toast.error("Please enter a video URL");
                                return;
                              }
                              
                              try {
                                await axios.post(`${API}/admin/inspiring-video`, { video: url });
                                toast.success("Inspiring video URL saved successfully!");
                                urlInput.value = '';
                                const response = await axios.get(`${API}/inspiring-video`);
                                setInspiringVideo(response.data.video || null);
                              } catch (error) {
                                toast.error(error.response?.data?.detail || "Failed to save video URL");
                              }
                            } else {
                              const file = fileInput?.files?.[0];
                              
                              if (!file) {
                                toast.error("Please select a video file");
                                return;
                              }
                              
                              if (file.size > 50 * 1024 * 1024) {
                                toast.error("Video too large. Maximum size is 50MB");
                                return;
                              }

                              uploadBtn.disabled = true;
                              uploadBtn.innerText = "Uploading...";
                              toast.info("Uploading video, please wait...");
                              
                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                try {
                                  await axios.post(`${API}/admin/inspiring-video`, {
                                    video: reader.result
                                  }, {
                                    timeout: 120000,
                                    maxContentLength: 100 * 1024 * 1024,
                                    maxBodyLength: 100 * 1024 * 1024
                                  });
                                  toast.success("Inspiring video uploaded successfully!");
                                  fileInput.value = '';
                                  const response = await axios.get(`${API}/inspiring-video`);
                                  setInspiringVideo(response.data.video || null);
                                } catch (error) {
                                  toast.error(error.response?.data?.detail || "Failed to upload inspiring video");
                                } finally {
                                  uploadBtn.disabled = false;
                                  uploadBtn.innerText = inspiringVideo ? 'Replace Video' : 'Upload Video';
                                }
                              };
                              reader.onerror = () => {
                                toast.error("Failed to read video file");
                                uploadBtn.disabled = false;
                              };
                              reader.readAsDataURL(file);
                            }
                          }}
                        >
                          <Plus className="w-4 h-4 mr-2" /> {inspiringVideo ? 'Replace Video' : 'Upload Video'}
                        </Button>
                      </div>

                      <p className="text-sm text-gray-500 bg-purple-50 p-3 rounded">
                        This video will autoplay in the "INSPIRING MODEL BRIDES" section on the bridal services page.
                      </p>
                    </CardContent>
                  </Card>

                  {/* Price List Management - Multiple Headings with Slider */}
                  <Card>
                    <CardHeader>
                      <CardTitle>Price List Section (Slider)</CardTitle>
                      <CardDescription>Manage multiple price categories that display as a slider with arrows on the bridal page</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                      {/* Price List Image - Common for all headings */}
                      <div>
                        <div className="flex items-center justify-between mb-2">
                          <Label>Left Side Image</Label>
                          <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                            <button
                              type="button"
                              id="price-mode-file"
                              onClick={() => {
                                document.getElementById('price-list-image-file').classList.remove('hidden');
                                document.getElementById('price-list-image-url').classList.add('hidden');
                                document.getElementById('price-mode-file').classList.add('bg-white', 'shadow');
                                document.getElementById('price-mode-url').classList.remove('bg-white', 'shadow');
                              }}
                              className="px-2 py-1 rounded-md bg-white shadow"
                            >
                              📁 File
                            </button>
                            <button
                              type="button"
                              id="price-mode-url"
                              onClick={() => {
                                document.getElementById('price-list-image-file').classList.add('hidden');
                                document.getElementById('price-list-image-url').classList.remove('hidden');
                                document.getElementById('price-mode-url').classList.add('bg-white', 'shadow');
                                document.getElementById('price-mode-file').classList.remove('bg-white', 'shadow');
                              }}
                              className="px-2 py-1 rounded-md"
                            >
                              🔗 URL
                            </button>
                          </div>
                        </div>
                        <p className="text-xs text-gray-500 mb-2">This image is common for all price categories</p>
                        <Input
                          id="price-list-image-file"
                          type="file"
                          accept="image/jpeg,image/png,image/webp"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (!file) return;
                            
                            if (file.size > 5 * 1024 * 1024) {
                              toast.error("Image too large. Maximum size is 5MB");
                              return;
                            }
                            
                            const reader = new FileReader();
                            reader.onloadend = async () => {
                              try {
                                await axios.post(`${API}/admin/price-list-image`, {
                                  image: reader.result
                                });
                                toast.success("Price list image uploaded successfully!");
                                e.target.value = '';
                              } catch (error) {
                                toast.error(error.response?.data?.detail || "Failed to upload image");
                              }
                            };
                            reader.readAsDataURL(file);
                          }}
                        />
                        <Input
                          id="price-list-image-url"
                          type="url"
                          placeholder="Paste image URL (Google Drive, Cloudinary, etc.)"
                          className="hidden"
                          onKeyDown={async (e) => {
                            if (e.key === 'Enter') {
                              const url = e.target.value.trim();
                              if (!url) return;
                              try {
                                await axios.post(`${API}/admin/price-list-image`, { image: url });
                                toast.success("Price list image URL saved!");
                                e.target.value = '';
                              } catch (error) {
                                toast.error("Failed to save image URL");
                              }
                            }
                          }}
                        />
                        <p className="text-xs text-gray-400 mt-1">Press Enter to save URL, or select file to upload</p>
                      </div>

                      {/* Add New Heading */}
                      <div className="border-t pt-4">
                        <Label className="text-base font-semibold">Add New Price Category (Heading)</Label>
                        <p className="text-xs text-gray-500 mb-2">Each category will appear as a separate slide</p>
                        <div className="flex gap-2 mt-2">
                          <Input
                            id="new-price-heading"
                            type="text"
                            placeholder="e.g., BRIDAL PACKAGES, PARTY MAKEUP, PRE-WEDDING"
                            className="flex-1"
                          />
                          <Button
                            onClick={async () => {
                              const name = document.getElementById('new-price-heading').value;
                              if (!name) {
                                toast.error("Please enter a heading name");
                                return;
                              }
                              try {
                                await axios.post(`${API}/admin/price-list-heading`, { name });
                                toast.success("Price category added!");
                                document.getElementById('new-price-heading').value = '';
                                // Refresh the list
                                const response = await axios.get(`${API}/price-list`);
                                setPriceListHeadings(response.data.headings || []);
                              } catch (error) {
                                toast.error("Failed to add heading");
                              }
                            }}
                          >
                            <Plus className="w-4 h-4 mr-1" /> Add Category
                          </Button>
                        </div>
                      </div>

                      {/* Refresh & Existing Headings */}
                      <div className="border-t pt-4">
                        <div className="flex justify-between items-center mb-3">
                          <Label className="text-base font-semibold">Manage Price Categories & Items</Label>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={async () => {
                              try {
                                const response = await axios.get(`${API}/price-list`);
                                setPriceListHeadings(response.data.headings || []);
                                toast.success("Price list refreshed!");
                              } catch (error) {
                                toast.error("Failed to fetch price list");
                              }
                            }}
                          >
                            Refresh List
                          </Button>
                        </div>

                        {priceListHeadings.length > 0 ? (
                          <div className="space-y-4">
                            {priceListHeadings.map((heading, hIndex) => (
                              <div key={heading.id} className="border rounded-lg p-4 bg-gray-50">
                                {/* Heading Title with Edit/Delete */}
                                <div className="flex justify-between items-center mb-3 pb-2 border-b">
                                  {editingHeading === heading.id ? (
                                    <div className="flex gap-2 flex-1 mr-2">
                                      <Input
                                        id={`edit-heading-${heading.id}`}
                                        defaultValue={heading.name}
                                        className="flex-1"
                                      />
                                      <Button
                                        size="sm"
                                        onClick={async () => {
                                          const newName = document.getElementById(`edit-heading-${heading.id}`).value;
                                          try {
                                            await axios.put(`${API}/admin/price-list-heading/${heading.id}`, { name: newName });
                                            toast.success("Category updated!");
                                            setEditingHeading(null);
                                            const response = await axios.get(`${API}/price-list`);
                                            setPriceListHeadings(response.data.headings || []);
                                          } catch (error) {
                                            toast.error("Failed to update");
                                          }
                                        }}
                                      >
                                        Save
                                      </Button>
                                      <Button size="sm" variant="outline" onClick={() => setEditingHeading(null)}>Cancel</Button>
                                    </div>
                                  ) : (
                                    <>
                                      <h3 className="font-bold text-lg text-purple-700">{heading.name}</h3>
                                      <div className="flex gap-2">
                                        <Button size="sm" variant="outline" onClick={() => setEditingHeading(heading.id)}>
                                          <Edit className="w-3 h-3 mr-1" /> Edit
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="destructive"
                                          onClick={async () => {
                                            if (!confirm(`Delete "${heading.name}" and all its items?`)) return;
                                            try {
                                              await axios.delete(`${API}/admin/price-list-heading/${heading.id}`);
                                              toast.success("Category deleted!");
                                              setPriceListHeadings(priceListHeadings.filter(h => h.id !== heading.id));
                                            } catch (error) {
                                              toast.error("Failed to delete");
                                            }
                                          }}
                                        >
                                          <Trash2 className="w-3 h-3" />
                                        </Button>
                                      </div>
                                    </>
                                  )}
                                </div>

                                {/* Items under this heading */}
                                <div className="space-y-2 mb-3">
                                  {heading.items && heading.items.length > 0 ? (
                                    heading.items.map((item, iIndex) => (
                                      <div key={item.id} className="flex justify-between items-center p-2 bg-white rounded border">
                                        {editingItem === item.id ? (
                                          <div className="flex-1 grid grid-cols-4 gap-2 mr-2">
                                            <Input id={`edit-item-name-${item.id}`} defaultValue={item.name} placeholder="Name" />
                                            <Input id={`edit-item-detail-${item.id}`} defaultValue={item.detail} placeholder="Detail" />
                                            <Input id={`edit-item-price-${item.id}`} defaultValue={item.price} placeholder="Price" />
                                            <div className="flex gap-1">
                                              <Button
                                                size="sm"
                                                onClick={async () => {
                                                  const name = document.getElementById(`edit-item-name-${item.id}`).value;
                                                  const detail = document.getElementById(`edit-item-detail-${item.id}`).value;
                                                  const price = document.getElementById(`edit-item-price-${item.id}`).value;
                                                  try {
                                                    await axios.put(`${API}/admin/price-list-item/${item.id}`, { name, detail, price });
                                                    toast.success("Item updated!");
                                                    setEditingItem(null);
                                                    const response = await axios.get(`${API}/price-list`);
                                                    setPriceListHeadings(response.data.headings || []);
                                                  } catch (error) {
                                                    toast.error("Failed to update");
                                                  }
                                                }}
                                              >
                                                Save
                                              </Button>
                                              <Button size="sm" variant="outline" onClick={() => setEditingItem(null)}>✕</Button>
                                            </div>
                                          </div>
                                        ) : (
                                          <>
                                            <div className="flex-1">
                                              <p className="font-medium">{item.name}</p>
                                              <p className="text-xs text-gray-500">{item.detail}</p>
                                            </div>
                                            <div className="flex items-center gap-2">
                                              <span className="font-semibold text-green-600">Rs. {item.price}</span>
                                              <Button size="sm" variant="outline" onClick={() => setEditingItem(item.id)}>
                                                <Edit className="w-3 h-3" />
                                              </Button>
                                              <Button
                                                size="sm"
                                                variant="destructive"
                                                onClick={async () => {
                                                  try {
                                                    await axios.delete(`${API}/admin/price-list-item/${item.id}`);
                                                    toast.success("Item deleted!");
                                                    const response = await axios.get(`${API}/price-list`);
                                                    setPriceListHeadings(response.data.headings || []);
                                                  } catch (error) {
                                                    toast.error("Failed to delete");
                                                  }
                                                }}
                                              >
                                                <Trash2 className="w-3 h-3" />
                                              </Button>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    ))
                                  ) : (
                                    <p className="text-sm text-gray-400 italic">No items yet in this category</p>
                                  )}
                                </div>

                                {/* Add Item to this Heading */}
                                <div className="border-t pt-3">
                                  <p className="text-sm font-medium mb-2">Add Item to "{heading.name}"</p>
                                  <div className="grid grid-cols-4 gap-2">
                                    <Input id={`add-item-name-${heading.id}`} placeholder="Item Name" />
                                    <Input id={`add-item-detail-${heading.id}`} placeholder="Detail (optional)" />
                                    <Input id={`add-item-price-${heading.id}`} placeholder="Price (Rs.)" />
                                    <Button
                                      size="sm"
                                      onClick={async () => {
                                        const name = document.getElementById(`add-item-name-${heading.id}`).value;
                                        const detail = document.getElementById(`add-item-detail-${heading.id}`).value;
                                        const price = document.getElementById(`add-item-price-${heading.id}`).value;
                                        if (!name || !price) {
                                          toast.error("Name and price required");
                                          return;
                                        }
                                        try {
                                          await axios.post(`${API}/admin/price-list-heading/${heading.id}/item`, { name, detail, price });
                                          toast.success("Item added!");
                                          document.getElementById(`add-item-name-${heading.id}`).value = '';
                                          document.getElementById(`add-item-detail-${heading.id}`).value = '';
                                          document.getElementById(`add-item-price-${heading.id}`).value = '';
                                          const response = await axios.get(`${API}/price-list`);
                                          setPriceListHeadings(response.data.headings || []);
                                        } catch (error) {
                                          toast.error("Failed to add item");
                                        }
                                      }}
                                    >
                                      <Plus className="w-4 h-4 mr-1" /> Add
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500 italic p-4 text-center border rounded bg-gray-50">
                            No price categories yet. Click "Refresh List" to load existing data or add a new category above.
                          </p>
                        )}
                      </div>

                      <p className="text-sm text-gray-500 bg-blue-50 p-3 rounded">
                        <strong>How it works:</strong> Each category (heading) will appear as a separate slide on the bridal services page. 
                        Users can navigate between categories using left/right arrows.
                      </p>
                    </CardContent>
                  </Card>

                  {/* Real Bride Stories Management */}
                  <Card>
                    <CardHeader>
                      <CardTitle>Real Bride Stories (Video Slider)</CardTitle>
                      <CardDescription>Manage up to 6 bride story videos displayed as a slider. Users navigate manually with arrows. Each story has a thumbnail image, full video (250MB max), bride name, date, and subtitle.</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                      {/* Add New Story */}
                      <div className="border rounded-lg p-4 bg-gray-50">
                        <Label className="text-base font-semibold mb-3 block">Add New Bride Story (Max 6)</Label>
                        <div className="grid md:grid-cols-2 gap-4">
                          <div>
                            <Label htmlFor="story-bride-name">Bride Name</Label>
                            <Input
                              id="story-bride-name"
                              type="text"
                              placeholder="e.g., PRIYA"
                              className="mt-1"
                            />
                          </div>
                          <div>
                            <Label htmlFor="story-makeup-date">Makeup Date</Label>
                            <Input
                              id="story-makeup-date"
                              type="text"
                              placeholder="e.g., 15 Jan 2025"
                              className="mt-1"
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <Label htmlFor="story-subtitle">Subtitle Text</Label>
                          <Input
                            id="story-subtitle"
                            type="text"
                            placeholder="e.g., A beautiful journey of love and celebration"
                            className="mt-1"
                          />
                        </div>
                        <div className="grid md:grid-cols-2 gap-4 mt-3">
                          <div>
                            <div className="flex items-center justify-between mb-1">
                              <Label>Thumbnail Image</Label>
                              <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                                <button
                                  type="button"
                                  id="thumb-mode-file"
                                  onClick={() => {
                                    document.getElementById('story-thumbnail-file').classList.remove('hidden');
                                    document.getElementById('story-thumbnail-url').classList.add('hidden');
                                    document.getElementById('thumb-mode-file').classList.add('bg-white', 'shadow');
                                    document.getElementById('thumb-mode-url').classList.remove('bg-white', 'shadow');
                                  }}
                                  className="px-2 py-1 rounded-md bg-white shadow"
                                >
                                  📁
                                </button>
                                <button
                                  type="button"
                                  id="thumb-mode-url"
                                  onClick={() => {
                                    document.getElementById('story-thumbnail-file').classList.add('hidden');
                                    document.getElementById('story-thumbnail-url').classList.remove('hidden');
                                    document.getElementById('thumb-mode-url').classList.add('bg-white', 'shadow');
                                    document.getElementById('thumb-mode-file').classList.remove('bg-white', 'shadow');
                                  }}
                                  className="px-2 py-1 rounded-md"
                                >
                                  🔗
                                </button>
                              </div>
                            </div>
                            <Input
                              id="story-thumbnail-file"
                              type="file"
                              accept="image/jpeg,image/png,image/webp"
                            />
                            <Input
                              id="story-thumbnail-url"
                              type="url"
                              placeholder="Image URL..."
                              className="hidden"
                            />
                          </div>
                          <div>
                            <div className="flex items-center justify-between mb-1">
                              <Label>Full Video</Label>
                              <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                                <button
                                  type="button"
                                  id="fullvid-mode-file"
                                  onClick={() => {
                                    document.getElementById('story-full-video-file').classList.remove('hidden');
                                    document.getElementById('story-full-video-url').classList.add('hidden');
                                    document.getElementById('fullvid-mode-file').classList.add('bg-white', 'shadow');
                                    document.getElementById('fullvid-mode-url').classList.remove('bg-white', 'shadow');
                                  }}
                                  className="px-2 py-1 rounded-md bg-white shadow"
                                >
                                  📁
                                </button>
                                <button
                                  type="button"
                                  id="fullvid-mode-url"
                                  onClick={() => {
                                    document.getElementById('story-full-video-file').classList.add('hidden');
                                    document.getElementById('story-full-video-url').classList.remove('hidden');
                                    document.getElementById('fullvid-mode-url').classList.add('bg-white', 'shadow');
                                    document.getElementById('fullvid-mode-file').classList.remove('bg-white', 'shadow');
                                  }}
                                  className="px-2 py-1 rounded-md"
                                >
                                  🔗
                                </button>
                              </div>
                            </div>
                            <Input
                              id="story-full-video-file"
                              type="file"
                              accept="video/mp4,video/quicktime,.mov"
                            />
                            <Input
                              id="story-full-video-url"
                              type="url"
                              placeholder="Video URL..."
                              className="hidden"
                            />
                          </div>
                        </div>
                        <p className="text-xs text-gray-400 mt-2">Max 5MB for thumbnail, 350MB for video, or paste URLs from cloud storage</p>
                        <Button
                          id="upload-story-btn"
                          className="mt-4"
                          onClick={async () => {
                            const thumbnailFileInput = document.getElementById('story-thumbnail-file');
                            const thumbnailUrlInput = document.getElementById('story-thumbnail-url');
                            const fullVideoFileInput = document.getElementById('story-full-video-file');
                            const fullVideoUrlInput = document.getElementById('story-full-video-url');
                            const brideName = document.getElementById('story-bride-name').value;
                            const makeupDate = document.getElementById('story-makeup-date').value;
                            const subtitle = document.getElementById('story-subtitle').value;
                            const uploadBtn = document.getElementById('upload-story-btn');
                            
                            const isThumbUrlMode = !document.getElementById('story-thumbnail-url').classList.contains('hidden');
                            const isVideoUrlMode = !document.getElementById('story-full-video-url').classList.contains('hidden');
                            
                            if (!brideName || !makeupDate) {
                              toast.error("Please enter Bride Name and Makeup Date");
                              return;
                            }

                            if (brideStories.length >= 6) {
                              toast.error("Maximum 6 stories allowed. Delete one to add more.");
                              return;
                            }

                            const thumbnailFile = thumbnailFileInput?.files?.[0];
                            const fullVideoFile = fullVideoFileInput?.files?.[0];
                            const thumbnailUrl = thumbnailUrlInput?.value?.trim();
                            const fullVideoUrl = fullVideoUrlInput?.value?.trim();

                            if (!isThumbUrlMode && thumbnailFile && thumbnailFile.size > 5 * 1024 * 1024) {
                              toast.error("Thumbnail too large. Maximum size is 5MB");
                              return;
                            }

                            if (!isVideoUrlMode && fullVideoFile && fullVideoFile.size > 350 * 1024 * 1024) {
                              toast.error("Full video too large. Maximum size is 350MB");
                              return;
                            }

                            uploadBtn.disabled = true;
                            uploadBtn.innerText = "Uploading...";
                            toast.info("Uploading, please wait...");

                            try {
                              let thumbnailData = "";
                              let fullVideoData = "";

                              // Get thumbnail data
                              if (isThumbUrlMode && thumbnailUrl) {
                                thumbnailData = thumbnailUrl;
                              } else if (thumbnailFile) {
                                thumbnailData = await new Promise((resolve, reject) => {
                                  const reader = new FileReader();
                                  reader.onloadend = () => resolve(reader.result);
                                  reader.onerror = reject;
                                  reader.readAsDataURL(thumbnailFile);
                                });
                              }

                              // Get full video data
                              if (isVideoUrlMode && fullVideoUrl) {
                                fullVideoData = fullVideoUrl;
                              } else if (fullVideoFile) {
                                toast.info("Processing full video, this may take a moment...");
                                fullVideoData = await new Promise((resolve, reject) => {
                                  const reader = new FileReader();
                                  reader.onloadend = () => resolve(reader.result);
                                  reader.onerror = reject;
                                  reader.readAsDataURL(fullVideoFile);
                                });
                              }

                              await axios.post(`${API}/admin/bride-story`, {
                                video: thumbnailData,
                                fullVideo: fullVideoData,
                                brideName: brideName,
                                makeupDate: makeupDate,
                                subtitle: subtitle || "A beautiful bride story"
                              }, {
                                timeout: 300000,
                                maxContentLength: 500 * 1024 * 1024,
                                maxBodyLength: 500 * 1024 * 1024
                              });

                              toast.success("Bride story added!");
                              document.getElementById('story-bride-name').value = '';
                              document.getElementById('story-makeup-date').value = '';
                              document.getElementById('story-subtitle').value = '';
                              if (thumbnailFileInput) thumbnailFileInput.value = '';
                              if (fullVideoFileInput) fullVideoFileInput.value = '';
                              if (thumbnailUrlInput) thumbnailUrlInput.value = '';
                              if (fullVideoUrlInput) fullVideoUrlInput.value = '';
                              
                              const response = await axios.get(`${API}/bride-stories`);
                              setBrideStories(response.data.stories || []);
                            } catch (error) {
                              console.error("Upload error:", error);
                              toast.error(error.response?.data?.detail || error.message || "Failed to add story");
                            } finally {
                              uploadBtn.disabled = false;
                              uploadBtn.innerText = "Add Bride Story";
                            }
                          }}
                        >
                          <Plus className="w-4 h-4 mr-2" /> Add Bride Story
                        </Button>
                      </div>

                      {/* Existing Stories List */}
                      <div className="border-t pt-4">
                        <div className="flex justify-between items-center mb-3">
                          <Label className="text-base font-semibold">Current Bride Stories ({brideStories.length}/6)</Label>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={async () => {
                              try {
                                const response = await axios.get(`${API}/bride-stories`);
                                setBrideStories(response.data.stories || []);
                                toast.success("Stories refreshed!");
                              } catch (error) {
                                toast.error("Failed to fetch stories");
                              }
                            }}
                          >
                            Refresh List
                          </Button>
                        </div>

                        {brideStories.length > 0 ? (
                          <div className="space-y-3">
                            {brideStories.map((story, index) => (
                              <div key={story.id} className="p-4 border rounded-lg bg-white">
                                <div className="flex items-start gap-4">
                                  {/* Thumbnail Preview */}
                                  <div className="w-24 h-32 bg-gray-100 rounded overflow-hidden flex-shrink-0">
                                    {story.video ? (
                                      <img 
                                        src={story.video.startsWith('/api') ? `${process.env.REACT_APP_BACKEND_URL || ''}${story.video}` : story.video}
                                        alt={story.brideName}
                                        className="w-full h-full object-cover"
                                        onError={(e) => { e.target.style.display = 'none'; }}
                                      />
                                    ) : (
                                      <div className="w-full h-full flex items-center justify-center text-gray-400 text-xs">No Image</div>
                                    )}
                                  </div>
                                  
                                  {/* Story Info */}
                                  <div className="flex-1 min-w-0">
                                    {editingStory === story.id ? (
                                      <div className="space-y-2">
                                        <div className="grid grid-cols-2 gap-2">
                                          <Input
                                            id={`edit-story-name-${story.id}`}
                                            defaultValue={story.brideName}
                                            placeholder="Bride Name"
                                            className="text-sm"
                                          />
                                          <Input
                                            id={`edit-story-date-${story.id}`}
                                            defaultValue={story.makeupDate}
                                            placeholder="Makeup Date"
                                            className="text-sm"
                                          />
                                        </div>
                                        <Input
                                          id={`edit-story-subtitle-${story.id}`}
                                          defaultValue={story.subtitle}
                                          placeholder="Subtitle"
                                          className="text-sm"
                                        />
                                        <div className="flex gap-2">
                                          <Button
                                            size="sm"
                                            onClick={async () => {
                                              const newName = document.getElementById(`edit-story-name-${story.id}`).value;
                                              const newDate = document.getElementById(`edit-story-date-${story.id}`).value;
                                              const newSubtitle = document.getElementById(`edit-story-subtitle-${story.id}`).value;
                                              try {
                                                await axios.put(`${API}/admin/bride-story/${story.id}`, {
                                                  brideName: newName,
                                                  makeupDate: newDate,
                                                  subtitle: newSubtitle
                                                });
                                                toast.success("Story updated!");
                                                setEditingStory(null);
                                                const response = await axios.get(`${API}/bride-stories`);
                                                setBrideStories(response.data.stories || []);
                                              } catch (error) {
                                                toast.error("Failed to update");
                                              }
                                            }}
                                          >
                                            Save
                                          </Button>
                                          <Button size="sm" variant="outline" onClick={() => setEditingStory(null)}>Cancel</Button>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <p className="font-bold text-base">{story.brideName || `Story #${index + 1}`}</p>
                                        <p className="text-sm text-gray-500">{story.makeupDate}</p>
                                        <p className="text-xs text-gray-400 mt-1 truncate">{story.subtitle}</p>
                                        <div className="flex items-center gap-2 mt-2">
                                          <span className={`text-xs px-2 py-0.5 rounded ${story.fullVideo ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}>
                                            {story.fullVideo ? 'Full Video ✓' : 'No Full Video'}
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  
                                  {/* Actions */}
                                  {editingStory !== story.id && (
                                    <div className="flex flex-col gap-2">
                                      <Button size="sm" variant="outline" onClick={() => setEditingStory(story.id)}>
                                        <Edit className="w-3 h-3 mr-1" /> Edit
                                      </Button>
                                      <Button
                                        size="sm"
                                        variant="destructive"
                                        onClick={async () => {
                                          if (!confirm("Delete this bride story?")) return;
                                          try {
                                            await axios.delete(`${API}/admin/bride-story/${story.id}`);
                                            toast.success("Story deleted!");
                                            setBrideStories(brideStories.filter(s => s.id !== story.id));
                                          } catch (error) {
                                            toast.error("Failed to delete");
                                          }
                                        }}
                                      >
                                        <Trash2 className="w-3 h-3 mr-1" /> Delete
                                      </Button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500 italic p-4 text-center border rounded bg-gray-50">
                            No bride stories yet. Click "Refresh List" to load existing or add new stories above.
                          </p>
                        )}
                      </div>

                      <p className="text-sm text-gray-500 bg-purple-50 p-3 rounded">
                        <strong>Display:</strong> "REAL BRIDES STORIES" appears as heading above the slider. Each slide shows bride name, date, and a "WATCH FULL VIDEO" button (if full video is uploaded). Thumbnail is used for the slide image.
                      </p>
                    </CardContent>
                  </Card>

                  {/* INSPIRING BRIDE LOOKS Section Management */}
                  <Card>
                    <CardHeader>
                      <CardTitle>Inspiring Bride Looks (Rolling Carousel)</CardTitle>
                      <CardDescription>Manage the auto-scrolling carousel of bride look images in the "INSPIRING BRIDE LOOKS FOR 2026" section</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                      {/* Add New Look */}
                      <div className="border rounded-lg p-4 bg-gray-50">
                        <Label className="text-base font-semibold mb-3 block">Add New Bride Look</Label>
                        <div className="grid md:grid-cols-2 gap-4">
                          <div>
                            <Label htmlFor="look-name">Bride Name</Label>
                            <Input
                              id="look-name"
                              type="text"
                              placeholder="e.g., PRIYA"
                              className="mt-1"
                            />
                          </div>
                          <div>
                            <div className="flex items-center justify-between mb-1">
                              <Label>Bride Image</Label>
                              <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                                <button
                                  type="button"
                                  id="look-mode-file"
                                  onClick={() => {
                                    document.getElementById('look-image-file').classList.remove('hidden');
                                    document.getElementById('look-image-url').classList.add('hidden');
                                    document.getElementById('look-mode-file').classList.add('bg-white', 'shadow');
                                    document.getElementById('look-mode-url').classList.remove('bg-white', 'shadow');
                                  }}
                                  className="px-2 py-1 rounded-md bg-white shadow"
                                >
                                  📁 File
                                </button>
                                <button
                                  type="button"
                                  id="look-mode-url"
                                  onClick={() => {
                                    document.getElementById('look-image-file').classList.add('hidden');
                                    document.getElementById('look-image-url').classList.remove('hidden');
                                    document.getElementById('look-mode-url').classList.add('bg-white', 'shadow');
                                    document.getElementById('look-mode-file').classList.remove('bg-white', 'shadow');
                                  }}
                                  className="px-2 py-1 rounded-md"
                                >
                                  🔗 URL
                                </button>
                              </div>
                            </div>
                            <Input
                              id="look-image-file"
                              type="file"
                              accept="image/jpeg,image/png,image/webp"
                            />
                            <Input
                              id="look-image-url"
                              type="url"
                              placeholder="Paste image URL..."
                              className="hidden"
                            />
                          </div>
                        </div>
                        <Button
                          className="mt-3"
                          onClick={async () => {
                            const fileInput = document.getElementById('look-image-file');
                            const urlInput = document.getElementById('look-image-url');
                            const isUrlMode = !document.getElementById('look-image-url').classList.contains('hidden');
                            const name = document.getElementById('look-name').value;
                            
                            if (!name) {
                              toast.error("Please enter bride name");
                              return;
                            }
                            
                            if (isUrlMode) {
                              const url = urlInput.value.trim();
                              if (!url) {
                                toast.error("Please enter an image URL");
                                return;
                              }
                              
                              try {
                                await axios.post(`${API}/admin/inspiring-bride-look`, {
                                  image: url,
                                  name: name
                                });
                                toast.success("Bride look added!");
                                document.getElementById('look-name').value = '';
                                urlInput.value = '';
                                const response = await axios.get(`${API}/inspiring-bride-looks`);
                                setInspiringBrideLooks(response.data.looks || []);
                              } catch (error) {
                                toast.error(error.response?.data?.detail || "Failed to add");
                              }
                            } else {
                              const file = fileInput?.files?.[0];
                              
                              if (!file) {
                                toast.error("Please select an image");
                                return;
                              }
                              
                              if (file.size > 5 * 1024 * 1024) {
                                toast.error("Image too large. Maximum size is 5MB");
                                return;
                              }
                              
                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                try {
                                  await axios.post(`${API}/admin/inspiring-bride-look`, {
                                    image: reader.result,
                                    name: name
                                  });
                                  toast.success("Bride look added!");
                                  document.getElementById('look-name').value = '';
                                  fileInput.value = '';
                                  const response = await axios.get(`${API}/inspiring-bride-looks`);
                                  setInspiringBrideLooks(response.data.looks || []);
                                } catch (error) {
                                  toast.error(error.response?.data?.detail || "Failed to add");
                                }
                              };
                              reader.readAsDataURL(file);
                            }
                          }}
                        >
                          <Plus className="w-4 h-4 mr-2" /> Add Bride Look
                        </Button>
                      </div>

                      {/* Existing Looks */}
                      <div className="border-t pt-4">
                        <div className="flex justify-between items-center mb-3">
                          <Label className="text-base font-semibold">Current Bride Looks</Label>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={async () => {
                              try {
                                const response = await axios.get(`${API}/inspiring-bride-looks`);
                                setInspiringBrideLooks(response.data.looks || []);
                                toast.success("Refreshed!");
                              } catch (error) {
                                toast.error("Failed to fetch");
                              }
                            }}
                          >
                            Refresh List
                          </Button>
                        </div>

                        {inspiringBrideLooks.length > 0 ? (
                          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
                            {inspiringBrideLooks.map((look, index) => (
                              <div key={look.id || index} className="relative border rounded-lg overflow-hidden bg-white">
                                <div className="h-28 bg-gray-100">
                                  {look.image ? (
                                    <img src={look.image} alt={look.name} className="w-full h-full object-cover" />
                                  ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-400 text-3xl">👰</div>
                                  )}
                                </div>
                                <div className="p-2">
                                  {editingLook === look.id ? (
                                    <div className="space-y-1">
                                      <Input
                                        id={`edit-look-name-${look.id}`}
                                        defaultValue={look.name}
                                        className="text-xs"
                                      />
                                      <div className="flex gap-1">
                                        <Button
                                          size="sm"
                                          className="text-xs flex-1"
                                          onClick={async () => {
                                            const newName = document.getElementById(`edit-look-name-${look.id}`).value;
                                            try {
                                              await axios.put(`${API}/admin/inspiring-bride-look/${look.id}`, { name: newName });
                                              toast.success("Updated!");
                                              setEditingLook(null);
                                              const response = await axios.get(`${API}/inspiring-bride-looks`);
                                              setInspiringBrideLooks(response.data.looks || []);
                                            } catch (error) {
                                              toast.error("Failed to update");
                                            }
                                          }}
                                        >
                                          Save
                                        </Button>
                                        <Button size="sm" variant="outline" className="text-xs" onClick={() => setEditingLook(null)}>✕</Button>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <p className="font-medium text-xs text-center truncate">{look.name}</p>
                                      <div className="flex gap-1 mt-1">
                                        <Button size="sm" variant="outline" className="text-xs flex-1 p-1" onClick={() => setEditingLook(look.id)}>
                                          <Edit className="w-3 h-3" />
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="destructive"
                                          className="text-xs flex-1 p-1"
                                          onClick={async () => {
                                            if (!confirm("Delete this look?")) return;
                                            try {
                                              await axios.delete(`${API}/admin/inspiring-bride-look/${look.id}`);
                                              toast.success("Deleted!");
                                              setInspiringBrideLooks(inspiringBrideLooks.filter(l => l.id !== look.id));
                                            } catch (error) {
                                              toast.error("Failed to delete");
                                            }
                                          }}
                                        >
                                          <Trash2 className="w-3 h-3" />
                                        </Button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500 italic p-4 text-center border rounded bg-gray-50">
                            No bride looks yet. Click "Refresh List" to load or add new looks above.
                          </p>
                        )}
                      </div>

                      <p className="text-sm text-gray-500 bg-rose-50 p-3 rounded">
                        This section auto-scrolls through bride looks in a rolling carousel. Ideal for showcasing model brides or inspiration looks.
                      </p>
                    </CardContent>
                  </Card>

                  {/* THE MAKEUP PROCESS Section Management */}
                  <Card>
                    <CardHeader>
                      <CardTitle>The Makeup Process Section</CardTitle>
                      <CardDescription>Manage the video and accordion content for "THE MAKEUP PROCESS" section</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                      {/* Video Upload */}
                      <div className="border-b pb-4">
                        <div className="flex justify-between items-center mb-3">
                          <Label className="text-base font-semibold">Process Video</Label>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={async () => {
                              try {
                                const response = await axios.get(`${API}/makeup-process-video`);
                                setMakeupProcessVideo(response.data.video || null);
                                setMakeupProcessAccordion(response.data.accordion || []);
                                toast.success("Refreshed!");
                              } catch (error) {
                                toast.error("Failed to fetch");
                              }
                            }}
                          >
                            Refresh
                          </Button>
                        </div>
                        
                        {makeupProcessVideo ? (
                          <div className="flex items-center gap-4 p-3 border rounded-lg bg-gray-50">
                            <div className="w-32 h-20 bg-black rounded overflow-hidden flex-shrink-0">
                              <video 
                                src={makeupProcessVideo.startsWith('/api') ? `${process.env.REACT_APP_BACKEND_URL || ''}${makeupProcessVideo}` : makeupProcessVideo}
                                className="w-full h-full object-cover"
                                muted
                              />
                            </div>
                            <div className="flex-1">
                              <p className="font-medium text-sm">Makeup Process Video</p>
                              <p className="text-xs text-gray-500">Currently uploaded</p>
                            </div>
                            <Button
                              size="sm"
                              variant="destructive"
                              onClick={async () => {
                                if (!confirm("Delete this video?")) return;
                                try {
                                  await axios.delete(`${API}/admin/makeup-process-video`);
                                  toast.success("Deleted!");
                                  setMakeupProcessVideo(null);
                                } catch (error) {
                                  toast.error("Failed to delete");
                                }
                              }}
                            >
                              <Trash2 className="w-4 h-4 mr-1" /> Delete
                            </Button>
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500 italic p-4 text-center border rounded bg-gray-50">
                            No video uploaded. Click "Refresh" to check or upload below.
                          </p>
                        )}

                        {/* Upload New Video */}
                        <div className="mt-4">
                          <Label htmlFor="process-video">Upload Video (MP4, MOV, max 50MB)</Label>
                          <Input
                            id="process-video"
                            type="file"
                            accept="video/mp4,video/quicktime,.mov"
                            className="mt-2"
                          />
                          <Button
                            className="mt-3"
                            id="upload-process-btn"
                            onClick={async () => {
                              const fileInput = document.getElementById('process-video');
                              const file = fileInput?.files?.[0];
                              const uploadBtn = document.getElementById('upload-process-btn');
                              
                              if (!file) {
                                toast.error("Please select a video file");
                                return;
                              }
                              
                              if (file.size > 50 * 1024 * 1024) {
                                toast.error("Video too large. Maximum size is 50MB");
                                return;
                              }

                              uploadBtn.disabled = true;
                              uploadBtn.innerText = "Uploading...";
                              toast.info("Uploading video, please wait...");
                              
                              const reader = new FileReader();
                              reader.onloadend = async () => {
                                try {
                                  await axios.post(`${API}/admin/makeup-process-video`, {
                                    video: reader.result
                                  }, { timeout: 120000 });
                                  toast.success("Video uploaded!");
                                  fileInput.value = '';
                                  const response = await axios.get(`${API}/makeup-process-video`);
                                  setMakeupProcessVideo(response.data.video || null);
                                } catch (error) {
                                  toast.error(error.response?.data?.detail || "Failed to upload");
                                } finally {
                                  uploadBtn.disabled = false;
                                  uploadBtn.innerText = "Upload Video";
                                }
                              };
                              reader.readAsDataURL(file);
                            }}
                          >
                            <Upload className="w-4 h-4 mr-2" /> Upload Video
                          </Button>
                        </div>
                      </div>

                      <p className="text-sm text-gray-500 bg-indigo-50 p-3 rounded">
                        The video plays behind a "BOOK AN APPOINTMENT" button.
                      </p>
                      
                      {/* Accordion Steps - Editable */}
                      <div className="border-t pt-4">
                        <div className="flex justify-between items-center mb-3">
                          <Label className="text-base font-semibold">Process Steps (Accordion)</Label>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={() => {
                              setMakeupProcessAccordion([
                                ...makeupProcessAccordion,
                                { id: Date.now().toString(), title: "New Step", description: "Step description" }
                              ]);
                            }}
                          >
                            <Plus className="w-4 h-4 mr-1" /> Add Step
                          </Button>
                        </div>
                        
                        {makeupProcessAccordion && makeupProcessAccordion.length > 0 ? (
                          <div className="space-y-3">
                            {makeupProcessAccordion.map((step, idx) => (
                              <div key={step.id || idx} className="border rounded-lg p-3 bg-gray-50">
                                <div className="flex justify-between items-start gap-2">
                                  <div className="flex-1 space-y-2">
                                    <Input 
                                      placeholder="Step Title (e.g., Initial Consultation)"
                                      value={step.title || ""}
                                      onChange={(e) => {
                                        const updated = [...makeupProcessAccordion];
                                        updated[idx].title = e.target.value;
                                        setMakeupProcessAccordion(updated);
                                      }}
                                      className="font-semibold"
                                    />
                                    <Textarea 
                                      placeholder="Step Description"
                                      value={step.description || ""}
                                      onChange={(e) => {
                                        const updated = [...makeupProcessAccordion];
                                        updated[idx].description = e.target.value;
                                        setMakeupProcessAccordion(updated);
                                      }}
                                      rows={2}
                                    />
                                  </div>
                                  <Button 
                                    variant="destructive" 
                                    size="sm"
                                    onClick={() => {
                                      setMakeupProcessAccordion(makeupProcessAccordion.filter((_, i) => i !== idx));
                                    }}
                                  >
                                    <Trash2 className="w-4 h-4" />
                                  </Button>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500 italic text-center p-4 border rounded">
                            No steps defined. Click "Add Step" to create accordion items.
                          </p>
                        )}
                        
                        <Button 
                          className="w-full mt-4"
                          onClick={async () => {
                            try {
                              await axios.post(`${API}/admin/makeup-process-accordion`, { accordion: makeupProcessAccordion });
                              toast.success("Steps saved!");
                            } catch (error) {
                              toast.error("Failed to save steps");
                            }
                          }}
                        >
                          Save Process Steps
                        </Button>
                      </div>
                    </CardContent>
                  </Card>

                  {/* THE ARTIST HERSELF Section Management */}
                  <Card>
                    <CardHeader>
                      <CardTitle>The Artist Herself Section</CardTitle>
                      <CardDescription>Manage artist photos and bio text for "THE ARTIST HERSELF" section</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                      {/* Artist Images */}
                      <div className="border-b pb-4">
                        <div className="flex justify-between items-center mb-3">
                          <Label className="text-base font-semibold">Artist Photos (Slider)</Label>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={async () => {
                              try {
                                const response = await axios.get(`${API}/artist-data`);
                                setArtistImages(response.data.images || []);
                                setArtistBio({
                                  intro: response.data.intro || "",
                                  outro: response.data.outro || ""
                                });
                                toast.success("Refreshed!");
                              } catch (error) {
                                toast.error("Failed to fetch");
                              }
                            }}
                          >
                            Refresh
                          </Button>
                        </div>

                        {/* Add New Image */}
                        <div className="space-y-2 mb-4">
                          <div className="flex items-center justify-between">
                            <Label>Add Artist Photo</Label>
                            <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5 text-xs">
                              <button
                                type="button"
                                id="artist-mode-file"
                                onClick={() => {
                                  document.getElementById('artist-image-file').classList.remove('hidden');
                                  document.getElementById('artist-image-url').classList.add('hidden');
                                  document.getElementById('artist-mode-file').classList.add('bg-white', 'shadow');
                                  document.getElementById('artist-mode-url').classList.remove('bg-white', 'shadow');
                                }}
                                className="px-2 py-1 rounded-md bg-white shadow"
                              >
                                📁 File
                              </button>
                              <button
                                type="button"
                                id="artist-mode-url"
                                onClick={() => {
                                  document.getElementById('artist-image-file').classList.add('hidden');
                                  document.getElementById('artist-image-url').classList.remove('hidden');
                                  document.getElementById('artist-mode-url').classList.add('bg-white', 'shadow');
                                  document.getElementById('artist-mode-file').classList.remove('bg-white', 'shadow');
                                }}
                                className="px-2 py-1 rounded-md"
                              >
                                🔗 URL
                              </button>
                            </div>
                          </div>
                          <div className="flex gap-3">
                            <Input
                              id="artist-image-file"
                              type="file"
                              accept="image/jpeg,image/png,image/webp"
                              className="flex-1"
                            />
                            <Input
                              id="artist-image-url"
                              type="url"
                              placeholder="Paste image URL..."
                              className="flex-1 hidden"
                            />
                            <Button
                              onClick={async () => {
                                const fileInput = document.getElementById('artist-image-file');
                                const urlInput = document.getElementById('artist-image-url');
                                const isUrlMode = !document.getElementById('artist-image-url').classList.contains('hidden');
                                
                                if (isUrlMode) {
                                  const url = urlInput.value.trim();
                                  if (!url) {
                                    toast.error("Please enter an image URL");
                                    return;
                                  }
                                  
                                  try {
                                    await axios.post(`${API}/admin/artist-image`, { image: url });
                                    toast.success("Image added!");
                                    urlInput.value = '';
                                    const response = await axios.get(`${API}/artist-data`);
                                    setArtistImages(response.data.images || []);
                                  } catch (error) {
                                    toast.error(error.response?.data?.detail || "Failed to add");
                                  }
                                } else {
                                  const file = fileInput?.files?.[0];
                                  
                                  if (!file) {
                                    toast.error("Please select an image");
                                    return;
                                  }
                                  
                                  if (file.size > 5 * 1024 * 1024) {
                                    toast.error("Image too large. Maximum 5MB");
                                    return;
                                  }
                                  
                                  const reader = new FileReader();
                                  reader.onloadend = async () => {
                                    try {
                                      await axios.post(`${API}/admin/artist-image`, { image: reader.result });
                                      toast.success("Image added!");
                                      fileInput.value = '';
                                      const response = await axios.get(`${API}/artist-data`);
                                      setArtistImages(response.data.images || []);
                                    } catch (error) {
                                      toast.error(error.response?.data?.detail || "Failed to add");
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                }
                              }}
                            >
                              <Plus className="w-4 h-4 mr-2" /> Add Image
                            </Button>
                          </div>
                        </div>

                        {/* Images Grid */}
                        {artistImages.length > 0 ? (
                          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                            {artistImages.map((img, index) => (
                              <div key={img.id || index} className="relative border rounded-lg overflow-hidden bg-white">
                                <div className="h-24 bg-gray-100">
                                  {img.image ? (
                                    <img src={img.image} alt={`Artist ${index + 1}`} className="w-full h-full object-cover" />
                                  ) : (
                                    <div className="w-full h-full flex items-center justify-center text-gray-400">No Image</div>
                                  )}
                                </div>
                                <div className="p-1">
                                  <Button
                                    size="sm"
                                    variant="destructive"
                                    className="w-full text-xs"
                                    onClick={async () => {
                                      if (!confirm("Delete this image?")) return;
                                      try {
                                        await axios.delete(`${API}/admin/artist-image/${img.id}`);
                                        toast.success("Deleted!");
                                        setArtistImages(artistImages.filter(i => i.id !== img.id));
                                      } catch (error) {
                                        toast.error("Failed to delete");
                                      }
                                    }}
                                  >
                                    <Trash2 className="w-3 h-3 mr-1" /> Delete
                                  </Button>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-sm text-gray-500 italic p-4 text-center border rounded bg-gray-50">
                            No artist images yet. Click "Refresh" to load or add new images above.
                          </p>
                        )}
                      </div>

                      {/* Bio Text */}
                      <div>
                        <Label className="text-base font-semibold mb-3 block">Artist Bio Text</Label>
                        <div className="space-y-4">
                          <div>
                            <Label htmlFor="artist-intro">Intro Paragraph (above photos)</Label>
                            <Textarea
                              id="artist-intro"
                              value={artistBio.intro}
                              onChange={(e) => setArtistBio({ ...artistBio, intro: e.target.value })}
                              placeholder="Meet Aradhana, a passionate makeup artist..."
                              className="mt-1"
                              rows={3}
                            />
                          </div>
                          <div>
                            <Label htmlFor="artist-outro">Outro Paragraph (below photos)</Label>
                            <Textarea
                              id="artist-outro"
                              value={artistBio.outro}
                              onChange={(e) => setArtistBio({ ...artistBio, outro: e.target.value })}
                              placeholder="With a keen eye for detail..."
                              className="mt-1"
                              rows={3}
                            />
                          </div>
                          <Button
                            onClick={async () => {
                              try {
                                await axios.put(`${API}/admin/artist-bio`, artistBio);
                                toast.success("Bio updated!");
                              } catch (error) {
                                toast.error("Failed to update bio");
                              }
                            }}
                          >
                            Save Bio Text
                          </Button>
                        </div>
                      </div>

                      <p className="text-sm text-gray-500 bg-amber-50 p-3 rounded">
                        This section displays artist photos in a slider with intro/outro paragraphs. Perfect for showcasing the makeup artist's personality and story.
                      </p>
                    </CardContent>
                  </Card>
                </div>
              </TabsContent>

              {/* Portfolio Management Tab */}
              <TabsContent value="portfolio">
                <div className="space-y-6">
                  <Card>
                    <CardHeader>
                      <CardTitle>Portfolio Pages Management</CardTitle>
                      <CardDescription>Upload and manage content for all portfolio pages</CardDescription>
                    </CardHeader>
                    <CardContent>
                      {/* Page Selector */}
                      <div className="flex flex-wrap gap-2 mb-6">
                        {[
                          { value: "class-videos", label: "Class Videos" },
                          { value: "bridal-portfolio", label: "Bridal Portfolio" },
                          { value: "model-portfolio", label: "Model Portfolio" },
                          { value: "more-reviews", label: "More Reviews" },
                          { value: "more-bride-stories", label: "More Bride Stories" },
                          { value: "trendy-hairstyles", label: "Trendy Hairstyles" }
                        ].map((page) => (
                          <Button
                            key={page.value}
                            variant={selectedPortfolioPage === page.value ? "default" : "outline"}
                            onClick={() => {
                              setSelectedPortfolioPage(page.value);
                              loadPortfolioItems(page.value);
                            }}
                            size="sm"
                          >
                            {page.label}
                          </Button>
                        ))}
                      </div>

                      {/* Category selector for bridal-portfolio */}
                      {selectedPortfolioPage === "bridal-portfolio" && (
                        <div className="mb-4">
                          <Label>Category</Label>
                          <Select 
                            value={portfolioUploadForm.category} 
                            onValueChange={(val) => setPortfolioUploadForm({...portfolioUploadForm, category: val})}
                          >
                            <SelectTrigger className="w-full mt-1">
                              <SelectValue placeholder="Select category" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="bridal-makeup">Bridal Makeup</SelectItem>
                              <SelectItem value="reception-makeup">Reception Makeup</SelectItem>
                              <SelectItem value="engagement-makeup">Engagement Makeup</SelectItem>
                              <SelectItem value="glam-party-makeup">Glam & Party Makeup</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                      )}

                      {/* Upload Form */}
                      <div className="border rounded-lg p-4 bg-gray-50 mb-6">
                        <h4 className="font-semibold mb-3">Add New Item</h4>
                        <div className="grid md:grid-cols-2 gap-4">
                          <div>
                            <Label>Media Type</Label>
                            <Select 
                              value={portfolioUploadForm.media_type} 
                              onValueChange={(val) => setPortfolioUploadForm({...portfolioUploadForm, media_type: val})}
                            >
                              <SelectTrigger className="mt-1">
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="image">Image</SelectItem>
                                <SelectItem value="video">Video</SelectItem>
                              </SelectContent>
                            </Select>
                          </div>
                          <div>
                            <Label>File Upload</Label>
                            <Input 
                              type="file" 
                              accept={portfolioUploadForm.media_type === "video" ? "video/*" : "image/*"}
                              className="mt-1"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (!file) return;
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                  setPortfolioUploadForm({...portfolioUploadForm, url: reader.result});
                                };
                                reader.readAsDataURL(file);
                              }}
                            />
                          </div>
                          <div className="md:col-span-2">
                            <Label>Or Paste URL</Label>
                            <Input 
                              type="url"
                              placeholder="https://example.com/image.jpg"
                              value={portfolioUploadForm.url.startsWith("data:") ? "" : portfolioUploadForm.url}
                              onChange={(e) => setPortfolioUploadForm({...portfolioUploadForm, url: e.target.value})}
                              className="mt-1"
                            />
                          </div>
                          {portfolioUploadForm.media_type === "video" && (
                            <div className="md:col-span-2">
                              <Label>Thumbnail URL (optional)</Label>
                              <Input 
                                type="url"
                                placeholder="https://example.com/thumbnail.jpg"
                                value={portfolioUploadForm.thumbnail}
                                onChange={(e) => setPortfolioUploadForm({...portfolioUploadForm, thumbnail: e.target.value})}
                                className="mt-1"
                              />
                            </div>
                          )}
                        </div>
                        <Button 
                          className="mt-4 w-full"
                          onClick={async () => {
                            if (!portfolioUploadForm.url) {
                              toast.error("Please provide a file or URL");
                              return;
                            }
                            if (selectedPortfolioPage === "bridal-portfolio" && !portfolioUploadForm.category) {
                              toast.error("Please select a category");
                              return;
                            }
                            try {
                              await axios.post(`${API}/admin/portfolio/${selectedPortfolioPage}`, portfolioUploadForm);
                              toast.success("Item added!");
                              setPortfolioUploadForm({ media_type: "image", url: "", thumbnail: "", category: portfolioUploadForm.category });
                              loadPortfolioItems(selectedPortfolioPage);
                            } catch (error) {
                              toast.error("Failed to add item");
                            }
                          }}
                        >
                          <Plus className="w-4 h-4 mr-2" /> Add Item
                        </Button>
                      </div>

                      {/* Existing Items Grid */}
                      <div>
                        <h4 className="font-semibold mb-3">
                          Existing Items ({portfolioItems[selectedPortfolioPage]?.length || 0})
                        </h4>
                        {portfolioItems[selectedPortfolioPage]?.length > 0 ? (
                          <div className="grid grid-cols-4 md:grid-cols-6 gap-3">
                            {portfolioItems[selectedPortfolioPage].map((item) => (
                              <div key={item.id} className="relative group">
                                <div className="aspect-square rounded-lg overflow-hidden bg-gray-100">
                                  {item.media_type === "video" ? (
                                    <video 
                                      src={item.url.startsWith("http") ? item.url : `${API.replace('/api', '')}${item.url}`}
                                      className="w-full h-full object-cover"
                                      muted
                                    />
                                  ) : (
                                    <img 
                                      src={item.url.startsWith("http") ? item.url : `${API.replace('/api', '')}${item.url}`}
                                      alt=""
                                      className="w-full h-full object-cover"
                                    />
                                  )}
                                </div>
                                <button
                                  onClick={async () => {
                                    if (!window.confirm("Delete this item?")) return;
                                    try {
                                      await axios.delete(`${API}/admin/portfolio/${selectedPortfolioPage}/${item.id}`);
                                      toast.success("Deleted!");
                                      loadPortfolioItems(selectedPortfolioPage);
                                    } catch (error) {
                                      toast.error("Failed to delete");
                                    }
                                  }}
                                  className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 text-xs opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center"
                                >
                                  ×
                                </button>
                                {item.category && (
                                  <span className="absolute bottom-1 left-1 bg-black/70 text-white text-xs px-1 rounded">
                                    {item.category.replace("-", " ")}
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-gray-500 text-center py-8">No items yet. Add your first item above.</p>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </div>

      {/* Manage Student Dialog (Edit + View Combined) */}
      <Dialog open={editDialog} onOpenChange={setEditDialog}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="edit-student-dialog">
          <DialogHeader>
            <DialogTitle>Manage Student - {selectedStudent?.name}</DialogTitle>
            <DialogDescription>View and edit all student information and manage payments & mentor</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 max-h-[500px] overflow-y-auto pr-2">
            <div>
              <Label htmlFor="edit-name">Name</Label>
              <Input
                id="edit-name"
                data-testid="edit-name-input"
                value={editForm.name}
                onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
              />
            </div>
            
            <div>
              <Label htmlFor="edit-mobile">Mobile</Label>
              <Input
                id="edit-mobile"
                data-testid="edit-mobile-input"
                value={editForm.mobile}
                onChange={(e) => setEditForm({ ...editForm, mobile: e.target.value })}
              />
            </div>
            
            <div>
              <Label htmlFor="edit-batch">Batch Number</Label>
              <Input
                id="edit-batch"
                data-testid="edit-batch-input"
                value={editForm.batch_number}
                onChange={(e) => setEditForm({ ...editForm, batch_number: e.target.value })}
                placeholder="e.g., BATCH-JAN-2025"
              />
            </div>
            
            <div>
              <Label htmlFor="edit-batch-date">Batch Start Date</Label>
              <Input
                id="edit-batch-date"
                data-testid="edit-batch-date-input"
                type="date"
                value={editForm.batch_start_date}
                onChange={(e) => setEditForm({ ...editForm, batch_start_date: e.target.value })}
              />
            </div>
            
            <div>
              <Label htmlFor="edit-course">Course</Label>
              <Select value={editForm.course_id} onValueChange={(val) => setEditForm({ ...editForm, course_id: val })}>
                <SelectTrigger data-testid="edit-course-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {courses.map((course) => (
                    <SelectItem key={course.id} value={course.id}>
                      {course.name} - ₹{course.fees.toLocaleString()}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            
            {editForm.course_id === "course3" && (
              <div>
                <Label htmlFor="edit-course3-choice">Course 3 Module Choice</Label>
                <Select value={editForm.course3_choice || ""} onValueChange={(val) => setEditForm({ ...editForm, course3_choice: val })}>
                  <SelectTrigger data-testid="edit-course3-choice-select">
                    <SelectValue placeholder="Nails or Draping" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="nails">Nails</SelectItem>
                    <SelectItem value="draping">Draping</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            )}
            
            <div className="flex items-center justify-between">
              <Label htmlFor="edit-reg-paid">Registration Paid</Label>
              <Switch
                id="edit-reg-paid"
                data-testid="edit-reg-paid-switch"
                checked={editForm.registration_paid}
                onCheckedChange={(checked) => setEditForm({ ...editForm, registration_paid: checked })}
              />
            </div>
            
            <div className="flex items-center justify-between">
              <Label htmlFor="edit-full-paid">Full Fees Paid</Label>
              <Switch
                id="edit-full-paid"
                data-testid="edit-full-paid-switch"
                checked={editForm.full_fees_paid}
                onCheckedChange={(checked) => setEditForm({ ...editForm, full_fees_paid: checked })}
              />
            </div>
            
            <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg border-2 border-green-200">
              <div>
                <Label htmlFor="edit-is-active" className="font-bold text-green-900">Account Active</Label>
                <p className="text-xs text-green-700">Enable to allow student to use dashboard features</p>
              </div>
              <Switch
                id="edit-is-active"
                data-testid="edit-is-active-switch"
                checked={editForm.is_active !== false}
                onCheckedChange={(checked) => setEditForm({ ...editForm, is_active: checked })}
              />
            </div>
            
            {/* Action Buttons */}
            <div className="border-t pt-4 space-y-3">
              <h3 className="font-semibold text-sm text-gray-700">Quick Actions</h3>
              <div className="grid grid-cols-2 gap-3">
                <Button 
                  variant="outline"
                  onClick={() => {
                    setEditDialog(false);
                    openMentorDialog(selectedStudent);
                  }}
                >
                  <Edit className="w-4 h-4 mr-2" />
                  Edit Mentor
                </Button>
                <Button 
                  variant="outline"
                  onClick={() => {
                    setEditDialog(false);
                    openPaymentManage(selectedStudent);
                  }}
                >
                  <IndianRupee className="w-4 h-4 mr-2" />
                  Manage Payments
                </Button>
              </div>
            </div>
            
            <Button onClick={handleUpdate} className="w-full bg-blue-600 hover:bg-blue-700" data-testid="update-student-button">
              Update Student Information
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Create Teacher Dialog */}
      <Dialog open={createTeacherDialog} onOpenChange={setCreateTeacherDialog}>
        <DialogContent data-testid="create-teacher-dialog">
          <DialogHeader>
            <DialogTitle>Add New Teacher</DialogTitle>
            <DialogDescription>Create teacher account</DialogDescription>
          </DialogHeader>
          
          <form onSubmit={handleCreateTeacher} className="space-y-4">
            <div>
              <Label htmlFor="teacher-name">Full Name</Label>
              <Input
                id="teacher-name"
                data-testid="teacher-name-input"
                value={newTeacher.name}
                onChange={(e) => setNewTeacher({ ...newTeacher, name: e.target.value })}
                required
              />
            </div>
            
            <div>
              <Label htmlFor="teacher-id">Teacher ID</Label>
              <Input
                id="teacher-id"
                data-testid="teacher-id-input"
                value={newTeacher.teacher_id}
                onChange={(e) => setNewTeacher({ ...newTeacher, teacher_id: e.target.value })}
                placeholder="e.g., TEACHER001"
                required
              />
            </div>
            
            <div>
              <Label htmlFor="teacher-mobile">Mobile</Label>
              <Input
                id="teacher-mobile"
                data-testid="teacher-mobile-input"
                type="tel"
                value={newTeacher.mobile}
                onChange={(e) => setNewTeacher({ ...newTeacher, mobile: e.target.value })}
                required
              />
            </div>
            
            <div>
              <Label htmlFor="teacher-password">Password</Label>
              <Input
                id="teacher-password"
                data-testid="teacher-password-input"
                type="password"
                value={newTeacher.password}
                onChange={(e) => setNewTeacher({ ...newTeacher, password: e.target.value })}
                required
              />
            </div>
            
            <div>
              <Label>Teacher Roles (Select Multiple)</Label>
              <div className="grid grid-cols-2 gap-2 mt-2">
                {["makeup", "hair", "nails", "draping"].map(role => (
                  <div key={role} className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id={`role-${role}`}
                      checked={newTeacher.roles.includes(role)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setNewTeacher({...newTeacher, roles: [...newTeacher.roles, role]});
                        } else {
                          setNewTeacher({...newTeacher, roles: newTeacher.roles.filter(r => r !== role)});
                        }
                      }}
                      className="w-4 h-4"
                    />
                    <label htmlFor={`role-${role}`} className="capitalize cursor-pointer">{role}</label>
                  </div>
                ))}
              </div>
            </div>
            
            <Button type="submit" className="w-full" data-testid="create-teacher-submit">
              Create Teacher
            </Button>
          </form>
        </DialogContent>
      </Dialog>

      {/* Edit Teacher Dialog */}
      <Dialog open={editTeacherDialog} onOpenChange={setEditTeacherDialog}>
        <DialogContent data-testid="edit-teacher-dialog">
          <DialogHeader>
            <DialogTitle>Edit Teacher</DialogTitle>
            <DialogDescription>Update teacher information</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label htmlFor="edit-teacher-name">Full Name</Label>
              <Input
                id="edit-teacher-name"
                data-testid="edit-teacher-name-input"
                value={editTeacherForm.name}
                onChange={(e) => setEditTeacherForm({ ...editTeacherForm, name: e.target.value })}
              />
            </div>
            
            <div>
              <Label htmlFor="edit-teacher-mobile">Mobile</Label>
              <Input
                id="edit-teacher-mobile"
                data-testid="edit-teacher-mobile-input"
                type="tel"
                value={editTeacherForm.mobile}
                onChange={(e) => setEditTeacherForm({ ...editTeacherForm, mobile: e.target.value })}
              />
            </div>
            
            <div>
              <Label htmlFor="edit-teacher-password">New Password (leave blank to keep current)</Label>
              <Input
                id="edit-teacher-password"
                data-testid="edit-teacher-password-input"
                type="password"
                value={editTeacherForm.password}
                onChange={(e) => setEditTeacherForm({ ...editTeacherForm, password: e.target.value })}
                placeholder="Enter new password or leave blank"
              />
            </div>
            
            <div>
              <Label>Teacher Roles (Select Multiple)</Label>
              <div className="grid grid-cols-2 gap-2 mt-2">
                {["makeup", "hair", "nails", "draping"].map(role => (
                  <div key={role} className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id={`edit-role-${role}`}
                      checked={editTeacherForm.roles?.includes(role) || false}
                      onChange={(e) => {
                        const currentRoles = editTeacherForm.roles || [];
                        if (e.target.checked) {
                          setEditTeacherForm({...editTeacherForm, roles: [...currentRoles, role]});
                        } else {
                          setEditTeacherForm({...editTeacherForm, roles: currentRoles.filter(r => r !== role)});
                        }
                      }}
                      className="w-4 h-4"
                    />
                    <label htmlFor={`edit-role-${role}`} className="capitalize cursor-pointer">{role}</label>
                  </div>
                ))}
              </div>
            </div>
            
            <Button onClick={handleUpdateTeacher} className="w-full" data-testid="update-teacher-button">
              Update Teacher
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Upload Content Dialog */}
      <Dialog open={uploadDialog} onOpenChange={setUploadDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {uploadType === "schedule" ? "Create Batch Schedule" : `Upload ${uploadType === "book" ? "Book" : "Notes"}`}
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            {uploadType === "schedule" ? (
              <>
                <div>
                  <Label>Course</Label>
                  <Select value={uploadForm.course_id} onValueChange={(val) => setUploadForm({...uploadForm, course_id: val})}>
                    <SelectTrigger>
                      <SelectValue placeholder="Select course" />
                    </SelectTrigger>
                    <SelectContent>
                      {courses.map(course => (
                        <SelectItem key={course.id} value={course.id}>{course.name}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Batch Name</Label>
                  <Input 
                    value={uploadForm.batch_name}
                    onChange={(e) => setUploadForm({...uploadForm, batch_name: e.target.value})}
                    placeholder="e.g., Batch 1, Morning Batch"
                  />
                </div>
                <div>
                  <Label>Start Date</Label>
                  <Input 
                    type="date"
                    value={uploadForm.batch_date}
                    onChange={(e) => setUploadForm({...uploadForm, batch_date: e.target.value})}
                  />
                </div>
              </>
            ) : (
              <>
                <div>
                  <Label>Title</Label>
                  <Input 
                    value={uploadForm.title}
                    onChange={(e) => setUploadForm({...uploadForm, title: e.target.value})}
                    placeholder="Enter title"
                  />
                </div>
                <div>
                  <Label>Course</Label>
                  <Select value={uploadForm.course_id} onValueChange={(val) => setUploadForm({...uploadForm, course_id: val})}>
                    <SelectTrigger>
                      <SelectValue placeholder="Select course" />
                    </SelectTrigger>
                    <SelectContent>
                      {courses.map(course => (
                        <SelectItem key={course.id} value={course.id}>{course.name}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>File (PDF)</Label>
                  <Input 
                    type="file"
                    accept=".pdf"
                    onChange={(e) => setUploadForm({...uploadForm, file: e.target.files[0]})}
                  />
                </div>
              </>
            )}
            
            <Button onClick={handleUploadContent} className="w-full">
              <Upload className="w-4 h-4 mr-2" />
              {uploadType === "schedule" ? "Create Schedule" : "Upload"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Edit Mentor Dialog */}
      <Dialog open={mentorDialog} onOpenChange={setMentorDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit Mentor</DialogTitle>
            <DialogDescription>Update mentor details for {selectedStudent?.name}</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Select Mentor (Makeup Teachers Only)</Label>
              {makeupTeachers.length > 0 ? (
                <Select 
                  value={mentorForm.mentor_name} 
                  onValueChange={(val) => {
                    const selected = makeupTeachers.find(t => t.name === val);
                    setMentorForm({
                      mentor_name: val,
                      mentor_whatsapp: selected?.mobile || ""
                    });
                  }}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Choose mentor" />
                  </SelectTrigger>
                  <SelectContent>
                    {makeupTeachers.map((teacher) => (
                      <SelectItem key={teacher.id} value={teacher.name}>
                        {teacher.name} ({teacher.mobile})
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              ) : (
                <div className="p-4 border rounded-md bg-gray-50 text-center">
                  <p className="text-sm text-gray-600">No makeup teachers found. Please add teachers with "Makeup" role first.</p>
                </div>
              )}
            </div>
            
            <Button 
              onClick={handleUpdateMentor} 
              className="w-full"
              disabled={makeupTeachers.length === 0 || !mentorForm.mentor_name}
            >
              Update Mentor
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Payment Management Dialog */}
      <Dialog open={paymentManageDialog} onOpenChange={setPaymentManageDialog}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Manage Payments - {selectedStudent?.name}</DialogTitle>
            <DialogDescription>
              Total Paid: ₹{selectedStudent?.paid_fees || 0} | Balance: ₹{selectedStudent?.balance_fees || 0}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-6">
            {/* Add New Payment */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Add New Payment</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="grid grid-cols-3 gap-3">
                  <div>
                    <Label>Amount</Label>
                    <Input 
                      type="number"
                      value={newPayment.amount}
                      onChange={(e) => setNewPayment({...newPayment, amount: e.target.value})}
                      placeholder="Enter amount"
                    />
                  </div>
                  <div>
                    <Label>Payment Method</Label>
                    <Select value={newPayment.payment_method} onValueChange={(val) => setNewPayment({...newPayment, payment_method: val})}>
                      <SelectTrigger>
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="cash">Cash</SelectItem>
                        <SelectItem value="upi">UPI</SelectItem>
                        <SelectItem value="card">Card</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Date</Label>
                    <Input 
                      type="date"
                      value={newPayment.date}
                      onChange={(e) => setNewPayment({...newPayment, date: e.target.value})}
                    />
                  </div>
                </div>
                <Button onClick={handleAddPayment} className="w-full">
                  <IndianRupee className="w-4 h-4 mr-2" />
                  Add Payment
                </Button>
              </CardContent>
            </Card>

            {/* Payment History */}
            <div>
              <h3 className="font-semibold mb-3">Payment History</h3>
              {studentPayments.length > 0 ? (
                <div className="border rounded-lg overflow-hidden">
                  <table className="w-full">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="text-left p-3 text-sm font-semibold">Date</th>
                        <th className="text-left p-3 text-sm font-semibold">Amount</th>
                        <th className="text-left p-3 text-sm font-semibold">Method</th>
                        <th className="text-left p-3 text-sm font-semibold">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {studentPayments.map((payment, idx) => (
                        <tr key={payment.id} className="border-t hover:bg-gray-50">
                          <td className="p-3 text-sm">{new Date(payment.date).toLocaleDateString()}</td>
                          <td className="p-3 text-sm font-semibold">₹{payment.amount.toLocaleString()}</td>
                          <td className="p-3 text-sm capitalize">{payment.payment_method}</td>
                          <td className="p-3">
                            <div className="flex gap-2">
                              <Button 
                                size="sm" 
                                variant="outline"
                                onClick={() => {
                                  setSelectedPayment({...payment});
                                  setEditPaymentDialog(true);
                                }}
                              >
                                <Edit className="w-3 h-3" />
                              </Button>
                              <Button 
                                size="sm" 
                                variant="destructive"
                                onClick={() => handleDeletePayment(payment.id)}
                              >
                                <Trash2 className="w-3 h-3" />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-gray-500 text-center py-4">No payment history</p>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Edit Payment Dialog */}
      <Dialog open={editPaymentDialog} onOpenChange={setEditPaymentDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit Payment</DialogTitle>
          </DialogHeader>
          
          {selectedPayment && (
            <div className="space-y-4">
              <div>
                <Label>Amount</Label>
                <Input 
                  type="number"
                  value={selectedPayment.amount}
                  onChange={(e) => setSelectedPayment({...selectedPayment, amount: parseFloat(e.target.value)})}
                />
              </div>
              <div>
                <Label>Payment Method</Label>
                <Select value={selectedPayment.payment_method} onValueChange={(val) => setSelectedPayment({...selectedPayment, payment_method: val})}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="cash">Cash</SelectItem>
                    <SelectItem value="upi">UPI</SelectItem>
                    <SelectItem value="card">Card</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Date</Label>
                <Input 
                  type="date"
                  value={selectedPayment.date}
                  onChange={(e) => setSelectedPayment({...selectedPayment, date: e.target.value})}
                />
              </div>
              
              <Button onClick={handleUpdatePayment} className="w-full">
                Update Payment
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Schedule Management Dialog */}
      <Dialog open={scheduleDialog} onOpenChange={setScheduleDialog}>
        <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Manage Schedule - Batch {selectedBatchForSchedule}</DialogTitle>
            <DialogDescription>Add date-wise topics for this batch</DialogDescription>
          </DialogHeader>

          <div className="space-y-6">
            {/* Course Selection */}
            {!selectedCourseForSchedule ? (
              <Card>
                <CardHeader>
                  <CardTitle className="text-lg">Select Course Type</CardTitle>
                  <CardDescription>Choose which course schedule you want to manage</CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <Button
                      variant="outline"
                      className="h-24 flex flex-col items-center justify-center hover:bg-pink-50 border-2"
                      onClick={() => {
                        setSelectedCourseForSchedule("makeup");
                        setNewScheduleEntry({...newScheduleEntry, course_id: "course1"});
                        fetchBatchSchedule(selectedBatchForSchedule, "makeup");
                      }}
                    >
                      <span className="text-2xl mb-2">💄</span>
                      <span className="font-semibold">Makeup</span>
                    </Button>
                    <Button
                      variant="outline"
                      className="h-24 flex flex-col items-center justify-center hover:bg-purple-50 border-2"
                      onClick={() => {
                        setSelectedCourseForSchedule("hair");
                        setNewScheduleEntry({...newScheduleEntry, course_id: "course2"});
                        fetchBatchSchedule(selectedBatchForSchedule, "hair");
                      }}
                    >
                      <span className="text-2xl mb-2">💇</span>
                      <span className="font-semibold">Hair</span>
                    </Button>
                    <Button
                      variant="outline"
                      className="h-24 flex flex-col items-center justify-center hover:bg-blue-50 border-2"
                      onClick={() => {
                        setSelectedCourseForSchedule("nails");
                        setNewScheduleEntry({...newScheduleEntry, course_id: "course3"});
                        fetchBatchSchedule(selectedBatchForSchedule, "nails");
                      }}
                    >
                      <span className="text-2xl mb-2">💅</span>
                      <span className="font-semibold">Nails</span>
                    </Button>
                    <Button
                      variant="outline"
                      className="h-24 flex flex-col items-center justify-center hover:bg-green-50 border-2"
                      onClick={() => {
                        setSelectedCourseForSchedule("draping");
                        setNewScheduleEntry({...newScheduleEntry, course_id: "course4"});
                        fetchBatchSchedule(selectedBatchForSchedule, "draping");
                      }}
                    >
                      <span className="text-2xl mb-2">👗</span>
                      <span className="font-semibold">Draping</span>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ) : (
              <>
                {/* Back Button */}
                <Button 
                  variant="outline" 
                  onClick={() => {
                    setSelectedCourseForSchedule("");
                    setBatchSchedules([]);
                  }}
                >
                  ← Back to Course Selection
                </Button>

                {/* Add New Schedule Entry */}
                <Card>
                  <CardHeader>
                    <CardTitle className="text-lg capitalize">
                      Add {selectedCourseForSchedule} Schedule Entry
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <Label>Date</Label>
                        <Input
                          type="date"
                          value={newScheduleEntry.date}
                          onChange={(e) => setNewScheduleEntry({...newScheduleEntry, date: e.target.value})}
                        />
                      </div>
                      <div>
                        <Label>Topic</Label>
                        <Input
                          value={newScheduleEntry.topic}
                          onChange={(e) => setNewScheduleEntry({...newScheduleEntry, topic: e.target.value})}
                          placeholder="Enter topic for this day"
                        />
                      </div>
                    </div>
                    <Button onClick={handleAddScheduleEntry} className="w-full">
                      <Calendar className="w-4 h-4 mr-2" />
                      Add Schedule Entry
                    </Button>
                  </CardContent>
                </Card>
              </>
            )}

            {/* Schedule Entries List - Only show when course is selected */}
            {selectedCourseForSchedule && (
              <div>
                <h3 className="font-semibold mb-3 flex items-center gap-2 capitalize">
                  <CalendarDays className="w-5 h-5" />
                  {selectedCourseForSchedule} Schedule Entries ({batchSchedules.length})
                </h3>
                {batchSchedules.length > 0 ? (
                  <div className="space-y-2">
                    {batchSchedules.map((schedule, idx) => (
                      <Card key={schedule.id} className="border">
                        <CardContent className="p-4">
                          <div className="flex items-center justify-between">
                            <div className="flex-1">
                              <div className="flex items-center gap-3">
                                <div className="bg-blue-100 rounded px-3 py-1">
                                  <p className="text-sm font-semibold text-blue-700">
                                    Day {idx + 1}
                                  </p>
                                </div>
                                <div>
                                  <p className="font-semibold">{new Date(schedule.date).toLocaleDateString('en-GB')}</p>
                                  <p className="text-sm text-gray-600">{schedule.topic}</p>
                                </div>
                              </div>
                            </div>
                            <Button
                              size="sm"
                              variant="destructive"
                              onClick={() => handleDeleteScheduleEntry(schedule.id)}
                            >
                              <Trash2 className="w-4 h-4" />
                            </Button>
                          </div>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                ) : (
                  <p className="text-center py-8 text-gray-500">No schedule entries yet. Add entries above.</p>
                )}
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Add Student Manually Dialog */}
      <Dialog open={addStudentDialog} onOpenChange={setAddStudentDialog}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Add Student Manually</DialogTitle>
            <DialogDescription>Create a new student account with all details</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Full Name *</Label>
                <Input
                  value={newStudentForm.name}
                  onChange={(e) => setNewStudentForm({...newStudentForm, name: e.target.value})}
                  placeholder="Student name"
                />
              </div>
              <div>
                <Label>Mobile *</Label>
                <Input
                  value={newStudentForm.mobile}
                  onChange={(e) => setNewStudentForm({...newStudentForm, mobile: e.target.value})}
                  placeholder="Mobile number"
                />
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Emergency Contact</Label>
                <Input
                  value={newStudentForm.emergency_contact}
                  onChange={(e) => setNewStudentForm({...newStudentForm, emergency_contact: e.target.value})}
                  placeholder="Emergency contact"
                />
              </div>
              <div>
                <Label>Batch Number</Label>
                <Input
                  value={newStudentForm.batch_number}
                  onChange={(e) => setNewStudentForm({...newStudentForm, batch_number: e.target.value})}
                  placeholder="e.g., 30"
                />
              </div>
            </div>
            
            <div>
              <Label>Address</Label>
              <Textarea
                value={newStudentForm.address}
                onChange={(e) => setNewStudentForm({...newStudentForm, address: e.target.value})}
                placeholder="Full address"
                rows={2}
              />
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Course *</Label>
                <Select 
                  value={newStudentForm.course_id} 
                  onValueChange={(val) => setNewStudentForm({...newStudentForm, course_id: val})}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select course" />
                  </SelectTrigger>
                  <SelectContent>
                    {courses.map(course => (
                      <SelectItem key={course.id} value={course.id}>{course.name}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              
              {newStudentForm.course_id === "course3" && (
                <div>
                  <Label>Course 3 Choice</Label>
                  <Select 
                    value={newStudentForm.course3_choice} 
                    onValueChange={(val) => setNewStudentForm({...newStudentForm, course3_choice: val})}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Nails or Draping" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="nails">Nails</SelectItem>
                      <SelectItem value="draping">Draping</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              )}
            </div>
            
            <div className="flex items-center gap-2">
              <Switch 
                checked={newStudentForm.is_active}
                onCheckedChange={(val) => setNewStudentForm({...newStudentForm, is_active: val})}
              />
              <Label>Account Active</Label>
            </div>
            
            <div className="bg-blue-50 p-3 rounded">
              <p className="text-sm text-gray-700">
                <strong>Note:</strong> Password will be set as mobile number automatically.
              </p>
            </div>
            
            <Button onClick={handleAddStudentManually} className="w-full">
              <UserPlus className="w-4 h-4 mr-2" />
              Add Student
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Teacher Attendance Dialog */}
      <Dialog open={teacherAttendanceDialog} onOpenChange={setTeacherAttendanceDialog}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Attendance History - {selectedTeacherForAttendance?.name}</DialogTitle>
            <DialogDescription>View date-wise attendance with time in and time out</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-3">
            {selectedTeacherAttendance.length > 0 ? (
              selectedTeacherAttendance.map((record, idx) => {
                const date = new Date(record.date);
                const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
                const dateStr = date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
                
                return (
                  <Card key={idx} className="border-2">
                    <CardContent className="p-4">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                          <div className="bg-blue-100 rounded-lg px-4 py-2 min-w-[120px] text-center">
                            <p className="text-xs text-blue-600 font-semibold">{dayName}</p>
                            <p className="text-sm font-bold text-blue-800">{dateStr}</p>
                          </div>
                          <div className="flex gap-6">
                            <div>
                              <p className="text-xs text-gray-500 mb-1">Time In</p>
                              <p className="font-semibold text-green-600">
                                {record.time_in ? new Date(record.time_in).toLocaleTimeString('en-US', { 
                                  hour: '2-digit', 
                                  minute: '2-digit',
                                  hour12: true 
                                }) : "-"}
                              </p>
                            </div>
                            <div>
                              <p className="text-xs text-gray-500 mb-1">Time Out</p>
                              <p className="font-semibold text-red-600">
                                {record.time_out ? new Date(record.time_out).toLocaleTimeString('en-US', { 
                                  hour: '2-digit', 
                                  minute: '2-digit',
                                  hour12: true 
                                }) : "-"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                );
              })
            ) : (
              <div className="text-center py-12 text-gray-500">
                <Clock className="w-12 h-12 mx-auto mb-3 text-gray-400" />
                <p>No attendance records found</p>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Content Management Dialog */}
      <Dialog open={contentDialog} onOpenChange={(open) => { 
        setContentDialog(open);
        if (open && contentType) {
          loadContentData(contentType);
        }
      }}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>
              {contentType === "banners" && "Homepage Banners"}
              {contentType === "contact" && "Contact Details"}
              {contentType === "policy" && "Website Policies"}
              {contentType === "faqs" && "Manage FAQs"}
              {contentType === "courses" && "Course Details"}
            </DialogTitle>
            <DialogDescription>
              {contentType === "banners" && "Upload images for the homepage hero section"}
              {contentType === "contact" && "Update contact information displayed on the website"}
              {contentType === "policy" && "Edit Terms & Conditions, Privacy Policy, and Refund Policy"}
              {contentType === "faqs" && "Add or edit frequently asked questions"}
              {contentType === "courses" && "Update course information and pricing"}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            {contentType === "banners" && (
              <div>
                <Label>Banner Images (Upload up to 5 images)</Label>
                <Input 
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={async (e) => {
                    const files = Array.from(e.target.files);
                    const base64Images = await Promise.all(
                      files.map(file => convertToBase64(file))
                    );
                    setContentForm({...contentForm, bannerImages: base64Images});
                  }}
                />
                {contentForm.bannerImages.length > 0 && (
                  <p className="text-sm text-gray-600 mt-2">{contentForm.bannerImages.length} image(s) selected</p>
                )}
              </div>
            )}

            {contentType === "contact" && (
              <>
                <div>
                  <Label>Phone Number</Label>
                  <Input 
                    value={contentForm.phone}
                    onChange={(e) => setContentForm({...contentForm, phone: e.target.value})}
                    placeholder="+91 1234567890"
                  />
                </div>
                <div>
                  <Label>Email</Label>
                  <Input 
                    type="email"
                    value={contentForm.email}
                    onChange={(e) => setContentForm({...contentForm, email: e.target.value})}
                    placeholder="info@muasacademy.com"
                  />
                </div>
                <div>
                  <Label>WhatsApp Number</Label>
                  <Input 
                    value={contentForm.whatsapp}
                    onChange={(e) => setContentForm({...contentForm, whatsapp: e.target.value})}
                    placeholder="+91 1234567890"
                  />
                </div>
                <div>
                  <Label>Address</Label>
                  <Textarea 
                    value={contentForm.address}
                    onChange={(e) => setContentForm({...contentForm, address: e.target.value})}
                    placeholder="Full address"
                    rows={3}
                  />
                </div>
              </>
            )}

            {contentType === "policy" && (
              <>
                <div>
                  <Label>Policy Type</Label>
                  <Select value={policyType} onValueChange={(val) => {
                    setPolicyType(val);
                    loadContentData("policy");
                  }}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="terms">Terms & Conditions</SelectItem>
                      <SelectItem value="privacy">Privacy Policy</SelectItem>
                      <SelectItem value="refund">Refund Policy</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Policy Content</Label>
                  <Textarea 
                    value={contentForm.policyContent}
                    onChange={(e) => setContentForm({...contentForm, policyContent: e.target.value})}
                    placeholder="Enter policy text..."
                    rows={10}
                  />
                </div>
              </>
            )}

            {contentType === "faqs" && (
              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <Label>FAQ Items</Label>
                  <Button
                    size="sm"
                    onClick={() => {
                      setContentForm({
                        ...contentForm,
                        faqs: [...contentForm.faqs, { question: "", answer: "" }]
                      });
                    }}
                  >
                    Add FAQ
                  </Button>
                </div>
                {contentForm.faqs.map((faq, idx) => (
                  <Card key={idx} className="p-4">
                    <div className="space-y-3">
                      <div>
                        <Label>Question {idx + 1}</Label>
                        <Input 
                          value={faq.question}
                          onChange={(e) => {
                            const newFaqs = [...contentForm.faqs];
                            newFaqs[idx].question = e.target.value;
                            setContentForm({...contentForm, faqs: newFaqs});
                          }}
                          placeholder="Enter question"
                        />
                      </div>
                      <div>
                        <Label>Answer {idx + 1}</Label>
                        <Textarea 
                          value={faq.answer}
                          onChange={(e) => {
                            const newFaqs = [...contentForm.faqs];
                            newFaqs[idx].answer = e.target.value;
                            setContentForm({...contentForm, faqs: newFaqs});
                          }}
                          placeholder="Enter answer"
                          rows={3}
                        />
                      </div>
                      <Button
                        size="sm"
                        variant="destructive"
                        onClick={() => {
                          const newFaqs = contentForm.faqs.filter((_, i) => i !== idx);
                          setContentForm({...contentForm, faqs: newFaqs});
                        }}
                      >
                        Remove
                      </Button>
                    </div>
                  </Card>
                ))}
              </div>
            )}

            {contentType === "courses" && (
              <>
                <div>
                  <Label>Select Course</Label>
                  <Select 
                    value={contentForm.courseDetails.course_id} 
                    onValueChange={(val) => {
                      const selectedCourse = courses.find(c => c.id === val);
                      setContentForm({
                        ...contentForm,
                        courseDetails: {
                          course_id: val,
                          name: selectedCourse.name,
                          duration: selectedCourse.duration,
                          fees: selectedCourse.fees.toString(),
                          description: ""
                        }
                      });
                    }}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Select course" />
                    </SelectTrigger>
                    <SelectContent>
                      {courses.map(course => (
                        <SelectItem key={course.id} value={course.id}>{course.name}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                {contentForm.courseDetails.course_id && (
                  <>
                    <div>
                      <Label>Course Name</Label>
                      <Input 
                        value={contentForm.courseDetails.name}
                        onChange={(e) => setContentForm({
                          ...contentForm,
                          courseDetails: {...contentForm.courseDetails, name: e.target.value}
                        })}
                      />
                    </div>
                    <div>
                      <Label>Duration</Label>
                      <Input 
                        value={contentForm.courseDetails.duration}
                        onChange={(e) => setContentForm({
                          ...contentForm,
                          courseDetails: {...contentForm.courseDetails, duration: e.target.value}
                        })}
                      />
                    </div>
                    <div>
                      <Label>Fees (₹)</Label>
                      <Input 
                        type="number"
                        value={contentForm.courseDetails.fees}
                        onChange={(e) => setContentForm({
                          ...contentForm,
                          courseDetails: {...contentForm.courseDetails, fees: e.target.value}
                        })}
                      />
                    </div>
                    <div>
                      <Label>Description</Label>
                      <Textarea 
                        value={contentForm.courseDetails.description}
                        onChange={(e) => setContentForm({
                          ...contentForm,
                          courseDetails: {...contentForm.courseDetails, description: e.target.value}
                        })}
                        placeholder="Course description for homepage"
                        rows={4}
                      />
                    </div>
                  </>
                )}
              </>
            )}
            
            <Button onClick={handleSaveContent} className="w-full">
              Save Changes
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Extra Work Management Dialogs */}
      
      {/* Pending Approvals Dialog */}
      <Dialog open={extraWorkDialog} onOpenChange={setExtraWorkDialog}>
        <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Pending Extra Work Approvals</DialogTitle>
            <DialogDescription>Review and approve teacher external work</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            {pendingExtraWork.length > 0 ? (
              pendingExtraWork.map((work) => (
                <Card key={work.id} className="border-l-4 border-l-orange-500">
                  <CardContent className="p-4">
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <p className="font-semibold text-lg">{work.teacher_name}</p>
                        <p className="text-sm text-gray-600 mb-2">Date: {new Date(work.date).toLocaleDateString()}</p>
                        <div className="space-y-1 text-sm">
                          <p><span className="font-medium">Client:</span> {work.client_name}</p>
                          <p><span className="font-medium">Location:</span> {work.location}</p>
                          <p><span className="font-medium">Service:</span> {work.service}</p>
                          <p><span className="font-medium">Vanity Type:</span> {work.vanity_type}</p>
                          <p><span className="font-medium">Quantity:</span> {work.qty}</p>
                        </div>
                      </div>
                      
                      <div className="flex items-center gap-2">
                        <Input
                          type="number"
                          placeholder="Enter amount"
                          value={selectedWork?.id === work.id ? approvalAmount : ""}
                          onChange={(e) => {
                            setSelectedWork(work);
                            setApprovalAmount(e.target.value);
                          }}
                          className="w-32"
                        />
                        <Button
                          onClick={handleApproveExtraWork}
                          disabled={selectedWork?.id !== work.id || !approvalAmount}
                          className="bg-green-500 hover:bg-green-600"
                        >
                          <CheckCircle className="w-4 h-4 mr-2" />
                          Approve
                        </Button>
                        <Button
                          onClick={() => handleDeleteExtraWork(work.id)}
                          variant="destructive"
                          size="sm"
                        >
                          <Trash2 className="w-4 h-4" />
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))
            ) : (
              <p className="text-center py-8 text-gray-500">No pending approvals</p>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Daily Task Management Dialog */}
      <Dialog open={taskManagementDialog} onOpenChange={setTaskManagementDialog}>
        <DialogContent className="max-w-6xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Daily Task Management</DialogTitle>
            <DialogDescription>View and manage all daily tasks created by teachers</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            {allTasks.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b">
                      <th className="text-left p-2">Teacher</th>
                      <th className="text-left p-2">Course</th>
                      <th className="text-left p-2">Due Date</th>
                      <th className="text-left p-2">Description</th>
                      <th className="text-left p-2">Submissions</th>
                      <th className="text-left p-2">Status</th>
                      <th className="text-left p-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allTasks.map((task) => (
                      <tr key={task.id} className="border-b hover:bg-gray-50">
                        <td className="p-2 font-medium">{task.teacher_name}</td>
                        <td className="p-2">
                          <span className="capitalize px-2 py-1 bg-blue-100 text-blue-700 rounded-full text-xs">
                            {task.course_type}
                          </span>
                        </td>
                        <td className="p-2">{new Date(task.due_date).toLocaleDateString()}</td>
                        <td className="p-2 max-w-xs truncate" title={task.task_description}>
                          {task.task_description}
                        </td>
                        <td className="p-2">
                          <div className="text-xs">
                            <div>Total: {task.submissions_count}</div>
                            <div className="text-green-600">Approved: {task.approved_count}</div>
                            <div className="text-yellow-600">Pending: {task.pending_count}</div>
                          </div>
                        </td>
                        <td className="p-2">
                          <span className={`px-2 py-1 rounded-full text-xs ${
                            new Date(task.due_date) < new Date() 
                              ? 'bg-red-100 text-red-700' 
                              : 'bg-green-100 text-green-700'
                          }`}>
                            {new Date(task.due_date) < new Date() ? 'Overdue' : 'Active'}
                          </span>
                        </td>
                        <td className="p-2">
                          <div className="flex gap-1">
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => loadTaskSubmissions(task.id)}
                              title="View Submissions"
                            >
                              <Eye className="w-3 h-3" />
                            </Button>
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => handleEditTask(task)}
                              title="Edit Task"
                            >
                              <Edit className="w-3 h-3" />
                            </Button>
                            <Button
                              size="sm"
                              variant="destructive"
                              onClick={() => handleDeleteTask(task.id)}
                              title="Delete Task"
                            >
                              <Trash2 className="w-3 h-3" />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-center py-8 text-gray-500">No tasks found</p>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Edit Task Dialog */}
      <Dialog open={editTaskDialog} onOpenChange={setEditTaskDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Edit Daily Task</DialogTitle>
            <DialogDescription>Modify task details and deadline</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Course Type</Label>
              <Select value={editTaskForm.course_type} onValueChange={(val) => setEditTaskForm({...editTaskForm, course_type: val})}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="makeup">Makeup</SelectItem>
                  <SelectItem value="hair">Hair</SelectItem>
                  <SelectItem value="nails">Nails</SelectItem>
                  <SelectItem value="draping">Draping</SelectItem>
                </SelectContent>
              </Select>
            </div>
            
            <div>
              <Label>Due Date</Label>
              <Input 
                type="date"
                value={editTaskForm.due_date}
                onChange={(e) => setEditTaskForm({...editTaskForm, due_date: e.target.value})}
              />
            </div>
            
            <div>
              <Label>Task Description</Label>
              <Textarea 
                value={editTaskForm.task_description}
                onChange={(e) => setEditTaskForm({...editTaskForm, task_description: e.target.value})}
                rows={4}
                placeholder="Describe the task..."
              />
            </div>
            
            <div className="flex gap-2">
              <Button onClick={handleUpdateTask} className="flex-1">
                Update Task
              </Button>
              <Button variant="outline" onClick={() => setEditTaskDialog(false)}>
                Cancel
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Task Submissions Dialog */}
      <Dialog open={taskSubmissionsDialog} onOpenChange={setTaskSubmissionsDialog}>
        <DialogContent className="max-w-5xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Task Submissions</DialogTitle>
            <DialogDescription>
              {taskSubmissions.task && `"${taskSubmissions.task.task_description}" - ${taskSubmissions.task.course_type} course`}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            {/* Summary */}
            {taskSubmissions.task && (
              <div className="grid grid-cols-4 gap-4 p-4 bg-gray-50 rounded-lg">
                <div className="text-center">
                  <p className="text-2xl font-bold text-blue-600">{taskSubmissions.total_submissions || 0}</p>
                  <p className="text-sm text-gray-600">Total</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-green-600">{taskSubmissions.approved_submissions || 0}</p>
                  <p className="text-sm text-gray-600">Approved</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-yellow-600">{taskSubmissions.pending_submissions || 0}</p>
                  <p className="text-sm text-gray-600">Pending</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-red-600">{taskSubmissions.rejected_submissions || 0}</p>
                  <p className="text-sm text-gray-600">Rejected</p>
                </div>
              </div>
            )}

            {/* Submissions Table */}
            {taskSubmissions.submissions && taskSubmissions.submissions.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b">
                      <th className="text-left p-2">Student</th>
                      <th className="text-left p-2">Mobile</th>
                      <th className="text-left p-2">Files</th>
                      <th className="text-left p-2">Status</th>
                      <th className="text-left p-2">Submitted</th>
                    </tr>
                  </thead>
                  <tbody>
                    {taskSubmissions.submissions.map((submission, idx) => (
                      <tr key={idx} className="border-b hover:bg-gray-50">
                        <td className="p-2 font-medium">{submission.student_name}</td>
                        <td className="p-2">{submission.student_mobile}</td>
                        <td className="p-2">{submission.submission_files?.length || 0} files</td>
                        <td className="p-2">
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                            submission.status === 'approved' 
                              ? 'bg-green-100 text-green-700'
                              : submission.status === 'rejected'
                              ? 'bg-red-100 text-red-700'
                              : 'bg-yellow-100 text-yellow-700'
                          }`}>
                            {submission.status === 'approved' ? 'Approved' 
                             : submission.status === 'rejected' ? 'Rejected'
                             : 'Pending'}
                          </span>
                        </td>
                        <td className="p-2">{new Date(submission.submitted_at).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-center py-8 text-gray-500">No submissions for this task</p>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Add Score Dialog */}
      <Dialog open={addScoreDialog} onOpenChange={setAddScoreDialog}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Add New Score for {selectedStudentForMarks?.name}</DialogTitle>
            <DialogDescription>Enter marks for the selected date</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Date</Label>
              <Input
                type="date"
                value={scoreForm.date}
                onChange={(e) => setScoreForm({...scoreForm, date: e.target.value})}
              />
            </div>

            <div className="flex items-center space-x-2">
              <Switch
                checked={scoreForm.is_absent}
                onCheckedChange={(checked) => setScoreForm({...scoreForm, is_absent: checked})}
              />
              <Label>Mark as Absent</Label>
            </div>

            {!scoreForm.is_absent && (
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Personality (Appearance)</Label>
                  <Input
                    type="number"
                    min="0"
                    max="10"
                    step="0.5"
                    value={scoreForm.personality}
                    onChange={(e) => setScoreForm({...scoreForm, personality: e.target.value})}
                  />
                </div>

                <div>
                  <Label>Communication</Label>
                  <Input
                    type="number"
                    min="0"
                    max="10"
                    step="0.5"
                    value={scoreForm.communication}
                    onChange={(e) => setScoreForm({...scoreForm, communication: e.target.value})}
                  />
                </div>

                <div>
                  <Label>Punctuality</Label>
                  <Input
                    type="number"
                    min="0"
                    max="10"
                    step="0.5"
                    value={scoreForm.punctuality}
                    onChange={(e) => setScoreForm({...scoreForm, punctuality: e.target.value})}
                  />
                </div>

                <div>
                  <Label>Eager to Learn</Label>
                  <Input
                    type="number"
                    min="0"
                    max="10"
                    step="0.5"
                    value={scoreForm.eager_to_learn}
                    onChange={(e) => setScoreForm({...scoreForm, eager_to_learn: e.target.value})}
                  />
                </div>

                <div>
                  <Label>Work Results</Label>
                  <Input
                    type="number"
                    min="0"
                    max="10"
                    step="0.5"
                    value={scoreForm.work_results}
                    onChange={(e) => setScoreForm({...scoreForm, work_results: e.target.value})}
                  />
                </div>

                <div className="flex items-end">
                  <div className="w-full">
                    <Label>Total</Label>
                    <Input
                      value={
                        parseFloat(scoreForm.personality || 0) +
                        parseFloat(scoreForm.communication || 0) +
                        parseFloat(scoreForm.punctuality || 0) +
                        parseFloat(scoreForm.eager_to_learn || 0) +
                        parseFloat(scoreForm.work_results || 0)
                      }
                      disabled
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setAddScoreDialog(false)}>Cancel</Button>
              <Button onClick={handleAddScore}>Add Score</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Edit Score Dialog */}
      <Dialog open={editScoreDialog} onOpenChange={setEditScoreDialog}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Edit Score for {selectedStudentForMarks?.name}</DialogTitle>
            <DialogDescription>Update marks for {selectedScore && new Date(selectedScore.date).toLocaleDateString()}</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <Switch
                checked={scoreForm.is_absent}
                onCheckedChange={(checked) => setScoreForm({...scoreForm, is_absent: checked})}
              />
              <Label>Mark as Absent</Label>
            </div>

            {!scoreForm.is_absent && (
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Personality (Appearance)</Label>
                  <Input
                    type="number"
                    min="0"
                    max="10"
                    step="0.5"
                    value={scoreForm.personality}
                    onChange={(e) => setScoreForm({...scoreForm, personality: e.target.value})}
                  />
                </div>

                <div>
                  <Label>Communication</Label>
                  <Input
                    type="number"
                    min="0"
                    max="10"
                    step="0.5"
                    value={scoreForm.communication}
                    onChange={(e) => setScoreForm({...scoreForm, communication: e.target.value})}
                  />
                </div>

                <div>
                  <Label>Punctuality</Label>
                  <Input
                    type="number"
                    min="0"
                    max="10"
                    step="0.5"
                    value={scoreForm.punctuality}
                    onChange={(e) => setScoreForm({...scoreForm, punctuality: e.target.value})}
                  />
                </div>

                <div>
                  <Label>Eager to Learn</Label>
                  <Input
                    type="number"
                    min="0"
                    max="10"
                    step="0.5"
                    value={scoreForm.eager_to_learn}
                    onChange={(e) => setScoreForm({...scoreForm, eager_to_learn: e.target.value})}
                  />
                </div>

                <div>
                  <Label>Work Results</Label>
                  <Input
                    type="number"
                    min="0"
                    max="10"
                    step="0.5"
                    value={scoreForm.work_results}
                    onChange={(e) => setScoreForm({...scoreForm, work_results: e.target.value})}
                  />
                </div>

                <div className="flex items-end">
                  <div className="w-full">
                    <Label>Total</Label>
                    <Input
                      value={
                        parseFloat(scoreForm.personality || 0) +
                        parseFloat(scoreForm.communication || 0) +
                        parseFloat(scoreForm.punctuality || 0) +
                        parseFloat(scoreForm.eager_to_learn || 0) +
                        parseFloat(scoreForm.work_results || 0)
                      }
                      disabled
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setEditScoreDialog(false)}>Cancel</Button>
              <Button onClick={handleUpdateScore}>Update Score</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Edit Book/Notes Dialog */}
      <Dialog open={editBookDialog} onOpenChange={setEditBookDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit {selectedBook?.file_type === 'book' ? 'Book' : 'Notes'}</DialogTitle>
            <DialogDescription>Update the details of this learning material</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Title</Label>
              <Input
                value={editBookForm.title}
                onChange={(e) => setEditBookForm({...editBookForm, title: e.target.value})}
                placeholder="Enter title"
              />
            </div>

            <div>
              <Label>Type</Label>
              <Select
                value={editBookForm.file_type}
                onValueChange={(value) => setEditBookForm({...editBookForm, file_type: value})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="book">Book</SelectItem>
                  <SelectItem value="notes">Notes</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label>Course</Label>
              <Select
                value={editBookForm.course_id}
                onValueChange={(value) => setEditBookForm({...editBookForm, course_id: value})}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="course1">Course 1: Makeup</SelectItem>
                  <SelectItem value="course2">Course 2: Makeup & Hair</SelectItem>
                  <SelectItem value="course3">Course 3: Makeup, Hair & Nails/Draping</SelectItem>
                  <SelectItem value="course4">Course 4: Master Course</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="text-sm text-gray-500">
              Note: You cannot change the file itself. To upload a different file, delete this entry and upload a new one.
            </div>

            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setEditBookDialog(false)}>Cancel</Button>
              <Button onClick={handleUpdateBook}>Update</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Allot Work Dialog - Same form as teacher's extra work */}
      <Dialog open={allotWorkDialog} onOpenChange={setAllotWorkDialog}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Allot Extra Work to Artist</DialogTitle>
            <DialogDescription>Pre-assign work to an artist</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Select Artist</Label>
              <Select value={allotWorkForm.teacher_id} onValueChange={(val) => setAllotWorkForm({...allotWorkForm, teacher_id: val})}>
                <SelectTrigger>
                  <SelectValue placeholder="Choose artist" />
                </SelectTrigger>
                <SelectContent>
                  {teachers.map((teacher) => (
                    <SelectItem key={teacher.id} value={teacher.id}>
                      {teacher.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label>Date</Label>
              <Input 
                type="date"
                value={allotWorkForm.date}
                onChange={(e) => setAllotWorkForm({...allotWorkForm, date: e.target.value})}
              />
            </div>
            
            <div>
              <Label>Client Name</Label>
              <Input 
                value={allotWorkForm.client_name}
                onChange={(e) => setAllotWorkForm({...allotWorkForm, client_name: e.target.value})}
                placeholder="e.g., Wedding Client, Event Company"
              />
            </div>
            
            <div>
              <Label>Location</Label>
              <Input 
                value={allotWorkForm.location}
                onChange={(e) => setAllotWorkForm({...allotWorkForm, location: e.target.value})}
                placeholder="e.g., Hotel Taj, Private Venue"
              />
            </div>
            
            {/* Location Type Checkboxes */}
            <div className="flex gap-4">
              <div className="flex items-center gap-2">
                <input 
                  type="checkbox" 
                  id="at_studio" 
                  checked={allotWorkForm.at_studio}
                  onChange={(e) => setAllotWorkForm({...allotWorkForm, at_studio: e.target.checked})}
                  className="w-4 h-4"
                />
                <Label htmlFor="at_studio">At Studio</Label>
              </div>
              <div className="flex items-center gap-2">
                <input 
                  type="checkbox" 
                  id="at_venue" 
                  checked={allotWorkForm.at_venue}
                  onChange={(e) => setAllotWorkForm({...allotWorkForm, at_venue: e.target.checked})}
                  className="w-4 h-4"
                />
                <Label htmlFor="at_venue">At Venue</Label>
              </div>
            </div>
            
            {/* Service Selection with Add/Delete */}
            <div>
              <Label>Service</Label>
              <Select value={allotWorkForm.service} onValueChange={(val) => setAllotWorkForm({...allotWorkForm, service: val})}>
                <SelectTrigger>
                  <SelectValue placeholder="Select service type" />
                </SelectTrigger>
                <SelectContent>
                  {customServices.map((service) => (
                    <SelectItem key={service} value={service}>{service}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <div className="flex gap-2 mt-2">
                <Input 
                  placeholder="Add new service" 
                  value={newServiceName}
                  onChange={(e) => setNewServiceName(e.target.value)}
                  className="flex-1"
                />
                <Button size="sm" onClick={() => {
                  if (newServiceName && !customServices.includes(newServiceName)) {
                    setCustomServices([...customServices, newServiceName]);
                    setNewServiceName("");
                    toast.success("Service added!");
                  }
                }}>Add</Button>
              </div>
              {customServices.length > 7 && (
                <div className="flex flex-wrap gap-1 mt-2">
                  {customServices.slice(7).map((s) => (
                    <span key={s} className="text-xs bg-gray-100 px-2 py-1 rounded flex items-center gap-1">
                      {s}
                      <button onClick={() => setCustomServices(customServices.filter(x => x !== s))} className="text-red-500 hover:text-red-700">×</button>
                    </span>
                  ))}
                </div>
              )}
            </div>
            
            <div>
              <Label>Vanity Type</Label>
              <Select value={allotWorkForm.vanity_type} onValueChange={(val) => setAllotWorkForm({...allotWorkForm, vanity_type: val})}>
                <SelectTrigger>
                  <SelectValue placeholder="Select vanity type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Studio Vanity">Studio Vanity</SelectItem>
                  <SelectItem value="Self Vanity">Self Vanity</SelectItem>
                </SelectContent>
              </Select>
            </div>
            
            <div className="grid grid-cols-3 gap-2">
              <div>
                <Label>Quantity</Label>
                <Input 
                  type="number"
                  min="1"
                  value={allotWorkForm.qty}
                  onChange={(e) => setAllotWorkForm({...allotWorkForm, qty: parseInt(e.target.value) || 1})}
                />
              </div>
              <div>
                <Label>Price (₹)</Label>
                <Input 
                  type="number"
                  min="0"
                  value={allotWorkForm.price}
                  onChange={(e) => setAllotWorkForm({...allotWorkForm, price: e.target.value})}
                  placeholder="Total price"
                />
              </div>
              <div>
                <Label>Artist Earning (₹)</Label>
                <Input 
                  type="number"
                  min="0"
                  value={allotWorkForm.artist_earning}
                  onChange={(e) => setAllotWorkForm({...allotWorkForm, artist_earning: e.target.value})}
                  placeholder="Artist share"
                />
              </div>
            </div>

            <Button onClick={handleAllotWork} className="w-full bg-purple-500 hover:bg-purple-600">
              Allot Work
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Payment Dialog */}
      <Dialog open={paymentDialog} onOpenChange={setPaymentDialog}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle>Mark as Paid</DialogTitle>
            <DialogDescription>Record payment details</DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Payment Date</Label>
              <Input 
                type="date"
                value={paymentForm.payment_date}
                onChange={(e) => setPaymentForm({...paymentForm, payment_date: e.target.value})}
              />
            </div>
            <div>
              <Label>Payment Type</Label>
              <Select value={paymentForm.pay_type} onValueChange={(val) => setPaymentForm({...paymentForm, pay_type: val})}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="CASH">Cash</SelectItem>
                  <SelectItem value="MA">MA (Mobile App)</SelectItem>
                  <SelectItem value="AS">AS (Account Settlement)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <Button 
              className="w-full bg-green-500 hover:bg-green-600"
              onClick={async () => {
                if (!selectedWork) return;
                try {
                  await axios.put(`${API}/admin/extra-work/${selectedWork.id}/pay`, paymentForm);
                  toast.success("Payment recorded!");
                  setPaymentDialog(false);
                  loadAllExtraWork();
                } catch (error) {
                  toast.error("Failed to record payment");
                }
              }}
            >
              Confirm Payment
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Edit Allotted Work Dialog */}
      <Dialog open={editAllotedWorkDialog} onOpenChange={setEditAllotedWorkDialog}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Edit Extra Work</DialogTitle>
            <DialogDescription>Update work details for {selectedWork?.teacher_name}</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Date</Label>
              <Input type="date" value={allotWorkForm.date} onChange={(e) => setAllotWorkForm({...allotWorkForm, date: e.target.value})} />
            </div>

            <div>
              <Label>Client Name</Label>
              <Input value={allotWorkForm.client_name} onChange={(e) => setAllotWorkForm({...allotWorkForm, client_name: e.target.value})} />
            </div>

            <div>
              <Label>Location</Label>
              <Input value={allotWorkForm.location} onChange={(e) => setAllotWorkForm({...allotWorkForm, location: e.target.value})} />
            </div>
            
            {/* Location Type Checkboxes */}
            <div className="flex gap-4">
              <div className="flex items-center gap-2">
                <input 
                  type="checkbox" 
                  id="edit_at_studio" 
                  checked={allotWorkForm.at_studio}
                  onChange={(e) => setAllotWorkForm({...allotWorkForm, at_studio: e.target.checked})}
                  className="w-4 h-4"
                />
                <Label htmlFor="edit_at_studio">At Studio</Label>
              </div>
              <div className="flex items-center gap-2">
                <input 
                  type="checkbox" 
                  id="edit_at_venue" 
                  checked={allotWorkForm.at_venue}
                  onChange={(e) => setAllotWorkForm({...allotWorkForm, at_venue: e.target.checked})}
                  className="w-4 h-4"
                />
                <Label htmlFor="edit_at_venue">At Venue</Label>
              </div>
            </div>

            <div>
              <Label>Service</Label>
              <Select value={allotWorkForm.service} onValueChange={(val) => setAllotWorkForm({...allotWorkForm, service: val})}>
                <SelectTrigger>
                  <SelectValue placeholder="Select service" />
                </SelectTrigger>
                <SelectContent>
                  {customServices.map((service) => (
                    <SelectItem key={service} value={service}>{service}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label>Vanity Type</Label>
              <Select value={allotWorkForm.vanity_type} onValueChange={(val) => setAllotWorkForm({...allotWorkForm, vanity_type: val})}>
                <SelectTrigger>
                  <SelectValue placeholder="Select vanity type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Studio Vanity">Studio Vanity</SelectItem>
                  <SelectItem value="Self Vanity">Self Vanity</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="grid grid-cols-3 gap-2">
              <div>
                <Label>Quantity</Label>
                <Input type="number" min="1" value={allotWorkForm.qty} onChange={(e) => setAllotWorkForm({...allotWorkForm, qty: parseInt(e.target.value) || 1})} />
              </div>
              <div>
                <Label>Price (₹)</Label>
                <Input 
                  type="number" 
                  min="0" 
                  value={allotWorkForm.price} 
                  onChange={(e) => setAllotWorkForm({...allotWorkForm, price: e.target.value})}
                  placeholder="Total price"
                />
              </div>
              <div>
                <Label>Artist Earning (₹)</Label>
                <Input 
                  type="number" 
                  min="0" 
                  value={allotWorkForm.artist_earning} 
                  onChange={(e) => setAllotWorkForm({...allotWorkForm, artist_earning: e.target.value})}
                  placeholder="Artist share"
                />
              </div>
            </div>

            <div className="flex gap-2">
              <Button variant="outline" onClick={() => setEditAllotedWorkDialog(false)} className="flex-1">Cancel</Button>
              <Button onClick={handleEditAllotedWork} className="flex-1">Update</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Edit Practice Kit Dialog */}
      <Dialog open={editKitDialog} onOpenChange={setEditKitDialog}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Edit Practice Kit</DialogTitle>
            <DialogDescription>Update practice kit information</DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4">
            <div>
              <Label>Kit Name</Label>
              <Input
                value={editKitForm.kit_name}
                onChange={(e) => setEditKitForm({...editKitForm, kit_name: e.target.value})}
                placeholder="e.g., Basic Makeup Kit"
              />
            </div>
            
            <div>
              <Label>Issue Date</Label>
              <Input
                type="date"
                value={editKitForm.issue_date}
                onChange={(e) => setEditKitForm({...editKitForm, issue_date: e.target.value})}
              />
            </div>
            
            <div className="flex items-center gap-2">
              <Switch
                checked={editKitForm.is_returned}
                onCheckedChange={(checked) => setEditKitForm({...editKitForm, is_returned: checked})}
              />
              <Label>Mark as Returned</Label>
            </div>
            
            {editKitForm.is_returned && (
              <div>
                <Label>Return Date</Label>
                <Input
                  type="date"
                  value={editKitForm.return_date}
                  onChange={(e) => setEditKitForm({...editKitForm, return_date: e.target.value})}
                />
              </div>
            )}
            
            <div className="flex gap-2 pt-4">
              <Button variant="outline" onClick={() => setEditKitDialog(false)} className="flex-1">
                Cancel
              </Button>
              <Button onClick={handleUpdateKit} className="flex-1 bg-purple-500 hover:bg-purple-600">
                Update Kit
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* View Kit Image Dialog */}
      <Dialog open={kitImageDialog} onOpenChange={setKitImageDialog}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Kit Image - {selectedKit?.kit_name}</DialogTitle>
            <DialogDescription>
              {selectedKit?.student_name} • Issued on {selectedKit?.issue_date && new Date(selectedKit.issue_date).toLocaleDateString()}
            </DialogDescription>
          </DialogHeader>
          
          {selectedKit?.kit_image_base64 && (
            <div className="w-full">
              <img
                src={selectedKit.kit_image_base64}
                alt={selectedKit.kit_name}
                className="w-full h-auto max-h-[70vh] object-contain rounded-lg border"
              />
            </div>
          )}
          
          <Button onClick={() => setKitImageDialog(false)} className="w-full">
            Close
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
